/* HOGG Design Studio — customhoggtumblers.com
 *
 * Theme asset. Shopify's CSP blocks external scripts, so this file lives in the
 * theme (Assets) rather than being served from Railway — same arrangement as
 * quote-app.js. Product data does come from the portal at runtime, so the
 * catalog stays in one place instead of being frozen into the theme.
 *
 * Requires, set in theme.liquid before this file loads:
 *   window.CUSTOMIZER_API_URL  portal origin
 * And a Custom Liquid section on the page containing:
 *   <div id="hogg-customizer"></div>
 */
(function () {
  'use strict';

  var MOUNT_ID = 'hogg-customizer';
  var API = (window.CUSTOMIZER_API_URL || '').replace(/\/$/, '');

  var root = document.getElementById(MOUNT_ID);
  if (!root) return;                       // page doesn't host the customizer

  // ---- styles, scoped to the mount so the theme is left alone -------------
  var style = document.createElement('style');
  style.textContent = '#hogg-customizer{\n  --ground:#F7F8FA; --surface:#FFFFFF; --surface-2:#EFF2F5; --sunken:#E7ECF0;\n  --ink:#101820; --ink-2:#3D4A56; --muted:#5C6A78; --faint:#8A97A3;\n  --line:#DBE2E8; --line-strong:#C2CDD6;\n  --accent:#14566B; --accent-ink:#FFFFFF; --accent-soft:#E3EFF3; --accent-line:#9CC4D0;\n  --good:#2E7D5B; --good-soft:#E4F1EA;\n  --warn:#8F6210; --warn-soft:#FAF0DB;\n  --crit:#A93B33; --crit-soft:#FAE7E5;\n  --shadow:0 1px 2px rgba(16,24,32,.06), 0 6px 20px rgba(16,24,32,.07);\n  --shadow-lg:0 2px 6px rgba(16,24,32,.08), 0 18px 44px rgba(16,24,32,.13);\n  --r:10px; --r-lg:16px;\n  --photo:#FFFFFF;   /* must match the photos\' own background */\n}\n#hogg-customizer, #hogg-customizer *{box-sizing:border-box}\n#hogg-customizer{\n  margin:0; background:var(--ground); color:var(--ink);\n  font-family:"IBM Plex Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;\n  font-size:15px; line-height:1.5; -webkit-font-smoothing:antialiased;\n}\n#hogg-customizer h1, #hogg-customizer h2, #hogg-customizer h3{margin:0; text-wrap:balance}\n#hogg-customizer button{font:inherit; color:inherit}\n#hogg-customizer :focus-visible{outline:2px solid var(--accent); outline-offset:2px; border-radius:4px}\n#hogg-customizer .wrap{max-width:1180px; margin:0 auto; padding:0 20px}\n#hogg-customizer /* ---------- top rail ---------- */\n.topbar{\n  position:sticky; top:0; z-index:40; background:var(--surface);\n  border-bottom:1px solid var(--line);\n}\n#hogg-customizer .topbar-in{display:flex; align-items:center; gap:20px; min-height:60px; flex-wrap:wrap}\n#hogg-customizer .brand{\n  font-family:"Bebas Neue",Impact,sans-serif; font-size:25px; letter-spacing:.055em;\n  line-height:1; display:flex; align-items:baseline; gap:8px; white-space:nowrap;\n}\n#hogg-customizer .brand span{\n  font-family:"IBM Plex Sans",sans-serif; font-size:10px; font-weight:600;\n  letter-spacing:.16em; text-transform:uppercase; color:var(--muted);\n}\n#hogg-customizer .steps{display:flex; align-items:center; gap:5px; margin-left:auto; flex-wrap:wrap}\n#hogg-customizer .stp{\n  display:flex; align-items:center; gap:7px; padding:5px 11px 5px 6px;\n  border-radius:100px; border:1px solid transparent; background:none;\n  cursor:default; color:var(--faint); font-size:12.5px; font-weight:500;\n}\n#hogg-customizer .stp .n{\n  width:20px; height:20px; border-radius:50%; display:grid; place-items:center;\n  background:var(--surface-2); color:var(--faint);\n  font-family:"IBM Plex Mono",monospace; font-size:11px; font-weight:500;\n}\n#hogg-customizer .stp.done{color:var(--muted); cursor:pointer}\n#hogg-customizer .stp.done .n{background:var(--accent-soft); color:var(--accent)}\n#hogg-customizer .stp.done:hover{background:var(--surface-2)}\n#hogg-customizer .stp.now{color:var(--ink); background:var(--accent-soft); border-color:var(--accent-line)}\n#hogg-customizer .stp.now .n{background:var(--accent); color:var(--accent-ink)}\n#hogg-customizer .stp-sep{width:12px; height:1px; background:var(--line-strong); flex:none}\n#hogg-customizer /* ---------- shared ---------- */\n.page{padding:34px 0 90px}\n#hogg-customizer .eyebrow{\n  font-size:11px; font-weight:600; letter-spacing:.15em; text-transform:uppercase;\n  color:var(--accent); margin-bottom:9px;\n}\n#hogg-customizer .h-lg{font-family:"Bebas Neue",Impact,sans-serif; font-size:clamp(30px,2.4vw + 20px,42px); letter-spacing:.02em; line-height:1.04}\n#hogg-customizer .sub{color:var(--muted); margin-top:9px; max-width:62ch}\n#hogg-customizer .head{margin-bottom:26px}\n#hogg-customizer .btn{\n  border:1px solid var(--line-strong); background:var(--surface); color:var(--ink);\n  padding:10px 18px; border-radius:var(--r); font-weight:600; font-size:14px;\n  cursor:pointer; transition:background .15s,border-color .15s;\n}\n#hogg-customizer .btn:hover{background:var(--surface-2)}\n#hogg-customizer .btn.pri{background:var(--accent); border-color:var(--accent); color:var(--accent-ink)}\n#hogg-customizer .btn.pri:hover{filter:brightness(1.09)}\n#hogg-customizer .btn:disabled{opacity:.42; cursor:not-allowed}\n#hogg-customizer .btn.pri:disabled:hover{filter:none}\n#hogg-customizer .hidden{display:none !important}\n#hogg-customizer /* ---------- step 1: method ---------- */\n.methods{display:grid; grid-template-columns:repeat(auto-fit,minmax(300px,1fr)); gap:18px}\n#hogg-customizer .method{\n  position:relative; text-align:left; background:var(--surface);\n  border:1.5px solid var(--line); border-radius:var(--r-lg); padding:0;\n  cursor:pointer; overflow:hidden; transition:border-color .16s, box-shadow .16s, transform .16s;\n  display:flex; flex-direction:column;\n}\n#hogg-customizer .method:hover{border-color:var(--accent-line); box-shadow:var(--shadow-lg); transform:translateY(-2px)}\n#hogg-customizer .method-art{\n  height:172px; background:var(--photo); display:grid; place-items:center;\n  border-bottom:1px solid var(--line); position:relative; overflow:hidden;\n}\n#hogg-customizer .method-art img{height:150px; width:auto; display:block}\n#hogg-customizer .method-body{padding:18px 20px 20px}\n#hogg-customizer .method h3{font-family:"Bebas Neue",Impact,sans-serif; font-size:27px; letter-spacing:.03em; line-height:1}\n#hogg-customizer .method .lede{color:var(--ink-2); margin-top:7px; font-size:14px}\n#hogg-customizer .method ul{margin:13px 0 0; padding:0; list-style:none; display:flex; flex-direction:column; gap:6px}\n#hogg-customizer .method li{font-size:13px; color:var(--muted); display:flex; gap:8px; align-items:flex-start}\n#hogg-customizer .method li::before{content:""; width:5px; height:5px; border-radius:50%; background:var(--accent-line); margin-top:7px; flex:none}\n#hogg-customizer .method .cnt{\n  margin-top:15px; font-family:"IBM Plex Mono",monospace; font-size:11.5px;\n  color:var(--faint); letter-spacing:.02em;\n}\n#hogg-customizer .helper{\n  margin-top:22px; background:var(--accent-soft); border:1px solid var(--accent-line);\n  border-radius:var(--r); padding:14px 17px; font-size:13.5px; color:var(--ink-2);\n  display:flex; gap:11px; align-items:flex-start;\n}\n#hogg-customizer .helper b{color:var(--ink)}\n#hogg-customizer /* ---------- step 2: products ---------- */\n.filters{display:flex; gap:10px; align-items:center; flex-wrap:wrap; margin-bottom:20px}\n#hogg-customizer .search{\n  flex:1; min-width:210px; padding:9px 13px; border-radius:var(--r);\n  border:1px solid var(--line-strong); background:var(--surface); color:var(--ink); font-size:14px;\n}\n#hogg-customizer .search::placeholder{color:var(--faint)}\n#hogg-customizer .chips{display:flex; gap:7px; flex-wrap:wrap}\n#hogg-customizer .chip{\n  padding:6px 13px; border-radius:100px; border:1px solid var(--line-strong);\n  background:var(--surface); font-size:12.5px; font-weight:500; color:var(--muted); cursor:pointer;\n}\n#hogg-customizer .chip:hover{background:var(--surface-2); color:var(--ink)}\n#hogg-customizer .chip.on{background:var(--accent); border-color:var(--accent); color:var(--accent-ink)}\n#hogg-customizer .hc-grid{display:grid; grid-template-columns:repeat(auto-fill,minmax(196px,1fr)); gap:16px}\n#hogg-customizer .hc-card{\n  background:var(--surface); border:1.5px solid var(--line); border-radius:var(--r-lg);\n  overflow:hidden; cursor:pointer; text-align:left; padding:0; display:flex; flex-direction:column;\n  transition:border-color .16s, box-shadow .16s, transform .16s;\n}\n#hogg-customizer .hc-card:hover{border-color:var(--accent-line); box-shadow:var(--shadow-lg); transform:translateY(-2px)}\n#hogg-customizer .card-art{\n  height:206px; background:var(--photo); display:grid; place-items:center;\n  position:relative; border-bottom:1px solid var(--line);\n}\n#hogg-customizer .card-shot{position:relative; width:100%; height:100%; overflow:hidden; display:grid; place-items:center}\n#hogg-customizer .card-shot img{max-height:164px; max-width:80%; width:auto; display:block}\n#hogg-customizer .card-body{padding:12px 14px 14px; display:flex; flex-direction:column; gap:4px; flex:1}\n#hogg-customizer .card-title{font-weight:600; font-size:13.5px; line-height:1.32}\n#hogg-customizer .tag-row{display:flex; gap:5px; flex-wrap:wrap; margin-top:3px}\n#hogg-customizer .pack-tag{\n  align-self:flex-start; font-family:"IBM Plex Mono",monospace; font-size:10px;\n  letter-spacing:.03em; color:var(--accent); background:var(--accent-soft);\n  border:1px solid var(--accent-line); border-radius:100px; padding:1px 7px;\n}\n#hogg-customizer .card-meta{\n  margin-top:auto; padding-top:8px; display:flex; align-items:center;\n  justify-content:space-between; gap:8px;\n}\n#hogg-customizer .price{font-family:"IBM Plex Mono",monospace; font-size:12.5px; color:var(--muted)}\n#hogg-customizer .price b{color:var(--ink); font-weight:500}\n#hogg-customizer .swatch-row{display:flex; align-items:center; gap:3px}\n#hogg-customizer .sw-dot{width:11px; height:11px; border-radius:50%; border:1px solid rgba(0,0,0,.22); flex:none}\n#hogg-customizer .sw-more{font-family:"IBM Plex Mono",monospace; font-size:10.5px; color:var(--faint); margin-left:2px}\n#hogg-customizer .empty{padding:52px 0; text-align:center; color:var(--muted)}\n#hogg-customizer /* ---------- step 3: studio ---------- */\n.studio{display:grid; grid-template-columns:minmax(0,1fr) 372px; gap:26px; align-items:start}\n@media(max-width:940px){\n#hogg-customizer .studio{grid-template-columns:1fr}\n}\n#hogg-customizer .stage-col{position:sticky; top:82px}\n@media(max-width:940px){\n#hogg-customizer .stage-col{position:static}\n}\n#hogg-customizer .stage{\n  background:var(--photo); border:1px solid var(--line); border-radius:var(--r-lg);\n  padding:22px; display:grid; place-items:center; min-height:456px; position:relative;\n  overflow:hidden;\n}\n#hogg-customizer .stage-bg{ display:none; }\n#hogg-customizer .wrap-stage{padding:18px 14px}\n#hogg-customizer .views{display:flex; gap:26px; align-items:flex-end; justify-content:center}\n#hogg-customizer .view{display:flex; flex-direction:column; align-items:center; gap:9px}\n#hogg-customizer .vlab{font-family:"IBM Plex Mono",monospace; font-size:10.5px; letter-spacing:.04em; color:var(--faint); text-transform:uppercase}\n#hogg-customizer .mock.sm > img.base{height:352px}\n@media(max-width:940px){\n#hogg-customizer .mock.sm > img.base{height:266px}\n}\n@media(max-width:560px){\n#hogg-customizer .views{flex-wrap:wrap}\n}\n#hogg-customizer /* the plate is flat white; a gradient would seam */\n.mock{position:relative; display:inline-block; user-select:none; touch-action:none}\n#hogg-customizer .mock > img.base{display:block; height:412px; width:auto; pointer-events:none}\n#hogg-customizer /* the printable region overlay */\n.area{position:absolute; pointer-events:none}\n#hogg-customizer .area.show{\n  outline:1.5px dashed var(--accent-line); outline-offset:0;\n  background:color-mix(in srgb, var(--accent) 6%, transparent);\n}\n#hogg-customizer .area-tag{\n  position:absolute; top:calc(100% + 6px); left:50%;\n  transform:translateX(-50%) scale(calc(1 / var(--zk, 1))); transform-origin:50% 0;\n  background:var(--accent); color:var(--accent-ink); font-family:"IBM Plex Mono",monospace;\n  font-size:9.5px; padding:2px 7px; border-radius:100px; white-space:nowrap; letter-spacing:.02em;\n}\n#hogg-customizer /* clipping frame for placed art */\n.clip{position:absolute; overflow:hidden}\n#hogg-customizer .art{\n  position:absolute; transform-origin:center center; cursor:grab;\n  pointer-events:auto; will-change:transform;\n}\n#hogg-customizer .art.dragging{cursor:grabbing}\n#hogg-customizer .art img{display:block; width:100%; height:100%; pointer-events:none}\n#hogg-customizer .art .txt{\n  white-space:pre; line-height:1.1; text-align:center; pointer-events:none;\n  display:grid; place-items:center; width:100%; height:100%;\n}\n#hogg-customizer .art-ring{\n  position:absolute; inset:-2px; border:1.5px solid var(--accent);\n  border-radius:2px; pointer-events:none; opacity:0;\n}\n#hogg-customizer .art.sel .art-ring{opacity:1}\n#hogg-customizer .enhance{\n  position:absolute; inset:0; display:grid; place-items:center; gap:10px;\n  background:color-mix(in srgb, var(--photo) 78%, transparent); z-index:5;\n  align-content:center; font-size:12.5px; color:var(--ink-2);\n}\n#hogg-customizer .enhance .ring{\n  width:34px; height:34px; border-radius:50%; border:3px solid var(--accent-soft);\n  border-top-color:var(--accent); animation:hgspin .8s linear infinite;\n}\n@keyframes hgspin{to{transform:rotate(360deg)}}\n#hogg-customizer .enhance b{font-weight:600; color:var(--ink)}\n#hogg-customizer .qbar{margin-top:12px}\n#hogg-customizer .qbar .head{display:flex; justify-content:space-between; align-items:baseline; gap:8px; margin-bottom:7px}\n#hogg-customizer .qbar .head .t{font-size:12px; font-weight:600; color:var(--ink-2)}\n#hogg-customizer .qbar .head .lab{font-size:12px; font-weight:700}\n#hogg-customizer .qbar .scale{position:relative; display:flex; gap:2px; height:8px; margin-bottom:5px}\n#hogg-customizer .qbar .seg{border-radius:2px; opacity:.30}\n#hogg-customizer .qbar .seg.on{opacity:1}\n#hogg-customizer .qbar .pin{position:absolute; top:-4px; width:3px; height:16px; border-radius:2px; background:var(--ink); transform:translateX(-1.5px)}\n#hogg-customizer .qbar .ticks{display:flex; font-size:10px; color:var(--faint); font-family:\"IBM Plex Mono\",monospace}\n#hogg-customizer .qbar .ticks span{text-align:center}\n#hogg-customizer .mock-vp{display:grid; place-items:center; overflow:hidden; width:100%; height:100%}\n#hogg-customizer .stage.zoomed{align-content:center}\n#hogg-customizer .stage.zoomed .mock > img.base{transition:none}\n#hogg-customizer .guide{position:absolute; background:var(--accent-line); opacity:.5; pointer-events:none}\n#hogg-customizer .guide.v{left:50%; top:0; bottom:0; width:1px}\n#hogg-customizer .guide.h{top:50%; left:0; right:0; height:1px}\n#hogg-customizer /* selection chrome — outside .clip, which would slice it */\n.frame{position:absolute; pointer-events:none}\n#hogg-customizer .frame-ring{position:absolute; inset:0; border:1.5px solid var(--accent); pointer-events:none}\n#hogg-customizer .hnd{\n  position:absolute; width:26px; height:26px; padding:0; border-radius:50%;\n  border:2px solid var(--surface); background:var(--accent); color:var(--accent-ink);\n  font-size:13px; line-height:1; display:grid; place-items:center; cursor:pointer;\n  pointer-events:auto; touch-action:none; box-shadow:var(--shadow);\n}\n#hogg-customizer .hnd.tl{left:0; top:0; transform:translate(-50%,-50%)}\n#hogg-customizer .hnd.tr{right:0; top:0; transform:translate(50%,-50%); background:var(--crit)}\n#hogg-customizer .hnd.bl{\n  left:0; bottom:0; transform:translate(-50%,50%); border-radius:5px;\n  width:22px; height:22px; background:var(--surface); border:2px solid var(--accent);\n  cursor:move;\n}\n#hogg-customizer .hnd.br{right:0; bottom:0; transform:translate(50%,50%); cursor:nwse-resize}\n#hogg-customizer .hnd.br::after{content:\"\\2921\"; font-size:14px}\n#hogg-customizer .hnd.tl{cursor:grab}\n#hogg-customizer .hnd.tl::after{content:\"\\21BB\"; font-size:15px}\n#hogg-customizer .hnd.tl:active{cursor:grabbing}\n\n#hogg-customizer .hnd:hover{filter:brightness(1.1)}\n#hogg-customizer .art{cursor:move}\n#hogg-customizer .addgrid{display:grid; grid-template-columns:1fr 1fr; gap:8px; margin-bottom:14px}\n#hogg-customizer .addbtn{\n  text-align:left; padding:10px 12px; border-radius:var(--r); cursor:pointer;\n  border:1.5px solid var(--line-strong); background:var(--surface);\n}\n#hogg-customizer .addbtn:hover{border-color:var(--accent); background:var(--accent-soft)}\n#hogg-customizer .addbtn b{display:block; font-size:13px; font-weight:600}\n#hogg-customizer .addbtn em{display:block; font-style:normal; font-size:11.5px; color:var(--muted)}\n#hogg-customizer .layers{display:flex; flex-direction:column; gap:6px}\n#hogg-customizer .lrow{\n  display:flex; align-items:center; gap:10px; padding:7px 9px; cursor:pointer;\n  background:var(--sunken); border:1.5px solid transparent; border-radius:var(--r);\n}\n#hogg-customizer .lrow:hover{border-color:var(--line-strong)}\n#hogg-customizer .lrow.on{border-color:var(--accent); background:var(--accent-soft)}\n#hogg-customizer .lrow .thumb{\n  width:40px; height:40px; border-radius:6px; background:var(--photo);\n  border:1px solid var(--line); object-fit:contain; flex:none;\n}\n#hogg-customizer /* cylinder shading over sublimation wraps */\n.cyl{\n  position:absolute; pointer-events:none;\n  background:linear-gradient(90deg,\n    rgba(0,0,0,.50) 0%, rgba(0,0,0,.22) 7%, rgba(0,0,0,0) 18%,\n    rgba(0,0,0,0) 82%, rgba(0,0,0,.22) 93%, rgba(0,0,0,.50) 100%);\n  mix-blend-mode:overlay;\n}\n#hogg-customizer .stage-foot{\n  display:flex; justify-content:space-between; align-items:center; gap:12px;\n  margin-top:12px; font-size:12.5px; color:var(--muted); flex-wrap:wrap;\n}\n#hogg-customizer .toggle{display:flex; align-items:center; gap:7px; cursor:pointer; user-select:none}\n#hogg-customizer .toggle input{accent-color:var(--accent); width:14px; height:14px}\n#hogg-customizer /* control panel */\n.panel{\n  background:var(--surface); border:1px solid var(--line); border-radius:var(--r-lg);\n  overflow:hidden;\n}\n#hogg-customizer .panel-hd{\n  padding:15px 18px; border-bottom:1px solid var(--line); background:var(--surface-2);\n}\n#hogg-customizer .panel-hd .t{font-weight:700; font-size:14.5px; line-height:1.3}\n#hogg-customizer .panel-hd .s{font-family:"IBM Plex Mono",monospace; font-size:11px; color:var(--muted); margin-top:3px}\n#hogg-customizer .sect{padding:16px 18px; border-bottom:1px solid var(--line)}\n#hogg-customizer .sect:last-child{border-bottom:none}\n#hogg-customizer .sect-t{\n  font-size:11px; font-weight:600; letter-spacing:.13em; text-transform:uppercase;\n  color:var(--muted); margin-bottom:11px; display:flex; justify-content:space-between; align-items:baseline; gap:8px;\n}\n#hogg-customizer .sect-t em{font-style:normal; font-family:"IBM Plex Mono",monospace; letter-spacing:0; text-transform:none; color:var(--faint); font-weight:400; font-size:11px}\n#hogg-customizer .sizes{display:flex; gap:9px; flex-wrap:wrap}\n#hogg-customizer .size-btn{\n  flex:1; min-width:96px; display:flex; flex-direction:column; gap:2px; align-items:flex-start;\n  padding:10px 13px; border-radius:var(--r); border:1.5px solid var(--line-strong);\n  background:var(--surface); cursor:pointer; transition:border-color .15s, background .15s;\n}\n#hogg-customizer .size-btn:hover{border-color:var(--accent-line); background:var(--surface-2)}\n#hogg-customizer .size-btn.on{border-color:var(--accent); background:var(--accent-soft)}\n#hogg-customizer .size-btn .sz{font-family:"Bebas Neue",Impact,sans-serif; font-size:21px; letter-spacing:.03em; line-height:1}\n#hogg-customizer .size-btn .szp{font-family:"IBM Plex Mono",monospace; font-size:11.5px; color:var(--muted)}\n#hogg-customizer .size-btn.on .szp{color:var(--accent)}\n#hogg-customizer .fx-row{\n  display:flex; gap:9px; align-items:flex-start; padding:6px 0; cursor:pointer;\n}\n#hogg-customizer .fx-row input{accent-color:var(--accent); width:15px; height:15px; margin-top:2px; flex:none}\n#hogg-customizer .fx-row b{font-weight:600; font-size:13px; display:block}\n#hogg-customizer .fx-row em{font-style:normal; font-size:11.5px; color:var(--muted); display:block}\n#hogg-customizer .two-side{align-items:center; margin-bottom:10px}\n#hogg-customizer .two-side > span:nth-child(2){flex:1}\n#hogg-customizer .two-side-price{font-family:"IBM Plex Mono",monospace; font-size:12.5px; font-weight:600; color:var(--accent)}\n#hogg-customizer .view.on .vlab{color:var(--accent); font-weight:600}\n#hogg-customizer .sub-stage{display:flex; flex-direction:column; align-items:stretch; gap:18px; padding:18px}\n#hogg-customizer .sbx-wrap{display:flex; flex-direction:column; align-items:center; gap:8px}\n#hogg-customizer .sbx-hd{display:flex; gap:10px; align-items:baseline; font-size:12.5px; color:var(--muted); flex-wrap:wrap; justify-content:center}\n#hogg-customizer .sbx-hd b{color:var(--ink); font-weight:600}\n#hogg-customizer .mock.sbx{display:block; background:#FFFFFF; outline:1.5px solid var(--line-strong); box-shadow:var(--shadow)}\n#hogg-customizer .hzone{position:absolute; top:0; bottom:0; pointer-events:none; display:flex; align-items:center; justify-content:center;\n  background:repeating-linear-gradient(135deg, rgba(20,86,107,.10) 0 6px, rgba(20,86,107,.03) 6px 12px)}\n#hogg-customizer .hzone.l{left:0; border-right:1px dashed var(--accent-line)}\n#hogg-customizer .hzone.r{right:0; border-left:1px dashed var(--accent-line)}\n#hogg-customizer .hzone span{writing-mode:vertical-rl; font-family:\"IBM Plex Mono\",monospace; font-size:9.5px; letter-spacing:.08em; text-transform:uppercase; color:var(--accent)}\n#hogg-customizer .seam{position:absolute; top:-7px; bottom:-7px; width:0; border-left:1.5px dashed var(--faint); pointer-events:none}\n#hogg-customizer .seam.l{left:0} #hogg-customizer .seam.r{right:0}\n#hogg-customizer .tviews{gap:26px; flex-wrap:nowrap}\n#hogg-customizer .mock.tv{pointer-events:none}\n#hogg-customizer .mock.tv > img.base{height:290px}\n#hogg-customizer .tvp{position:absolute; mix-blend-mode:multiply; isolation:isolate; pointer-events:none}\n#hogg-customizer .tvp > *{position:absolute; inset:0; width:100%; height:100%}\n#hogg-customizer .tvc{background:#FFFFFF}\n#hogg-customizer .hnd{width:18px; height:18px; font-size:10px; border-width:1.5px; opacity:.72; box-shadow:0 1px 3px rgba(16,24,32,.25)}\n#hogg-customizer .hnd:hover{opacity:1}\n#hogg-customizer .hnd.bl{width:15px; height:15px}\n#hogg-customizer .hnd.br::after{font-size:10px}\n#hogg-customizer .hnd.tl::after{font-size:11px}\n#hogg-customizer .frame-ring{border-width:1px; opacity:.8}\n#hogg-customizer .hnd.tl{transform:translate(-100%,-100%)}\n#hogg-customizer .hnd.tr{transform:translate(100%,-100%)}\n#hogg-customizer .hnd.bl{transform:translate(-100%,100%)}\n#hogg-customizer .hnd.br{transform:translate(100%,100%)}\n#hogg-customizer .lrow .row-in{background:#FFFFFF; border:1.5px solid var(--line-strong); cursor:text}\n#hogg-customizer .lrow .row-in:hover{border-color:var(--accent-line)}\n#hogg-customizer .lrow .row-in:focus{outline:none; border-color:var(--accent); box-shadow:0 0 0 3px var(--accent-soft)}\n#hogg-customizer .uv-stage .vlab{display:flex; flex-direction:column; align-items:center; gap:2px}\n#hogg-customizer .vlab-ed{font-style:normal; font-size:9.5px; letter-spacing:.06em; color:var(--accent)}\n#hogg-customizer .side-sw{display:inline-flex; border:1px solid var(--line-strong); border-radius:999px; overflow:hidden; background:var(--surface)}\n#hogg-customizer .side-sw button{border:0; background:transparent; padding:3px 11px; font-size:12px; font-weight:600; color:var(--muted); cursor:pointer}\n#hogg-customizer .side-sw button.on{background:var(--accent); color:var(--accent-ink)}\n#hogg-customizer .lrow.has-side{flex-wrap:wrap}\n#hogg-customizer .row-side{flex-basis:100%; display:flex; align-items:center; gap:8px; font-size:12px; color:var(--muted); padding:6px 2px 0}\n#hogg-customizer .add-side{display:flex; align-items:center; gap:8px; font-size:12.5px; color:var(--ink-2); font-weight:600; margin-bottom:10px}\n#hogg-customizer .method .method-how{font-style:italic; margin-top:12px; font-size:13.5px; color:var(--muted)}\n#hogg-customizer .add-row .add-price{margin-left:auto}\n#hogg-customizer .uv-stage .views{gap:10px; flex-wrap:nowrap}\n#hogg-customizer .uv-stage .mock > img.base{height:540px}\n@media (max-width:700px){#hogg-customizer .uv-stage .mock > img.base{height:360px}}\n#hogg-customizer .method.has-hero{flex-direction:row; align-items:center}\n#hogg-customizer .method-art.hero{flex:0 0 36%; height:auto; aspect-ratio:1 / 1; align-self:center; margin:14px 0 14px 14px; border:1px solid var(--line); border-radius:var(--r); background:#FFFFFF}\n#hogg-customizer .method-art.hero img{width:100%; height:100%; object-fit:cover}\n#hogg-customizer .method.has-hero .method-body{flex:1; min-width:0; padding:16px 18px}\n#hogg-customizer .card-art{position:relative}\n#hogg-customizer .card-info{position:absolute; top:8px; right:8px; display:inline-flex; align-items:center; gap:5px; padding:4px 9px 4px 5px; border-radius:999px; background:rgba(255,255,255,.94); border:1px solid var(--line-strong); font-size:12px; font-weight:600; color:var(--ink-2); cursor:pointer}\n#hogg-customizer .card-info:hover{border-color:var(--accent); color:var(--accent)}\n#hogg-customizer .card-info .ci-i{width:16px; height:16px; border-radius:50%; background:var(--accent); color:#fff; display:grid; place-items:center; font:italic 700 11px/1 Georgia,serif}\n#hogg-customizer .pd-link{font-size:13px; margin-top:2px}\n#hogg-customizer .pd-card{position:relative; background:var(--surface); border-radius:var(--r-lg); box-shadow:0 24px 70px rgba(16,24,32,.35); width:min(520px,100%); max-height:calc(100vh - 32px); overflow:auto}\n#hogg-customizer .pd-close{position:absolute; top:10px; right:10px; z-index:2; width:34px; height:34px; border-radius:50%; border:1px solid var(--line); background:rgba(255,255,255,.95); cursor:pointer; font-size:15px}\n#hogg-customizer .pd-slider{position:relative; overflow:hidden; background:#FFFFFF; border-radius:var(--r-lg) var(--r-lg) 0 0}\n#hogg-customizer .pd-track{display:flex; transition:transform .3s ease}\n#hogg-customizer .pd-track img{flex:0 0 100%; width:100%; aspect-ratio:1/1; object-fit:contain; display:block; user-select:none}\n#hogg-customizer .pd-arrow{position:absolute; top:50%; transform:translateY(-50%); width:36px; height:36px; border-radius:50%; border:1px solid var(--line); background:rgba(255,255,255,.92); font-size:22px; line-height:1; cursor:pointer; color:var(--ink)}\n#hogg-customizer .pd-arrow.prev{left:10px}\n#hogg-customizer .pd-arrow.next{right:10px}\n#hogg-customizer .pd-dots{position:absolute; bottom:10px; left:0; right:0; display:flex; justify-content:center; gap:6px}\n#hogg-customizer .pd-dot{width:7px; height:7px; border-radius:50%; background:var(--line-strong)}\n#hogg-customizer .pd-dot.on{background:var(--accent)}\n#hogg-customizer .pd-body{padding:16px 20px 20px}\n#hogg-customizer .pd-name{font-size:19px; font-weight:650; margin:0 0 4px; font-family:inherit}\n#hogg-customizer .pd-tag{margin:0 0 12px; color:var(--muted); font-size:14px}\n#hogg-customizer .pd-specs{width:100%; border-collapse:collapse; font-size:14px; margin:6px 0 4px}\n#hogg-customizer .pd-specs td{padding:7px 0; border-top:1px solid var(--line); vertical-align:top}\n#hogg-customizer .pd-specs td.k{width:38%; color:var(--muted); font-weight:600}\n#hogg-customizer .pd-details{font-size:14px; color:var(--ink-2); margin-top:10px}\n#hogg-customizer .pd-details p{margin:0 0 8px}\n#hogg-customizer .pd-details ul{margin:0 0 8px; padding-left:18px}\n#hogg-customizer .band-row{margin-top:18px; align-items:center; white-space:nowrap}\n#hogg-customizer .band-row .two-side-price{margin-left:auto}\n#hogg-customizer .left-bar{display:flex; align-items:center; gap:12px; margin:0 0 18px; padding:10px 14px; background:var(--accent-soft); border:1px solid var(--accent-line); border-radius:var(--r)}\n#hogg-customizer .left-bar span{color:var(--ink-2); font-size:14px}\n#hogg-customizer .cyl-shade, #hogg-customizer .cyl-gloss{pointer-events:none}\n#hogg-customizer .cyl-shade{mix-blend-mode:overlay}\n#hogg-customizer .cyl-gloss{mix-blend-mode:screen}\n#hogg-customizer .tvc{display:block}\n/* The store theme hides every childless div (div:empty{display:none}), and several of ours are\n   empty on purpose — the selection ring, the cylinder shading, the spinner. Put them back. */\n#hogg-customizer div:empty:not(.stage-bg):not(.hidden){display:block}\n#hogg-customizer .sbx-bg{position:absolute; inset:0; width:100%; height:100%; pointer-events:none}\n#hogg-customizer .guide.on{background:var(--accent); opacity:1}\n#hogg-customizer .sub-stage{position:relative}\n#hogg-customizer .stage.is-empty > :not(.empty-ov){opacity:.16; filter:grayscale(1) blur(1px); pointer-events:none}\n#hogg-customizer .stage.is-empty{background:var(--sunken)}\n#hogg-customizer .empty-ov{position:absolute; inset:0; display:grid; place-items:center; pointer-events:none}\n#hogg-customizer .empty-ov > div{background:var(--surface); border:1px solid var(--line); border-radius:var(--r); box-shadow:var(--shadow); padding:14px 20px; text-align:center; display:flex; flex-direction:column; gap:3px}\n#hogg-customizer .empty-ov b{font-size:15px}\n#hogg-customizer .empty-ov span{font-size:12.5px; color:var(--muted)}\n#hogg-customizer .tpl-box{margin-bottom:4px}\n#hogg-customizer .chip-scratch{border-style:dashed}\n#hogg-customizer .color-row{align-items:center}\n#hogg-customizer .sw-wheel{position:relative; overflow:hidden; cursor:pointer; background:conic-gradient(#f00,#ff0,#0f0,#0ff,#00f,#f0f,#f00)}\n#hogg-customizer .sw-wheel.on{box-shadow:inset 0 0 0 5px var(--cur, transparent)}\n#hogg-customizer .sw-wheel input{position:absolute; inset:0; opacity:0; cursor:pointer; width:100%; height:100%; border:0; padding:0}\n#hogg-customizer .upbtn{display:flex; gap:10px; align-items:center; text-align:left; padding:11px 12px; border-radius:10px; border:1.5px dashed var(--accent-line); background:var(--accent-soft); cursor:pointer}\n#hogg-customizer .upbtn:hover{border-color:var(--accent)}\n#hogg-customizer .upbtn b{display:block; font-size:13px; font-weight:600; color:var(--ink)}\n#hogg-customizer .upbtn em{display:block; font-style:normal; font-size:11px; color:var(--muted)}\n#hogg-customizer .up-ic{flex:none; width:28px; height:28px; border-radius:50%; display:grid; place-items:center; background:var(--accent); color:var(--accent-ink); font-weight:700; font-size:15px}\n#hogg-customizer .lrow.add-row{width:100%; justify-content:flex-start; gap:10px; border:1.5px dashed var(--line-strong); background:transparent; font:inherit; font-size:13.5px; font-weight:600; color:var(--ink-2); cursor:pointer}\n#hogg-customizer .lrow.add-row:hover, #hogg-customizer .lrow.add-row.open{border-color:var(--accent); color:var(--accent)}\n#hogg-customizer .add-row .plus{width:28px; height:28px; border-radius:50%; display:grid; place-items:center; background:var(--surface-2); font-size:17px}\n#hogg-customizer .addbox{margin-top:8px}\n#hogg-customizer .addgrid.three{grid-template-columns:1fr 1fr 1fr; margin-top:8px}\n#hogg-customizer .addgrid.three .addbtn{text-align:center; padding:10px 6px}\n#hogg-customizer .lrow > .fmeta{flex:1; min-width:0}\n#hogg-customizer .row-act{flex:none; display:inline-flex; align-items:center; gap:5px; padding:4px 10px; border-radius:100px; border:1px solid var(--accent-line); background:var(--surface); color:var(--accent); font-size:11.5px; font-weight:600; cursor:pointer; white-space:nowrap}\n#hogg-customizer .row-act:hover{background:var(--accent); color:var(--accent-ink)}\n#hogg-customizer .lrow.open{flex-wrap:wrap; row-gap:8px; cursor:default}\n#hogg-customizer .row-ed{flex:1 1 100%; padding:8px 2px 2px; border-top:1px solid var(--line); cursor:auto}\n#hogg-customizer .row-ed > div > :first-child{margin-top:0}\n#hogg-customizer .add-sect{border:1.5px dashed var(--accent); border-radius:var(--r); padding:0 10px 10px}\n#hogg-customizer .add-sect > .lrow.add-row{border:0; padding-left:0; padding-right:0}\n#hogg-customizer .add-sect .addbox{margin-top:2px}\n#hogg-customizer .tpl-opts{margin-top:14px; padding-top:12px; border-top:1px solid var(--line); display:flex; flex-direction:column; gap:6px}\n#hogg-customizer .tpl-opts .panel-label{margin:4px 0 0}\n#hogg-customizer .logo-card{width:340px}\n#hogg-customizer .logo-card .fx-row{margin:0}\n#hogg-customizer .crop-stage.logo-prev{height:200px; background-color:#fff; background-image:linear-gradient(45deg,#E3E7EB 25%,transparent 25%,transparent 75%,#E3E7EB 75%),linear-gradient(45deg,#E3E7EB 25%,transparent 25%,transparent 75%,#E3E7EB 75%); background-size:16px 16px; background-position:0 0,8px 8px}\n#hogg-customizer .logo-prev img{max-width:100%; max-height:188px; object-fit:contain}\n#hogg-customizer .logo-busy{font-size:13px; font-weight:600; color:var(--muted)}\n#hogg-customizer .qmini{display:flex; flex-direction:column; gap:3px; min-width:0}\n#hogg-customizer .qmini .qline{display:flex; align-items:baseline; justify-content:space-between; gap:6px}\n#hogg-customizer .qmini .t{font-size:10.5px; font-weight:600; color:var(--muted); white-space:nowrap; overflow:hidden; text-overflow:ellipsis; letter-spacing:.01em}\n#hogg-customizer .qmini .scale{position:relative; display:flex; gap:2px; height:6px; margin-top:2px}\n#hogg-customizer .qmini .seg{border-radius:2px; opacity:.28}\n#hogg-customizer .qmini .seg.on{opacity:1}\n#hogg-customizer .qmini .pin{position:absolute; top:-3px; width:3px; height:12px; border-radius:2px; background:var(--ink); transform:translateX(-1.5px)}\n#hogg-customizer .qmini .lab{font-size:11.5px; font-weight:700; white-space:nowrap}\n#hogg-customizer .lrow{min-height:58px; gap:8px; padding-left:8px; padding-right:6px}\n#hogg-customizer .row-mid{flex:1; min-width:0; display:flex; align-items:center}\n#hogg-customizer .row-mid > .row-in, #hogg-customizer .row-mid > .row-pair, #hogg-customizer .row-mid > .qmini{flex:1}\n#hogg-customizer .row-hint{font-size:12.5px; color:var(--muted); white-space:nowrap; overflow:hidden; text-overflow:ellipsis}\n#hogg-customizer .edit-btn{flex:none; display:inline-flex; align-items:center; gap:5px; padding:5px 11px; border-radius:100px; border:1px solid var(--accent-line); background:var(--surface); color:var(--accent); font-size:12px; font-weight:600; cursor:pointer; white-space:nowrap}\n#hogg-customizer .edit-btn .ic{display:inline-flex; line-height:1}\n#hogg-customizer .edit-btn:hover, #hogg-customizer .lrow.open > .edit-btn{background:var(--accent); color:var(--accent-ink); border-color:var(--accent)}\n#hogg-customizer .edit-btn.add{background:var(--accent); color:var(--accent-ink); border-color:var(--accent)}\n#hogg-customizer .edit-btn.add .ic{font-size:14px; font-weight:700}\n#hogg-customizer .thumb-empty{display:grid; place-items:center; border:1.5px dashed var(--line-strong) !important; background:transparent !important; color:var(--faint); font-size:18px}\n#hogg-customizer .te{display:flex; flex-direction:column; gap:8px}\n#hogg-customizer .te-line{display:flex; align-items:center; gap:12px; min-width:0}\n#hogg-customizer .te-lab{display:flex; align-items:center; gap:7px; font-size:11.5px; font-weight:600; color:var(--muted); white-space:nowrap; margin:0}\n#hogg-customizer .te-lab select{width:118px; padding:4px 6px; border-radius:7px; border:1px solid var(--line-strong); background:var(--surface); color:var(--ink); font-size:12.5px; font-weight:500}\n#hogg-customizer .te-check{gap:6px; color:var(--ink-2); cursor:pointer}\n#hogg-customizer .te-check input{width:15px; height:15px; margin:0; accent-color:var(--accent)}\n#hogg-customizer .te-curve-row{gap:8px}\n#hogg-customizer .te-curve-row input{flex:1; min-width:0; accent-color:var(--accent)}\n#hogg-customizer .te-end{font-size:11px; font-weight:600; color:var(--muted)}\n#hogg-customizer .te-curve-row em{font-style:normal; font-family:\"IBM Plex Mono\",monospace; font-size:10.5px; color:var(--ink-2); min-width:54px; text-align:right}\n#hogg-customizer .te-ink .swatches{gap:6px; flex:1}\n#hogg-customizer .te-ink .sw-sm{width:22px; height:22px}\n#hogg-customizer .rev-shot{position:relative; background:var(--photo); border:1px solid var(--line); border-radius:var(--r); overflow:hidden; display:grid; place-items:center; padding:14px}\n#hogg-customizer .rev-shot img{display:block; width:100%; height:auto; max-height:460px; object-fit:contain}\n#hogg-customizer .rev-expand{position:absolute; top:10px; right:10px; width:34px; height:34px; border-radius:8px; border:1px solid var(--line-strong); background:rgba(255,255,255,.92); color:var(--ink-2); display:grid; place-items:center; cursor:pointer; box-shadow:var(--shadow)}\n#hogg-customizer .rev-expand:hover{background:var(--accent); color:var(--accent-ink); border-color:var(--accent)}\n#hogg-customizer .lightbox{cursor:zoom-out; background:rgba(16,24,32,.82)}\n#hogg-customizer .lightbox img{max-width:min(96vw,1600px); max-height:90vh; background:#fff; border-radius:12px; box-shadow:0 24px 70px rgba(0,0,0,.4)}\n#hogg-customizer .lb-close{position:fixed; top:16px; right:18px; width:40px; height:40px; border-radius:50%; border:0; background:rgba(255,255,255,.95); color:var(--ink); font-size:18px; cursor:pointer}\n#hogg-customizer a.btn{display:inline-block; text-decoration:none}\n#hogg-customizer .pet-grid{display:grid; grid-template-columns:1fr 1fr; gap:6px; margin-bottom:12px}\n#hogg-customizer .pet-opt{text-align:left; padding:8px 10px; border-radius:8px; border:1px solid var(--line-strong); background:var(--surface); cursor:pointer}\n#hogg-customizer .pet-opt b{display:block; font-size:13px; font-weight:600}\n#hogg-customizer .pet-opt span{display:block; font-size:11px; color:var(--muted); line-height:1.3}\n#hogg-customizer .pet-opt.on{border-color:var(--accent); background:var(--accent-soft)}\n#hogg-customizer .pet-name{display:flex; flex-direction:column; gap:4px; margin:10px 0 12px; font-size:12px; font-weight:600; color:var(--ink-2)}\n#hogg-customizer .pet-name input{padding:8px 10px; border-radius:8px; border:1px solid var(--line-strong); font-size:14px; font-weight:400}\n#hogg-customizer .row-x{flex:none; width:28px; height:28px; border-radius:50%; border:0; background:transparent; color:var(--faint); opacity:.55; font-size:14px; cursor:pointer; transition:opacity .12s}\n#hogg-customizer .lrow:hover .row-x, #hogg-customizer .lrow.on .row-x, #hogg-customizer .row-x:focus-visible{opacity:1}\n#hogg-customizer .row-x:hover{background:var(--crit-soft); color:var(--crit)}\n#hogg-customizer .stage{padding-bottom:56px}\n#hogg-customizer .draft-banner{display:flex; align-items:center; justify-content:space-between; gap:14px; flex-wrap:wrap; margin:18px 0 10px; padding:14px 16px; border-radius:var(--r); background:var(--accent-soft); border:1px solid var(--accent-line)}\n#hogg-customizer .draft-banner b{font-size:15px}\n#hogg-customizer .draft-banner span{font-size:13px; color:var(--ink-2)}\n#hogg-customizer .draft-btns{display:flex; gap:8px}\n#hogg-customizer .crop-ov{position:fixed; inset:0; z-index:2147483000; background:rgba(16,24,32,.55); display:grid; place-items:center; padding:16px; overflow:auto; overscroll-behavior:contain}\n#hogg-customizer .crop-card{background:var(--surface); border:1px solid var(--line); border-radius:var(--r-lg); box-shadow:0 24px 70px rgba(16,24,32,.35); padding:16px; max-height:calc(100vh - 32px); overflow:auto; display:flex; flex-direction:column; gap:12px; align-items:stretch; max-width:100%}\n#hogg-customizer .crop-hd{display:flex; flex-direction:column; gap:2px}\n#hogg-customizer .crop-hd b{font-size:15px}\n#hogg-customizer .crop-hd span{font-size:12.5px; color:var(--muted)}\n#hogg-customizer .crop-stage{display:grid; place-items:center; background:var(--surface-2); border-radius:var(--r); padding:6px; overflow:hidden}\n#hogg-customizer .crop-cv{touch-action:none; cursor:grab; max-width:100%; height:auto}\n#hogg-customizer .crop-zoom{display:flex; align-items:center; gap:10px; font-size:12.5px; font-weight:600; color:var(--ink-2)}\n#hogg-customizer .crop-zoom input{flex:1}\n#hogg-customizer .crop-btns{display:flex; justify-content:flex-end; gap:8px}\n#hogg-customizer .hist{position:absolute; right:12px; bottom:12px; display:flex; gap:6px; z-index:5}\n#hogg-customizer .hist-btn{padding:6px 11px; border-radius:100px; border:1px solid var(--line-strong); background:var(--surface); font-size:12px; font-weight:600; color:var(--ink-2); cursor:pointer; box-shadow:var(--shadow)}\n#hogg-customizer .hist-btn:disabled{opacity:.4; cursor:default}\n#hogg-customizer .lrow .row-in{flex:1; min-width:0; padding:7px 10px; border-radius:7px; border:1px solid var(--line-strong); background:var(--surface); font-size:13.5px; color:var(--ink)}\n#hogg-customizer .row-pair{flex:1; display:flex; gap:6px; min-width:0}\n#hogg-customizer .row-pair .row-in.num{flex:0 0 58px}\n#hogg-customizer .tpl-fields{margin-top:12px}\n#hogg-customizer .bg-grid{display:grid; grid-template-columns:repeat(3, 1fr); gap:5px; margin-top:8px}\n#hogg-customizer .bg-opt{text-align:center; padding:5px 6px; border-radius:7px; border:1px solid var(--line-strong); background:var(--surface); cursor:pointer; font-size:12px; font-weight:600; line-height:1.3}\n#hogg-customizer .bg-opt.on{border-color:var(--accent); background:var(--accent-soft)}\n@media(max-width:560px){\n#hogg-customizer .mock.tv > img.base{height:150px}\n#hogg-customizer .tviews{gap:14px}\n}\n#hogg-customizer .fx-ink{display:flex; align-items:center; gap:10px; margin-top:11px}\n#hogg-customizer .fx-ink-lab{font-size:13px; font-weight:600; color:var(--ink-2)}\n#hogg-customizer .fx-note{\n  font-size:11.5px; color:var(--muted); margin-top:8px; line-height:1.45;\n}\n#hogg-customizer .pat-grid{display:grid; grid-template-columns:1fr 1fr; gap:8px; margin-top:2px}\n#hogg-customizer .pat{\n  padding:0; border:1.5px solid var(--line-strong); border-radius:9px; overflow:hidden;\n  background:var(--surface); cursor:pointer; display:flex; flex-direction:column;\n}\n#hogg-customizer .pat:hover{border-color:var(--accent-line)}\n#hogg-customizer .pat.on{border-color:var(--accent); box-shadow:0 0 0 2px var(--accent-soft)}\n#hogg-customizer .pat img{width:100%; height:40px; object-fit:cover; display:block; border-bottom:1px solid var(--line)}\n#hogg-customizer .pat span{font-size:11.5px; font-weight:600; color:var(--ink-2); padding:5px 7px}\n#hogg-customizer .sw-sm{width:26px; height:26px}\n#hogg-customizer .fx-contrast{width:100%; margin-top:12px; padding:9px 14px; font-size:13px}\n#hogg-customizer .fx-contrast:disabled{opacity:.5}\n#hogg-customizer .mini-btns{display:flex; gap:6px; flex-wrap:wrap; margin-top:4px}\n#hogg-customizer .mini{\n  padding:5px 11px; border-radius:100px; border:1px solid var(--line-strong);\n  background:var(--surface); font-size:12px; font-weight:600; color:var(--ink-2); cursor:pointer;\n}\n#hogg-customizer .mini:hover{background:var(--surface-2); color:var(--ink); border-color:var(--accent-line)}\n#hogg-customizer .panel-label{\n  display:flex; justify-content:space-between; align-items:baseline; gap:8px;\n  font-size:12px; font-weight:600; color:var(--ink-2); margin-bottom:6px;\n}\n#hogg-customizer .panel-label em{\n  font-style:normal; font-family:"IBM Plex Mono",monospace;\n  font-size:11px; color:var(--muted); font-weight:400;\n}\n#hogg-customizer .swatches{display:flex; flex-wrap:wrap; gap:8px}\n#hogg-customizer .sw{\n  width:32px; height:32px; border-radius:50%; border:1.5px solid var(--line-strong);\n  cursor:pointer; position:relative; padding:0; flex:none;\n}\n#hogg-customizer .sw:hover{transform:scale(1.08)}\n#hogg-customizer .sw.on{box-shadow:0 0 0 2px var(--surface), 0 0 0 4px var(--accent); border-color:transparent}\n#hogg-customizer .sw-name{font-size:12.5px; color:var(--ink-2); margin-top:10px}\n#hogg-customizer .sw-name b{font-weight:600}\n#hogg-customizer .drop{\n  border:1.5px dashed var(--line-strong); border-radius:var(--r); padding:20px 14px;\n  text-align:center; cursor:pointer; background:var(--sunken); transition:border-color .15s,background .15s;\n}\n#hogg-customizer .drop:hover, #hogg-customizer .drop.over{border-color:var(--accent); background:var(--accent-soft)}\n#hogg-customizer .drop .ic{font-size:19px; line-height:1}\n#hogg-customizer .drop .t1{font-weight:600; font-size:13.5px; margin-top:7px}\n#hogg-customizer .drop .t2{font-size:12px; color:var(--muted); margin-top:3px}\n#hogg-customizer .file-row{\n  display:flex; align-items:center; gap:10px; padding:9px 11px;\n  background:var(--sunken); border:1px solid var(--line); border-radius:var(--r);\n}\n#hogg-customizer .file-row .thumb{\n  width:36px; height:36px; border-radius:6px; background:var(--photo);\n  border:1px solid var(--line); object-fit:contain; flex:none;\n}\n#hogg-customizer .file-row .fmeta{min-width:0; flex:1}\n#hogg-customizer .file-row .fname{font-size:12.5px; font-weight:600; overflow:hidden; text-overflow:ellipsis; white-space:nowrap}\n#hogg-customizer .file-row .fdim{font-family:"IBM Plex Mono",monospace; font-size:11px; color:var(--muted)}\n#hogg-customizer .link-btn{\n  background:none; border:none; color:var(--accent); font-size:12.5px; font-weight:600;\n  cursor:pointer; padding:4px; text-decoration:underline; text-underline-offset:2px;\n}\n#hogg-customizer .note{\n  border-radius:var(--r); padding:11px 13px; font-size:12.5px; line-height:1.45;\n  display:flex; gap:9px; align-items:flex-start; margin-top:11px;\n}\n#hogg-customizer .note .ni{flex:none; font-weight:700}\n#hogg-customizer .note.ok{background:var(--good-soft); color:var(--good)}\n#hogg-customizer .note.warn{background:var(--warn-soft); color:var(--warn)}\n#hogg-customizer .note.bad{background:var(--crit-soft); color:var(--crit)}\n#hogg-customizer .note b{color:inherit}\n#hogg-customizer .hc-field{margin-bottom:12px}\n#hogg-customizer .hc-field:last-child{margin-bottom:0}\n#hogg-customizer .hc-field label{display:block; font-size:12px; font-weight:600; color:var(--ink-2); margin-bottom:5px}\n#hogg-customizer .hc-field input[type=text], #hogg-customizer .hc-field select{\n  width:100%; padding:8px 11px; border-radius:8px; border:1px solid var(--line-strong);\n  background:var(--surface); color:var(--ink); font-size:13.5px;\n}\n#hogg-customizer .row2{display:grid; grid-template-columns:1fr 1fr; gap:10px}\n#hogg-customizer input[type=range]{width:100%; accent-color:var(--accent)}\n#hogg-customizer .slider-lab{display:flex; justify-content:space-between; font-size:11.5px; color:var(--muted); margin-bottom:2px}\n#hogg-customizer .slider-lab em{font-style:normal; font-family:"IBM Plex Mono",monospace; color:var(--ink-2)}\n#hogg-customizer .tabs{display:flex; gap:4px; background:var(--sunken); padding:3px; border-radius:9px; margin-bottom:14px}\n#hogg-customizer .tab{\n  flex:1; padding:7px 10px; border-radius:7px; border:none; background:none;\n  font-size:12.5px; font-weight:600; color:var(--muted); cursor:pointer;\n}\n#hogg-customizer .tab.on{background:var(--surface); color:var(--ink); box-shadow:var(--shadow)}\n#hogg-customizer .qty{display:flex; align-items:center; gap:0; width:fit-content; border:1px solid var(--line-strong); border-radius:var(--r); overflow:hidden}\n#hogg-customizer .qty button{width:34px; height:34px; border:none; background:var(--surface); cursor:pointer; font-size:16px; color:var(--ink-2)}\n#hogg-customizer .qty button:hover{background:var(--surface-2)}\n#hogg-customizer .qty input{\n  width:52px; height:34px; border:none; border-left:1px solid var(--line); border-right:1px solid var(--line);\n  text-align:center; background:var(--surface); color:var(--ink);\n  font-family:"IBM Plex Mono",monospace; font-size:14px;\n}\n#hogg-customizer .total-row{display:flex; justify-content:space-between; align-items:baseline; font-size:13px; color:var(--muted); margin-bottom:6px}\n#hogg-customizer .total-row.big{font-size:17px; color:var(--ink); font-weight:700; margin-top:9px; padding-top:11px; border-top:1px solid var(--line)}\n#hogg-customizer .total-row .v{font-family:"IBM Plex Mono",monospace; font-variant-numeric:tabular-nums}\n#hogg-customizer .bar{display:flex; gap:11px; align-items:center; margin-top:20px; flex-wrap:wrap}\n#hogg-customizer .bar .spacer{flex:1}\n#hogg-customizer /* ---------- step 4: review ---------- */\n.review{display:grid; grid-template-columns:minmax(0,1fr) 372px; gap:26px; align-items:start}\n@media(max-width:940px){\n#hogg-customizer .review{grid-template-columns:1fr}\n}\n#hogg-customizer .rev-card{background:var(--surface); border:1px solid var(--line); border-radius:var(--r-lg); padding:22px}\n  width:150px; height:210px; background:var(--photo); border:1px solid var(--line);\n  border-radius:var(--r); display:grid; place-items:center; overflow:hidden; flex:none;\n}\n#hogg-customizer /* the wrap mockup is a front/back pair, so it needs the room to be checkable */\n@media(max-width:620px){\n}\n#hogg-customizer .callout{\n  background:var(--accent-soft); border:1px solid var(--accent-line); border-radius:var(--r);\n  padding:15px 17px; font-size:13px; color:var(--ink-2); line-height:1.5;\n}\n#hogg-customizer .callout .ct{font-weight:700; color:var(--ink); margin-bottom:5px; font-size:13.5px}\n#hogg-customizer /* prototype ribbon */\n.proto{\n  background:var(--warn-soft); color:var(--warn); border-bottom:1px solid var(--line);\n  font-size:12.5px; padding:8px 0; text-align:center;\n}\n#hogg-customizer .proto b{font-weight:700}\n#hogg-customizer /* ---------- AI artwork (sublimation) ---------- */\n.ai-bal{\n  display:flex; align-items:center; gap:8px; flex-wrap:wrap; margin-bottom:12px;\n  font-size:12.5px; color:var(--ink-2); line-height:1.5;\n}\n#hogg-customizer .ai-bal b{color:var(--ink)}\n#hogg-customizer .ai-bal .link-btn{margin-left:auto; white-space:nowrap}\n#hogg-customizer .ai-ta{\n  width:100%; border:1px solid var(--line-strong); border-radius:var(--r);\n  padding:11px 12px; font:inherit; font-size:13.5px; color:var(--ink);\n  background:var(--surface); resize:vertical; min-height:76px;\n}\n#hogg-customizer .ai-ta::placeholder{color:var(--faint)}\n#hogg-customizer .ai-ideas{display:flex; flex-wrap:wrap; gap:6px; align-items:center; margin-top:9px}\n#hogg-customizer .ai-ideas > span{font-size:11.5px; color:var(--muted); font-weight:600}\n#hogg-customizer .ai-chip{\n  border:1px solid var(--line); background:var(--surface); color:var(--ink-2);\n  border-radius:999px; padding:4px 10px; font-size:11.5px; cursor:pointer;\n}\n#hogg-customizer .ai-chip:hover{border-color:var(--accent-line); color:var(--accent)}\n#hogg-customizer .ai-ref{margin-top:11px}\n#hogg-customizer .ai-ref-btn{\n  display:flex; align-items:center; gap:9px; width:100%; cursor:pointer;\n  border:1.5px dashed var(--line-strong); background:var(--sunken);\n  border-radius:var(--r); padding:11px 13px; font-size:12.5px; color:var(--ink-2);\n}\n#hogg-customizer .ai-ref-btn:hover{border-color:var(--accent-line)}\n#hogg-customizer .ai-ref-btn .ic{\n  width:22px; height:22px; border-radius:50%; background:var(--accent-soft);\n  color:var(--accent); display:grid; place-items:center; font-weight:700; flex:none;\n}\n#hogg-customizer .ai-ref-btn em{margin-left:auto; font-style:normal; font-size:11px; color:var(--faint)}\n#hogg-customizer .ai-go{width:100%; margin-top:13px}\n#hogg-customizer .ai-wait{\n  margin-top:9px; font-size:12px; color:var(--muted); text-align:center; line-height:1.5;\n}\n#hogg-customizer .ai-grid{display:grid; grid-template-columns:1fr 1fr; gap:8px; margin-bottom:10px}\n#hogg-customizer .ai-res{\n  padding:0; border:2px solid var(--line); border-radius:var(--r); overflow:hidden;\n  background:var(--sunken); cursor:pointer; aspect-ratio:1/1; display:block;\n}\n#hogg-customizer .ai-res img{width:100%; height:100%; object-fit:cover; display:block}\n#hogg-customizer .ai-res:hover{border-color:var(--accent-line)}\n#hogg-customizer .ai-res.on{border-color:var(--accent); box-shadow:0 0 0 3px var(--accent-soft)}\n#hogg-customizer .ai-pack{\n  border:1px solid var(--accent-line); background:var(--accent-soft);\n  border-radius:var(--r-lg); padding:18px;\n}\n#hogg-customizer .ai-pack-t{font-size:13px; font-weight:700; color:var(--accent); letter-spacing:.02em}\n#hogg-customizer .ai-pack-p{font-size:30px; font-weight:700; color:var(--ink); line-height:1.1; margin:4px 0 12px}\n#hogg-customizer .ai-pack-l{margin:0 0 12px; padding-left:18px; font-size:13px; color:var(--ink-2); line-height:1.65}\n#hogg-customizer .ai-pack-n{\n  font-size:12px; color:var(--muted); line-height:1.5;\n  border-top:1px solid var(--accent-line); padding-top:11px; margin-bottom:14px;\n}\n#hogg-customizer .ai-pack-b{display:flex; gap:8px}\n#hogg-customizer .ai-pack-b .btn{flex:1}\n#hogg-customizer .ai-res{position:relative}\n#hogg-customizer .ai-res.busy{border-color:var(--accent)}\n#hogg-customizer .ai-res.busy img{opacity:.35}\n#hogg-customizer .ai-res:disabled{cursor:default}\n#hogg-customizer .ai-res-busy{\n  position:absolute; inset:auto 0 0 0; padding:6px 0;\n  background:var(--accent); color:var(--accent-ink);\n  font-size:11.5px; font-weight:600; letter-spacing:.02em;\n}\n@media (prefers-reduced-motion: reduce){\n#hogg-customizer, #hogg-customizer *{transition:none !important; animation:none !important}\n}\n';
  document.head.appendChild(style);

  root.innerHTML =
    '<div class="topbar"><div class="wrap topbar-in">' +
      '<div class="brand">HOGG <span>Design Studio</span></div>' +
      '<nav class="steps" id="hc-steps"></nav>' +
    '</div></div>' +
    '<main class="wrap page" id="hc-app"><div class="empty">Loading the catalog…</div></main>';

  var CATALOG = null;

  
/* ============================== state ============================== */
const S = {
  step: 1,
  method: null,          // 'uv_print' | 'sublimation'
  product: null,         // catalog entry
  variant: null,         // chosen variant (color)
  qty: 1,
  /* UV designs are a stack of layers, back to front — a customer can put a logo
     and their name on one tumbler, which one `art` object could never hold.

     Every layer carries a bitmap in `src` whatever its kind: text, monograms and
     jersey marks are baked to canvas by bake() the moment their content changes.
     One representation means one placement path, one compositing path, and no way
     for the stage and the print file to disagree about what a font measures.

       {id, kind:'img'|'text'|'monogram'|'jersey',
        src, w, h,            baked bitmap + its natural pixel size
        x, y,                 centre, as a fraction of the print area
        s,                    size, where 1 fills the area on its limiting side
        rot,                  rotation in degrees, clockwise
        flip,                 mirrored horizontally
        ...kind-specific content}

     Sublimation uses them too, on its **Create your own** tab: the same pieces placed on
     the front of a white tumbler, printed onto an otherwise blank white wrap (see
     layerAreaW). A full wrap — uploaded or generated — is one file at one exact size
     with no placement to make, so it still rides in `art`. */
  /* One stack per side. `layers` is whichever side is being edited, so every editing path
     — add, drag, remove, the layer list — works on one side without knowing there are
     two. Rendering and printing name the side explicitly (sideLayers()), because they
     draw both while only one is being edited. Sublimation only ever uses the front. */
  // wrap: sublimation's Upload full wrap tab; pet: the Pet Templates tab (the generated scene
  // as a full-wrap piece, plus the pet's name as a text piece)
  sides: {front: [], back: [], wrap: [], pet: []},
  get layers(){ return this.sides[curSide()]; },
  set layers(v){ this.sides[curSide()] = v; },
  twoSided: false,       // no longer read: UV always has both sides (uvSides); kept for old drafts
  side: 'front',         // which side is being edited while twoSided
  sel: null,             // id of the selected layer
  zoom: false,           // stage zoomed to the print area while editing
  art: null,             // sublimation only: the wrap {type:'img', src, w, h, name}
  artB: null,            // second wrap panel, for the tapered Big Swig bottoms
  // Fit, not Fill: filling crops whatever doesn't match the wrap shape, and
  // silently cutting off part of someone's design is the worse default.
  wrapFit: 'contain',
  fxBusy: false,
  bottomMode: 'pattern',        // 'pattern' | 'upload'
  bottomOn: false,              // Big Swig: extend the wrap background onto the bottom band (+BAND_PRICE)
  /* Sublimation, Create your own tab: a background across the whole wrap, under the pieces.
     {kind, color, size, photos:[{src,name}]} — see WRAP_BGS. */
  wrapBgOn: false,
  wrapBg: {kind: 'hearts', color: '#E8A0A8', size: 'm'},
  /* Create your own: which "Start with" template the design came from, and its fill-in
     field values (kept by key, so switching template keeps a name already typed). */
  tpl: {id: null, count: 3, layout: 'row'},
  addOpen: false,        // the "+ Add another piece" options are showing
  crop: null,            // the photo being positioned in its frame: {id, frame, zoom, pan}
  logoFx: null,
  wrapPos: null,         // the full wrap being positioned in its pop-up: {id, z, x, y}          // the logo whose cleanup pop-up is open: {id, fx as it was on opening}
  addShut: false,        // "Add a piece" closed while the design is still empty
  draft: null,           // a saved design offered back on step 1 (see loadDraft)
  artError: '',                 // why the last wrap upload failed, shown under the drop zone
  bottomPattern: 'stripes',
  bottomColor: '#1F2E48',
  showArea: true,
  /* Sublimation only: how the artwork arrives. Every sublimation blank is white, so a
     logo on a white tumbler is a real sublimation order, not only an all-over wrap —
     'logo' places pieces exactly the way UV does, 'upload' takes a finished full wrap,
     and 'pet' generates one from a template and a pet photo. Each tab has its own side
     in S.sides and the tab decides which gets printed, so switching back and forth
     loses nothing. */
  artTab: 'logo',         // 'logo' | 'upload' | 'pet'
  ai: {
    status: null,         // server's answer about this visitor: allowance, price, on/off
    species: 'dog',       // Pet Templates: 'dog' | 'cat'
    template: null,       // chosen template id, e.g. 'dog:beach'
    ref: null,            // {src, name} — the pet's photo (required)
    name: '',             // the pet's name, added as a real text piece, never drawn by the AI
    busy: false,
    error: '',
    results: [],          // [{url, template}] from generations, newest first
    pack: false,          // the package explainer is open
    unlocking: false,
    applying: null,       // URL of the design currently being put on the tumbler
  },
};

let layerSeq = 0;
/* UV always shows and edits both sides (front first); the back only prints — and is only
   charged — once something is on it. */
const uvSides   = () => S.method !== 'sublimation';
const twoOn     = () => uvSides() && S.sides.back.length > 0;
/* Sublimation keeps a stack per tab — a logo design and a full-wrap design are different
   jobs, and switching tabs to look must not merge them. UV keeps one per printed side. */
const curSide   = () => S.method === 'sublimation'
  ? (S.artTab === 'upload' ? 'wrap' : S.artTab === 'pet' ? 'pet' : 'front')
  : (uvSides() ? S.side : 'front');
const sideLayers = side => S.sides[side] || [];
const SIDE_KEYS = ['front', 'back', 'wrap', 'pet'];
// Every layer that prints: on UV, both sides.
const printing  = () => uvSides() ? [...S.sides.front, ...S.sides.back] : S.sides[curSide()];
/* UV: every piece after the first, on either side, costs EXTRA_PRICE more per tumbler
   (catalog `extraPiecePrice`, the same figure the cart's Customization variant is priced at). */
let EXTRA_PRICE = 0.5;
const extraPieces = () => uvSides() && S.product ? Math.min(11, Math.max(0, inked().length - 1)) : 0;
const extraPrice = p => extraPieces() * EXTRA_PRICE * ((p || S.product).packSize || 1);
let BAND_PRICE = 1;      // replaced by the catalog's bottomBandPrice, which is what the cart charges
let METHOD_IMAGES = {};  // catalog `methodImages`: the quote form's decoration-style examples
/* The Big Swig's bottom band carries a design only as an extension of the Full wrap
   background (same pattern and colour), and only for BAND_PRICE more; otherwise it's white. */
const bandOn = () => isSub() && !!bottomSpec() && S.bottomOn && bgActive();
const bandPrice = p => bandOn() ? BAND_PRICE * ((p || S.product).packSize || 1) : 0;
const sideOf    = l => S.sides.back.includes(l) ? 'back' : 'front';
// "Back: " in front of a label only when there is a back to tell it apart from.
const layerById = id => S.layers.find(l => l.id === id) || null;
const selected  = () => layerById(S.sel);

/* Decoration price comes from the product itself: the portal's per-category
   customization rate × pack size (drinkware 6.50, ceramic_mug 3.50,
   mini_tumbler_pack 2.50 × 6). Not a flat rate. */

const hexFor = v => v.swatch || '#9AA8B4';   // sampled from the product photo

const fmt = n => '$' + n.toFixed(2);
const el = (t, a={}, ...kids) => {
  const n = document.createElement(t);
  for (const [k,v] of Object.entries(a)) {
    if (k === 'class') n.className = v;
    else if (k === 'html') n.innerHTML = v;
    else if (k.startsWith('on')) n.addEventListener(k.slice(2), v);
    else if (v !== null && v !== undefined) n.setAttribute(k, v);
  }
  for (const kid of kids.flat()) if (kid !== null && kid !== undefined)
    n.appendChild(typeof kid === 'string' ? document.createTextNode(kid) : kid);
  return n;
};

/* Where artwork starts inside the print area, as a fraction of its height.

   Not centred, and not a matter of taste: these bodies curve away below the
   straight section, and ink that lands near the curve prints badly. The print
   box is already clamped to the straight band, but artwork narrower than the box
   is tall floats to the middle of it — a wide logo centred in a 3.5" area sits
   well down the cup. Starting high keeps it clear of the curve; the Height
   slider still reaches everything.

   Straight-sided products are the exception: their print area *is* the whole
   coloured surface (`fullHeight` from the catalog), so there is no curve to stay
   clear of and no reason to prefer one height — those default to the middle. */
/* The colourway every UV product is shown in, on the cards and when the studio
   first opens. Left to itself each product led with whichever colour happened to
   be first in CUSTOMIZER_SKUS, so the grid was a scatter of unrelated finishes
   and the eye read the colours rather than the products.

   Black: the studio is a light page on a white photo plate with one deep teal
   accent, and black is the only finish that neither competes with that accent nor
   washes out against the plate. It is also where the dashed print outline is
   easiest to see, which is the thing the customer is actually there to judge.
   Falls through to the first variant for any product not sold in it. */
const DEFAULT_COLOR = 'black';
const shownVariant = p =>
  p.variants.find(v => (v.color || '').trim().toLowerCase() === DEFAULT_COLOR) || p.variants[0];

const ART_TOP_Y = 0.3;
const ART_DEFAULT_Y = () => {
  // A sublimation logo sits on a white wrap that covers the whole body, so there is
  // no curve-avoiding reason to start high either.
  try { return sizeSpec().fullHeight || isSub() ? 0.5 : ART_TOP_Y; }
  catch (e) { return ART_TOP_Y; }               // no product picked yet
};

const isSub  = () => S.method === 'sublimation';
// A sublimation logo on a white wrap. It is built from layers exactly like a UV design,
// so everything that places, draws or measures layers keys off useLayers(), not !isSub().
const subLogo   = () => isSub() && S.artTab === 'logo';
/* The flat-wrap sandbox: sublimation's Create your own and Upload full wrap tabs. Both are
   layers placed on the whole wrap and seen on three wrapped tumblers. So is Pet Templates:
   its generated scene is a full-wrap piece and the name a text piece on top. */
const sandboxMode = () => isSub();
const useLayers = () => !isSub() || sandboxMode();
const decoPrice = p => (p || S.product).decoPrice;
const unitPrice = () => (S.variant ? S.variant.price : 0) + decoPrice() + extraPrice() + bandPrice();

/* A product can vary by size, by colour, or both. The selected size decides the
   print geometry, so every area lookup goes through the size spec. */
const sizeSpec = () =>
  S.product.sizes.find(z => z.size === (S.variant ? S.variant.size : null)) || S.product.sizes[0];
const area  = () => sizeSpec().box;
const areaW = () => sizeSpec().areaW;
const areaH = () => sizeSpec().areaH;
/* How wide the layers' print area is, in print pixels — the whole print area for UV, and
   the whole wrap for sublimation, which the sandbox shows flat at its true proportions. */
const layerAreaW = () => areaW();
const hasSizes = p => (p || S.product).sizes.length > 1;
const colorsFor = (p, size) => p.variants.filter(v => v.size === size && v.color);
const findVariant = (p, size, color) =>
  p.variants.find(v => v.size === size && v.color === color) ||
  p.variants.find(v => v.size === size) || p.variants[0];

/* ============================== step rail ============================== */
const STEP_NAMES = ['Method','Product','Design','Review'];
function renderSteps(){
  const nav = document.getElementById('hc-steps');
  nav.textContent = '';
  STEP_NAMES.forEach((name,i) => {
    const n = i+1;
    const cls = n === S.step ? 'stp now' : (n < S.step ? 'stp done' : 'stp');
    nav.appendChild(el('button', {
      class: cls,
      ...(n < S.step ? { onclick: () => go(n) } : {}),
      ...(n === S.step ? { 'aria-current':'step' } : {}),
    }, el('span',{class:'n'}, String(n)), name));
    if (n < STEP_NAMES.length) nav.appendChild(el('span',{class:'stp-sep'}));
  });
}
/* Every step change goes through here. It has to render: nothing else does —
   the panel's own controls call render() for in-step edits, but a step change
   only moved S.step, so the page sat on the previous step forever. */
/* Every step change is a browser history entry, so the browser's Back button walks back
   through the steps (and Forward returns) instead of leaving the page. Leaving the design
   step for steps 1–2 keeps what it was on (`S.left`): picking a method there clears the
   product, and without this "See UV print options" was a one-way trip. */
function go(n, fromHistory){
  if (n < 3 && S.step >= 3 && S.product && S.variant)
    S.left = {method: S.method, product: S.product, variant: S.variant};
  S.step = n;
  if (!fromHistory){
    try { history.pushState({hcStep: n}, ''); } catch (e) {}
  }
  render(); window.scrollTo({top:0, behavior:'smooth'});
}
/* Back to the design left for steps 1–2, as it was. */
function backToDesign(){
  if (!S.left) return;
  Object.assign(S, S.left); S.left = null; go(3);
}
window.addEventListener('popstate', e => {
  const n = e.state && e.state.hcStep;
  if (!n || !CATALOG) return;
  if (n >= 3 && !(S.product && S.variant)){
    if (S.left){ Object.assign(S, S.left); S.left = null; }
    else return go(S.method ? 2 : 1, true);
  }
  if (n >= 2 && !S.method) return go(1, true);
  go(n, true);
});
/* Steps 1–2 while a design is waiting: one bar that takes them straight back to it. */
function leftBar(){
  if (!S.left) return null;
  return el('div',{class:'left-bar'},
    el('button',{class:'btn', onclick:backToDesign}, '← Back to your design'),
    el('span',{}, pname(S.left.product)));
}

/* ============================== step 1 ============================== */
function viewMethod(){
  const uvCount  = CATALOG.filter(p => p.method==='uv_print').length;
  const subCount = CATALOG.filter(p => p.method==='sublimation').length;

  // The quote form's decoration-style examples (Form Settings) when set; else a product photo.
  const card = (method, title, lede, bullets, count, demoSrc) => {
    const hero = METHOD_IMAGES[method];
    return el('button',{class:'method' + (hero ? ' has-hero' : ''), onclick:()=>{ S.method=method; S.product=null; go(2); }},
      hero ? el('div',{class:'method-art hero'}, el('img',{src:hero, alt:title + ' examples'}))
           : el('div',{class:'method-art'}, el('img',{src:demoSrc, alt:''})),
      el('div',{class:'method-body'},
        el('h3',{}, title),
        el('ul',{}, bullets.map(b => el('li',{}, b))),
        // What the method actually is, as a footnote under what it's best for.
        el('p',{class:'lede method-how'}, lede),
      ));
  };

  const uvDemo  = (CATALOG.find(p=>p.method==='uv_print')||{variants:[{}]}).variants[1] ||
                  CATALOG.find(p=>p.method==='uv_print').variants[0];
  const subDemo = CATALOG.find(p=>p.method==='sublimation').variants[0];

  return el('div',{},
    leftBar() || draftBanner(),
    el('div',{class:'head'},
      el('div',{class:'eyebrow'}, 'Step 1 of 4'),
      el('h1',{class:'h-lg'}, 'Print method'),
    ),
    el('div',{class:'methods'},
      card('uv_print','UV Print',
        'A permanent, full-color print applied directly to the surface of a colored tumbler.',
        ['Company logos', 'Monograms', 'Simple design on a colored tumbler'],
        uvCount, uvDemo.img),
      card('sublimation','Sublimation',
        'Ink is heat-transferred into the coating of a white tumbler.',
        ['Photos of family members or pets', 'Custom gifts', 'Design the entire surface of the tumbler'],
        subCount, subDemo.img),
    ),
  );
}

/* ============================== step 2 ============================== */
/* Each product card's photo scaled so every product's body reads at the same size, whatever
   its photo's framing. The studio photos keep each family's own framing, so a Big Swig sat small in its
   frame beside a can cooler that fills its own. photoBounds() finds the product (the same
   non-white extent the design step's views trim to); Cloudinary's e_trim couldn't, since on
   the white sublimation blanks a tolerance loose enough to drop the faint shadow also cut
   into the product. Until it's measured the photo shows as before. */
const CARD_BOX = {body: 110, h: 192, w: 210};
function fitCardImg(img, p){
  const b = photoBounds(img), box = img.parentElement;
  if (!b || !box) return;
  const W = img.naturalWidth, H = img.naturalHeight;
  // Sized by the body (the print box the Studio already has for the photo), so a straw or a
  // handle doesn't make one tumbler smaller than the next; then capped so the whole product,
  // straw and all, still fits the card.
  const v = shownVariant(p), z = (p.sizes || []).find(s => s.size === v.size) || (p.sizes || [])[0];
  const bodyH = z && z.box ? z.box.h * H : (b[3] - b[2]) * H;
  const pw = (b[1] - b[0]) * W, ph = (b[3] - b[2]) * H;
  const k = Math.min(CARD_BOX.body / bodyH, CARD_BOX.h / ph, CARD_BOX.w / pw);
  Object.assign(img.style, {position:'absolute', maxWidth:'none', maxHeight:'none',
    width: W * k + 'px', height: H * k + 'px',
    left: `calc(50% - ${((b[0] + b[1]) / 2) * W * k}px)`,
    top:  `calc(50% - ${((b[2] + b[3]) / 2) * H * k}px)`});
  box.classList.add('fit');
}

function pickProduct(p){
  // The product the design in progress is on: back to it, design intact.
  const kept = S.product || (S.left && S.left.method === S.method && S.left.product);
  if (kept === p && S.left){ Object.assign(S, S.left); S.left = null; go(3); return; }
  S.product=p; S.variant=shownVariant(p); S.art=null; S.artB=null; S.left=null;
  S.sides={front:[], back:[], wrap:[], pet:[]}; S.side='front'; S.sel=null; S.zoom=false; S.bottomOn=false;
  S.tpl={id:null, count:3}; S.wrapBgOn=false; resetHistory();
  go(3);
}

/* `?product=<group>` (e.g. ?product=skinny) opens straight onto that product's design step —
   the redirects from the old per-product "Custom ___" listings use it. Those listings were all
   sublimation, so the sublimation product wins where a group is sold both ways. An unknown
   group is ignored and the studio starts as usual. */
function linkedProduct(){
  let g = null;
  try { g = new URLSearchParams(location.search).get('product'); } catch (e) {}
  if (!g) return null;
  const inGroup = CATALOG.filter(p => p.group === g);
  return inGroup.find(p => p.method === 'sublimation') || inGroup[0] || null;
}

/* The product details pop-up, as the quote form has: photos to swipe through, then the name,
   a tagline, a specs table and a description. All of it is edited on the product's Custom
   Shop listing (catalog `info`, see studio_shop.listing_details) — the listing's main photo
   and any photo staff add that isn't a colour's, the "Design Studio: tagline" and "Design
   Studio: specs" fields, and the description. From step 2 it can also pick the product. */
function openDetails(p, canPick){
  const inf = p.info || {};
  const imgs = (inf.images && inf.images.length ? inf.images : [shownVariant(p).img]).filter(Boolean);
  const sized = u => /cdn\.shopify\.com/.test(u) ? u + (u.includes('?') ? '&' : '?') + 'width=1000' : u;
  let idx = 0;
  const track = el('div',{class:'pd-track'}, imgs.map(u => el('img',{src:sized(u), alt:pname(p), draggable:'false', loading:'lazy'})));
  const dots = imgs.length > 1 ? el('div',{class:'pd-dots'}, imgs.map((_, i) => el('span',{class:'pd-dot'+(i?'':' on')}))) : null;
  const goTo = n => {
    idx = (n + imgs.length) % imgs.length;
    track.style.transform = `translateX(-${idx * 100}%)`;
    if (dots) [...dots.children].forEach((d, i) => d.classList.toggle('on', i === idx));
  };
  const slider = el('div',{class:'pd-slider'}, track,
    imgs.length > 1 ? el('button',{class:'pd-arrow prev', 'aria-label':'Previous photo', onclick:e=>{ e.stopPropagation(); goTo(idx - 1); }}, '‹') : null,
    imgs.length > 1 ? el('button',{class:'pd-arrow next', 'aria-label':'Next photo', onclick:e=>{ e.stopPropagation(); goTo(idx + 1); }}, '›') : null,
    dots);
  let sx = null;
  slider.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, {passive:true});
  slider.addEventListener('touchend', e => {
    if (sx === null) return;
    const dx = e.changedTouches[0].clientX - sx; sx = null;
    if (Math.abs(dx) > 30) goTo(idx + (dx < 0 ? 1 : -1));
  });
  const close = () => { ov.remove(); document.removeEventListener('keydown', key); };
  const key = e => {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft' && imgs.length > 1) goTo(idx - 1);
    else if (e.key === 'ArrowRight' && imgs.length > 1) goTo(idx + 1);
  };
  const card = el('div',{class:'pd-card', role:'dialog', 'aria-modal':'true', onclick:e=>e.stopPropagation()},
    el('button',{class:'pd-close', 'aria-label':'Close', onclick:close}, '✕'),
    slider,
    el('div',{class:'pd-body'},
      el('h3',{class:'pd-name'}, pname(p)),
      inf.tagline ? el('p',{class:'pd-tag'}, inf.tagline) : null,
      inf.specs && inf.specs.length ? el('table',{class:'pd-specs'}, el('tbody',{},
        inf.specs.map(([k, v]) => el('tr',{}, el('td',{class:'k'}, k), el('td',{}, v))))) : null,
      inf.details ? el('div',{class:'pd-details', html:inf.details}) : null,
      canPick ? el('button',{class:'btn pri', style:'width:100%;margin-top:14px',
        onclick:()=>{ close(); pickProduct(p); }}, 'Design this ' + (p.packSize > 1 ? 'pack' : 'product')) : null));
  const ov = el('div',{class:'crop-ov pd-ov', onclick:close}, card);
  document.addEventListener('keydown', key);
  document.getElementById(MOUNT_ID).appendChild(ov);
}
let q2 = '', cat2 = 'all';
function viewProducts(){
  const pool = CATALOG.filter(p => p.method === S.method);
  const cats = ['all', ...new Set(pool.map(p => p.groupName))];
  const list = pool.filter(p =>
    (cat2==='all' || p.groupName===cat2) &&
    (!q2 || (pname(p) + ' ' + p.title).toLowerCase().includes(q2.toLowerCase())));

  const grid = list.length ? el('div',{class:'hc-grid'}, list.map(p => {
    const v0 = shownVariant(p);
    const min = Math.min(...p.variants.map(v=>v.price)) + decoPrice(p);
    const named = colorsFor(p, v0.size);
    const tags = [];
    if (p.sizes.length > 1) tags.push(p.sizes.map(z=>z.size).join(' · '));
    if (p.packSize > 1) tags.push('Sold as a '+p.packSize+'-pack');
    // A span, not a button: the card itself is a button, and buttons can't nest.
    const info = el('span',{class:'card-info', role:'button', tabindex:'0', 'aria-label':'Product details',
      onclick:e=>{ e.stopPropagation(); openDetails(p, true); },
      onkeydown:e=>{ if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); e.stopPropagation(); openDetails(p, true); } }},
      el('span',{class:'ci-i'}, 'i'), 'Details');
    return el('button',{class:'hc-card', onclick:()=>pickProduct(p)},
      el('div',{class:'card-art'},
        el('div',{class:'card-shot'}, el('img',{crossorigin:'anonymous', src:v0.img, alt:pname(p), loading:'lazy',
          onload:e=>fitCardImg(e.target, p)})), info),
      el('div',{class:'card-body'},
        el('div',{class:'card-title'}, pname(p)),
        tags.length ? el('div',{class:'tag-row'}, tags.map(t=>el('span',{class:'pack-tag'},t))) : null,
        el('div',{class:'card-meta'},
          el('span',{class:'price', html:'from <b>'+fmt(min)+'</b>'}),
          named.length > 1
            ? el('span',{class:'swatch-row'},
                named.slice(0,4).map(v => el('span',{class:'sw-dot', style:'background:'+hexFor(v)})),
                named.length>4 ? el('span',{class:'sw-more'}, '+'+(named.length-4)) : null)
            : null,
        ),
      ));
  })) : el('div',{class:'empty'}, 'No products match that search.');

  return el('div',{},
    leftBar(),
    el('div',{class:'head'},
      el('div',{class:'eyebrow'}, 'Step 2 of 4 · ' + (isSub()?'Sublimation':'UV Print')),
      el('h1',{class:'h-lg'}, 'Pick your product'),
    ),
    /* With a short list, search + category chips are just noise. */
    pool.length > 8 ? el('div',{class:'filters'},
      el('input',{class:'search', type:'text', placeholder:'Search products…', value:q2,
        oninput:e=>{ q2=e.target.value; render(true); }}),
      el('div',{class:'chips'}, cats.map(c =>
        el('button',{class:'chip'+(c===cat2?' on':''), onclick:()=>{ cat2=c; render(true); }},
          c==='all' ? 'All' : c))),
    ) : null,
    grid,
    el('div',{class:'bar'}, el('button',{class:'btn', onclick:()=>go(1)}, '← Back')),
  );
}

/* ============================== step 3 ============================== */
function viewDesign(){
  return el('div',{},
    el('div',{class:'head'},
      el('div',{class:'eyebrow'}, 'Step 3 of 4 · ' + (isSub()?'Sublimation':'UV Print')),
      /* The heading follows the tab, not just the method. "Upload your wrap artwork",
         over a panel whose only control is a description box, tells someone to do the one
         thing this tab exists to save them from — and the subtitle underneath it was
         explaining a pixel size that is no longer shown. */
      el('h1',{class:'h-lg'}, !isSub() || sandboxMode() ? 'Design your tumbler' : 'Describe your design'),
    ),
    el('div',{class:'studio'},
      el('div',{class:'stage-col', id:'hc-stage-col'}, stage(), stageFoot()),
      panel(),
    ),
  );
}

/* One rendered tumbler. `view.turn` is how far the body is rotated, as a fraction
   of a full turn; `view.flip` mirrors the product photo so the far side of the
   body is what's facing you. `view.side` names which UV stack it shows (two-sided
   designs); `view.edit` overrides whether it's the one being edited — by default the
   full-size view is and the small ones are reference pictures. */
function mockView(view, small){
  const v = S.variant, a = area();
  const edit = view.edit !== undefined ? view.edit : !small;
  const mock = el('div',{class:'mock'+(small?' sm':'')},
    el('img',{class:'base', src:v.img, alt:pname(S.product),
              ...(view.flip ? {style:'transform:scaleX(-1)'} : {})}));
  const pct = n => (n*100)+'%';
  // Mirroring the photo moves the body across the frame, so the print area has to
  // move with it. Only the photo is flipped, never the artwork inside — a design
  // that reads backwards on the back of the tumbler is just wrong.
  const cx = view.flip ? 1 - a.x : a.x;
  const frame = `left:${pct(cx-a.w/2)}; top:${pct(a.y-a.h/2)}; width:${pct(a.w)}; height:${pct(a.h)};`;
  const clip = el('div',{class:'clip', style:frame});
  (view.side ? sideLayers(view.side) : S.layers)
    .forEach(l => { if (l.src) clip.appendChild(layerNode(l)); });
  mock.appendChild(clip);
  // UV sides: a side's print area shows once that side has a design, and only then — an empty
  // back shows as a plain tumbler. (The single view shows it whenever it's being edited.)
  const showArea = view.side ? sideLayers(view.side).length > 0 : edit;
  if (showArea){
    // Just the name, and below the box: the pixel figures belong in the panel
    // (where the wrap size already has its own callout), and sitting on top of
    // the outline this label covered the part of the tumbler being judged.
    // Centre guides, as every design tool has them: lining a mark up by eye
    // against a dashed rectangle is the one thing this view is bad at.
    mock.appendChild(el('div',{class:'area show', style:frame},
      el('span',{class:'guide v'}), el('span',{class:'guide h'})));
  }
  // Selection chrome last, and outside the clip: the clip has overflow:hidden and
  // would cut every handle in half. Never on the small back-view, which is a
  // reference picture rather than something to edit.
  const sel = useLayers() && edit ? selected() : null;
  if (sel && sel.src) mock.appendChild(frameFor(sel));

  /* Clicking a design selects it (and drags it); clicking bare tumbler deselects. On UV both
     sides' designs can be grabbed where they are — the side is only chosen from the panel
     (each design's Side switch, and Add to), never by clicking a tumbler. */
  if (useLayers() && (edit || view.side)){
    mock.addEventListener('pointerdown', e => {
      const hit = e.target.closest('.art');
      const id = hit && +hit.getAttribute('data-id');
      if (id && view.side) S.side = view.side;     // the piece's own side, so drags line up
      if (id){
        /* Select and start dragging in the same press. Selecting first and
           re-rendering would replace the node under the pointer — the drag would
           die on contact, which is the slider bug in a different costume. The
           frame appears on pointerup instead, and having no chrome in the way
           while dragging turns out to be the nicer half of the trade. */
        S.sel = id; S.zoom = true;
        return startMove(e, layerById(id));
      }
      if (!e.target.closest('.frame')){ S.sel = null; S.zoom = false; render(true); }
    });
  }
  return mock;
}

/* UV's single view. (Sublimation draws its own wrapped views — see WRAP_VIEWS.) */
const FLAT_VIEW = {turn: 0, flip: false};
/* Two-sided UV: the same photo twice, the second mirrored so it reads as the back —
   the same trick the wrap's back view uses. The artwork is never mirrored. */
const SIDE_VIEWS = [
  {turn: 0, flip: false, side: 'front', label: 'Front'},
  {turn: 0, flip: true,  side: 'back',  label: 'Back'},
];
/* The views for this product. The Big Swig's photo has its handle on the right, but its front
   is the side facing out when it's held right-handed — the handle on the left, as the
   sublimation Big Swig's main side — so there the mirrored photo is the front. */
const sideViews = () => handleSide(S.product) === 'right'
  ? [{...SIDE_VIEWS[0], flip: true}, {...SIDE_VIEWS[1], flip: false}] : SIDE_VIEWS;
const sideFlip = side => (sideViews().find(v => v.side === side) || {}).flip;


/* ======================= sublimation: sandbox + wrapped views =======================
   A wrap is designed flat and judged wrapped. The sandbox is the whole print file at its
   true proportions — pieces go anywhere on it, at any size — and three tumblers below show
   the same design bent round the body, redrawn live on every drag.

   The file's left and right edges meet at the seam. On a handled body that seam sits
   under the handle, which is where a wrap's join belongs: it's the one strip of the
   tumbler nobody looks at, and the sandbox shades it so nothing important goes there. */

/* Three views a quarter turn apart, centred on u = 0.25 / 0.5 / 0.75 of the file. Each
   shows half the circumference, so together they cover all of it, and the seam (u = 0)
   falls at the outer edge of the left and right views — exactly where the handle stands
   in profile in the product photo. That is why these offsets and not an even third of a
   turn: the photos are shot with the handle in profile, so only a view with the seam at
   its edge can put the printed design and the photographed handle in the same place. */
const WRAP_VIEWS = [
  {c: 0.25, label: 'Left'},
  {c: 0.50, label: 'Front'},
  {c: 0.75, label: 'Right'},
];

/* Which side of its own photo each handled product's handle is on. The mug is shot with
   the handle left, the Big Swig with it right; everything else is a plain cylinder. */
/* The name customers see: the Custom Shop listing's own title (staff rename it there —
   "Sublimatable" is dropped, for one), falling back to the catalog title. `p.title` stays the
   internal key every print geometry table is looked up by, so never display it directly. */
const pname = p => (p && (p.name || p.title)) || '';
const handleSide = p => /big swig/i.test(p.title) ? 'right' : /mug/i.test(p.title) ? 'left' : null;
/* The body's circumference in print px (catalog `circ`). Equal to the wrap everywhere but
   the mug, whose wrap stops short and leaves a gap for the handle. */
const circPx = () => Math.max(areaW(), sizeSpec().circ || areaW());
const circK = () => circPx() / areaW();          // > 1 where the wrap leaves a gap
/* Artwork never runs across the seam: past either edge of the wrap it is trimmed. Letting
   it come round the other side meant one piece scaled up large enough overlapped itself. */
const wrapsRound = () => false;
/* The share of the file a handle hides, both edges together: its measured width (catalog
   `handleW`), less whatever gap the wrap already leaves for it. */
const handleFrac = () => {
  const hw = sizeSpec().handleW;
  return hw ? Math.min(0.3, Math.max(0, hw - (circPx() - areaW())) / areaW()) : 0;
};

/* A view is mirrored when the handle has to be on the other side from the photo's: the
   left view shows the seam at its left edge, the right view at its right. The front view
   uses the photo as shot (its handle would really be behind the body). */
function wrapViewFlip(vw){
  const hs = handleSide(S.product);
  if (!hs) return false;
  if (vw.c < 0.5) return hs === 'right';
  if (vw.c > 0.5) return hs === 'left';
  return false;
}

/* Decoded images for the canvas previews, keyed by src. A layer's bitmap is replaced when
   it is cleaned up or re-baked, so a new src is simply a new entry; a redraw is requested
   when one finishes loading. */
const IMG_CACHE = new Map();
function cachedImg(src){
  let i = IMG_CACHE.get(src);
  if (!i){
    if (IMG_CACHE.size > 40) IMG_CACHE.clear();
    i = new Image();
    // The product photo is read back for the body outline (bodyMask), which needs CORS.
    if (!src.startsWith('data:')) i.crossOrigin = 'anonymous';
    i.onload = () => scheduleViews();
    i.src = src;
    IMG_CACHE.set(src, i);
  }
  return i.complete && i.naturalWidth ? i : null;
}

/* The flat wrap as a canvas at width `pw` — white, with the pieces on it, each also drawn
   one wrap-width to either side so anything crossing the seam comes round the other edge,
   the way it does on the tumbler. Pet Templates is its generated scene. Returns null
   while something is still loading. `imgs` optionally supplies decoded images by layer id
   (the order-time renders load their own). */
function flatWrap(pw, imgs){
  const w = areaW(), h = areaH(), ph = Math.round(pw * h / w);
  const cv = document.createElement('canvas');
  cv.width = pw; cv.height = ph;
  const c = cv.getContext('2d');
  c.fillStyle = '#FFFFFF'; c.fillRect(0, 0, pw, ph);
  // `imgs` is the one-off order render, drawn from the originals at high quality; the
  // live preview draws from copies already scaled to the size they appear at (scaledCopy),
  // so it needs no more than medium — high re-resampled the dragged piece every frame.
  const live = !imgs;
  c.imageSmoothingEnabled = true; c.imageSmoothingQuality = live ? 'medium' : 'high';
  if (!sandboxMode()){
    if (!S.art) return cv;
    const im = imgs ? imgs.art : cachedImg(S.art.src);
    if (!im) return null;
    c.drawImage(live ? scaledCopy(S.art.src, im, pw, ph) : im, 0, 0, pw, ph);
    return cv;
  }
  const list = inked(), got = {};
  for (const l of list){
    if (!l.src) continue;
    const im = imgs ? imgs[l.id] : cachedImg(l.src);
    if (!im) return null;
    if (live){
      const b = layerBox(l);
      got[l.id] = scaledCopy(l.src, im, pw * b.w, ph * b.h);
    } else got[l.id] = im;
  }
  if (bgActive()){
    const bg = wrapBgCanvas(src => imgs ? (imgs.bg || {})[src] : cachedImg(src));
    if (!bg) return null;
    c.drawImage(live ? scaledCopy(BG_CACHE.key, bg, pw, ph) : bg, 0, 0, pw, ph);
  }
  drawLayers(c, pw, ph, got, list, wrapsRound());
  return cv;
}

/* An image at exactly w x h, resampled once at high quality and then reused. The views
   redraw on every drag step; high-quality scaling of a phone photo (or the full-size
   background) on each of those was most of the time a redraw took, and made dragging
   visibly stutter on an ordinary desktop. A drag keeps the size, so every step after the
   first is a plain 1:1 copy; a resize makes one new copy per step, for that piece only. */
const SCALED = new Map();
function scaledCopy(key, im, w, h){
  w = Math.max(1, Math.round(w)); h = Math.max(1, Math.round(h));
  const iw = im.naturalWidth || im.width, ih = im.naturalHeight || im.height;
  if (iw <= w * 1.25 && ih <= h * 1.25) return im;      // little or no shrinking: draw as is
  let byKey = SCALED.get(key);
  if (!byKey){
    if (SCALED.size > 24) SCALED.clear();
    byKey = new Map(); SCALED.set(key, byKey);
  }
  const k = w + 'x' + h;
  let cv = byKey.get(k);
  if (cv) return cv;
  if (byKey.size > 6) byKey.clear();                    // a resize leaves stale sizes
  cv = document.createElement('canvas'); cv.width = w; cv.height = h;
  const c = cv.getContext('2d');
  c.imageSmoothingEnabled = true; c.imageSmoothingQuality = 'high';
  c.drawImage(im, 0, 0, w, h);
  byKey.set(k, cv);
  return cv;
}

/* The flat wrap bent round a cylinder into a bw x bh box at (bx, by), centred on u = `centre`.

   A column at t in [-1, 1] across the visible body faces the camera at angle asin(t), so
   it shows the file at u = centre + asin(t) / 2π. The middle of the view is at true width
   and the edges compress, which is what a printed tumbler actually looks like — a straight
   linear mapping squeezes everything evenly and makes a round logo read as an oval. */
function drawWrapped(c, flat, bx, by, bw, bh, centre, reff, ck, rim, rimB){
  // One column per device pixel — two while a piece is being dragged or sized (half the
  // draws, under a CSS pixel apart); letting go redraws at full detail.
  const fw = flat.width, fh = flat.height, cols = Math.max(2, Math.round(bw / (gesturing ? 2 : 1)));
  const step = bw / cols, k = reff || 1;
  // `ck` = circumference / wrap width. u runs round the whole body with the seam (or the
  // middle of the handle gap) at 0; `f` is where that lands in the file, and a column
  // outside it is the gap, left unprinted so the body shows.
  const circ = ck || 1, gap0 = (circ - 1) / 2;
  // Each column's top drops by the top curve at its angle and its bottom by the bottom
  // curve (`rimB`, the same as `rim` unless given), so the design follows both ellipses.
  // Columns are drawn a little past both edges and cut by a smooth outline of the same
  // two curves: a column's own top and bottom are hard-edged, and one after another at
  // slightly different heights they read as a staircase along the edge.
  const a = rim || 0, ab = rimB === undefined ? a : rimB, pad = 1.5;
  const sq = x => Math.sqrt(Math.max(0, 1 - x * x));
  c.save();
  c.beginPath();
  for (let i = 0; i <= 48; i++){ const t = i / 24 - 1; c.lineTo(bx + (t + 1) / 2 * bw, by + a * sq(t)); }
  for (let i = 48; i >= 0; i--){ const t = i / 24 - 1; c.lineTo(bx + (t + 1) / 2 * bw, by + bh - ab * (1 - sq(t))); }
  c.closePath(); c.clip();
  // Medium, not high: the view is drawn a column at a time from a source that changes on
  // every drag step, and at high quality each column re-prepared the whole source — ~75ms
  // a step on an ordinary desktop. Medium looks the same at these scales.
  c.imageSmoothingEnabled = true; c.imageSmoothingQuality = 'medium';
  for (let i = 0; i < cols; i++){
    // `reff` > 1 treats the body as a wider cylinder than the box — see wrapGeom().
    const t = Math.max(-0.9999, Math.min(0.9999, (((i + 0.5) / cols) * 2 - 1) / k));
    let u = centre + Math.asin(t) / (2 * Math.PI);
    u -= Math.floor(u);
    const f = u * circ - gap0;
    if (f < 0 || f >= 1) continue;
    // One output column covers this much of the file — wider towards the edges.
    const sw = Math.max(1, fw * circ / (Math.PI * cols * k * Math.sqrt(1 - t * t)));
    const sx = Math.min(fw - sw, Math.max(0, f * fw - sw / 2));
    const s1 = sq(t * k), top = a * s1, bot = bh - ab * (1 - s1);
    c.drawImage(flat, sx, 0, sw, fh, bx + i * step, by + top - pad, step + 0.6, bot - top + pad * 2);
  }
  c.restore();
}

/* Where the wrap really sits inside the body box, as fractions of the box's height.

   The sublimation photos were never measured (see Product images: `measured: false`), so
   a box's proportions needn't match the wrap's: at true scale a wrap is its height by
   circumference / π across. Bending a file into a box of the wrong shape stretches every
   logo by the difference, so the views correct for it:

   - A body with a bottom band (the tapered Big Swig) has a box running down over the
     taper, where the main wrap doesn't go. The main wrap takes its true height from the
     top, and the band is drawn on the rest — which is where it prints.
   - Any other box that's too tall is kept, and the body treated as a proportionally wider
     cylinder (`reff`): the middle of each view is then at true proportions, and a view
     sees a little less than half the circumference.
   - A box too short is left as it is — see DESIGN_STUDIO.md, the mug needs measuring. */
function wrapGeom(){
  const a = area(), v = S.variant;
  const boxAR = (a.h * (v.ih || 1)) / (a.w * (v.iw || 1));
  const trueAR = areaH() / (circPx() / Math.PI);
  if (!(boxAR > trueAR) || !v.iw) return {main: 1, reff: 1, band: false};
  if (bottomSpec()) return {main: trueAR / boxAR, reff: 1, band: true};
  return {main: 1, reff: boxAR / trueAR, band: false};
}

/* The main wrap and, on a tapered body, the bottom band below it, into one body box. */
function drawBody(c, flat, band, bx, by, bw, bh, centre, taper, prof){
  const g = wrapGeom(), mh = bh * g.main, cv = curveAt;
  drawWrapped(c, flat, bx, by, bw, mh, centre, g.reff, circK(), bw * cv(0), bw * cv(g.main));
  // The light is laid across the main wrap's own width here; the band gets it below, squeezed
  // with the band — laid across the whole box, the body's bright edge above landed inside the
  // narrower band as a pale strip down its right side.
  if (prof){ c.save(); c.beginPath(); c.rect(bx, by, bw, mh); c.clip(); shadePrint(c, bw, mh, prof); c.restore(); }
  if (g.band && band && bh - mh > 1){
    /* The band narrows with the body: bent round at the full box width first, then each row
       squeezed to the body's own width at that height (`taper`, measured off the photo at
       the band's top and bottom), so its sides follow the base's outline. One rectangle at
       the band's average width came out too narrow at its top and too wide at its foot. */
    const tp = taper || {t: 1, b: 1}, th = Math.ceil(bh - mh), avg = (tp.t + tp.b) / 2;
    const tc = document.createElement('canvas'); tc.width = Math.ceil(bw); tc.height = th;
    drawWrapped(tc.getContext('2d'), band, 0, 0, bw, th, centre, 1, 1,
                bw * avg * cv(g.main), bw * avg * cv(1));
    if (prof) shadePrint(tc.getContext('2d'), tc.width, th, prof);
    for (let y = 0; y < th; y++){
      const wr = bw * (tp.t + (tp.b - tp.t) * (y + 0.5) / th);
      c.drawImage(tc, 0, y, tc.width, 1, bx + (bw - wr) / 2, by + mh + y, wr, 1.05);
    }
  }
}

/* How much the print's top and bottom edges curve, as a share of the width there. The camera
   sits above each product, so every horizontal circle reads as an ellipse — and a deeper one
   the further below the camera it is: the base's is several times the rim's. The print's edges
   have to follow the same ellipses as the body's, or its top floats off the rim and its
   bottom runs flatter than the base ("not symmetrical with the bottom of the cup").

   Per product, the depth at the print box's top and at its bottom (a fraction of the width),
   and linear between, since an ellipse's depth grows with distance below the eye. Measured by
   fitting ellipses to each photo's base silhouette (and rim, where the rim is a clean circle —
   the mug and the coolers; the tumblers' flat lid tops aren't), through a straight-line
   perspective model. A single 11% everywhere was too deep at the top and too shallow at the
   bottom on every product. */
// Where a product has a lid, `top` is the lid's own bottom edge, read off the photo (clear
// and metal lids photograph almost edge-on, so nearly flat); `bot` is the base, or on the
// speakers the top of the speaker ring. The boxes they pair with are in MEASURED_BOX.
const RIM_CURVES = {
  skinny:     {top: 0.005, bot: 0.090},
  spkrskinny: {top: 0.005, bot: 0.045},   // bottom = the speaker ring's top edge, a shallow curve
  miniskinny: {top: 0.005, bot: 0.110},
  bigswig:    {top: 0.010, bot: 0.125},
  cancooler:  {top: 0.030, bot: 0.094},
  spkrcooler: {top: 0.005, bot: 0.128},
  coffeemug:  {top: 0.040, bot: 0.144},   // top from the rim's front lip, which reads shallower than its outer silhouette
};
const RIM_CURVE = 0.11;       // anything unmeasured
const rimCurve = () => RIM_CURVES[(S.product || {}).group] || {top: RIM_CURVE, bot: RIM_CURVE};
/* The depth at `f` of the way down the print box (0 top, 1 bottom). */
const curveAt = f => { const r = rimCurve(); return r.top + (r.bot - r.top) * f; };

/* A tapered body (the Big Swig) narrows under its main wrap, and the bottom band follows
   it: the body's width at the band's top (`t`) and at its foot (`b`), as fractions of the
   print box's width. Read off the photo's LEFT edge only, mirrored about the box centre:
   the build snaps near-white to pure white, so the lit right side of a white body has no
   reliable edge — cutting to it is what made the views ragged on the right. Cached per
   photo; full width when the photo can't be read. */
const TAPERS = new Map();
function bandTaper(photo){
  const g = wrapGeom();
  if (!g.band || !photo) return {t: 1, b: 1};
  if (TAPERS.has(photo.src)) return TAPERS.get(photo.src);
  let k = {t: 1, b: 1};
  try {
    const a = area(), W = photo.naturalWidth, H = photo.naturalHeight;
    const cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    const c = cv.getContext('2d', {willReadFrequently: true});
    c.drawImage(photo, 0, 0);
    const cx = a.x * W, top = (a.y - a.h/2) * H, bh = a.h * H, half = a.w * W / 2;
    const leftEdge = y => {
      const d = c.getImageData(0, Math.round(y), Math.round(cx), 1).data;
      for (let x = 0; x < d.length / 4; x++)
        if (d[x*4] < 250 || d[x*4+1] < 250 || d[x*4+2] < 250) return x;
      return null;
    };
    const fr = y => { const l = leftEdge(y); return l === null ? null : Math.max(0.4, Math.min(1.02, (cx - l) / half)); };
    // A few rows in from each end, where the band's edge is straight.
    const t = fr(top + bh * g.main + (bh - bh * g.main) * 0.1), b = fr(top + bh * 0.95);
    if (t !== null && b !== null){
      // Extrapolated back to the band's own top and foot from those two rows.
      const y1 = g.main + (1 - g.main) * 0.1, y2 = 0.95, slope = (b - t) / (y2 - y1);
      k = {t: t - slope * (y1 - g.main), b: b + slope * (1 - y2)};
    }
  } catch (e){ k = {t: 1, b: 1}; }
  TAPERS.set(photo.src, k);
  return k;
}

/* The printed band's outline in a w x h body box: curved top and bottom, straight sides,
   and over a tapered body's bottom band, the band's own trapezoid. */
function bodyPath(c, w, h, taper){
  const g = wrapGeom(), mh = h * g.main, N = 48;
  const s = t => Math.sqrt(Math.max(0, 1 - t * t));
  const a = w * curveAt(0);
  c.beginPath();
  for (let i = 0; i <= N; i++){ const t = i / N * 2 - 1; c.lineTo((t + 1) / 2 * w, a * s(t)); }
  if (g.band && taper && (taper.t < 1 || taper.b < 1)){
    const wt = w * taper.t, wb = w * taper.b, ab = wb * curveAt(1);
    c.lineTo(w, mh); c.lineTo((w + wt) / 2, mh);
    for (let i = N; i >= 0; i--){
      const t = i / N * 2 - 1;
      c.lineTo(w / 2 + t * wb / 2, h - ab + ab * s(t));
    }
    c.lineTo((w - wt) / 2, mh); c.lineTo(0, mh);
  } else {
    const ab = w * curveAt(1);
    for (let i = N; i >= 0; i--){ const t = i / N * 2 - 1; c.lineTo((t + 1) / 2 * w, h - ab + ab * s(t)); }
  }
  c.closePath();
}

/* How the photo lights the body, left to right across the print box: 0 at its darkest
   column, 1 at its brightest, in the view's own orientation (`flip` mirrors it with the
   photo). The print is multiplied onto the photo, so it already takes that diffuse
   shading — but faintly (a white body only dips to ~0.82), and a glossy printed tumbler
   also shows a highlight that a white one can't. Taking both from the photo keeps them
   where the photo's light actually is; a fixed gradient put its highlight on the photo's
   darkest band and the two cancelled out into a flat-looking print. Cached per photo. */
const LIGHT = new Map();
function lightProfile(photo, flip){
  if (!photo) return null;
  const key = photo.src + '|' + area().x + '|' + !!flip;
  if (LIGHT.has(key)) return LIGHT.get(key);
  let prof = null;
  try {
    const a = area(), W = photo.naturalWidth, H = photo.naturalHeight, N = 32;
    const cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    const c = cv.getContext('2d', {willReadFrequently: true});
    c.drawImage(photo, 0, 0);
    const x0 = (a.x - a.w / 2) * W, y0 = (a.y - a.h / 2) * H, raw = [];
    for (let i = 0; i < N; i++){
      const x = Math.round(x0 + (i + 0.5) / N * a.w * W);
      let sum = 0;
      [0.3, 0.4, 0.5, 0.6].forEach(f => {
        const d = c.getImageData(x, Math.round(y0 + f * a.h * H), 1, 1).data;
        sum += (d[0] + d[1] + d[2]) / 3;
      });
      raw.push(sum / 4);
    }
    // The outermost columns can be background the build snapped to white; judge the
    // range on the inner body only, then clamp.
    const inner = raw.slice(3, N - 3), lo = Math.min(...inner), hi = Math.max(...inner);
    if (hi - lo > 4){
      prof = raw.map(v => Math.max(0, Math.min(1, (v - lo) / (hi - lo))));
      if (flip) prof.reverse();
    }
  } catch (e) { prof = null; }       // an unreadable photo just means no extra shading
  LIGHT.set(key, prof);
  return prof;
}

/* Deepens the photo's own shading on the print and adds the gloss highlight where the
   photo is brightest. Both leave white alone (overlay and screen on white stay white), so
   the unprinted body keeps exactly the photo's look and the two match at the print's edge. */
/* The shading and gloss as colour stops: [position 0..1, css colour] for each. Shared by
   the canvas version (the filed mockup) and the stage's CSS layers (lightLayers). */
function lightStops(prof){
  const n = prof.length, stop = i => (i + 0.5) / n;
  return {
    shade: prof.map((p, i) => [stop(i), `rgba(0,0,0,${(0.34 * (1 - p)).toFixed(3)})`]),
    gloss: prof.map((p, i) => { const g = Math.max(0, (p - 0.55) / 0.45);
                                return [stop(i), `rgba(255,255,255,${(0.34 * g * g).toFixed(3)})`]; }),
  };
}

/* The stage draws the same light with CSS blend layers over each view (.cyl-shade overlay,
   .cyl-gloss screen) rather than on the canvas: canvas overlay/screen compositing took
   ~30ms per view per redraw — most of what made dragging stutter — and the compositor
   does it for nothing. Over the photo they give the same result: both modes leave white
   white, so only the print is touched. */
function lightLayers(view, prof, photo){
  const g = wrapGeom(), tp = g.band ? bandTaper(photo) : null;
  const key = (prof ? prof.join(',') : '') + '|' + g.main + '|' + (tp ? tp.t + ',' + tp.b : '');
  if (view.dataset.light === key) return;
  view.dataset.light = key;
  const css = st => `linear-gradient(90deg, ${st.map(([p, c]) => `${c} ${(p * 100).toFixed(1)}%`).join(', ')})`;
  const st = prof ? lightStops(prof) : null;
  const [shM, glM] = view.querySelectorAll('.cyl-shade:not(.bandl), .cyl-gloss:not(.bandl)');
  const [shB, glB] = view.querySelectorAll('.cyl-shade.bandl, .cyl-gloss.bandl');
  shM.style.background = st ? css(st.shade) : 'none';
  glM.style.background = st ? css(st.gloss) : 'none';
  /* On a tapered body the main light stops at the band, and the band gets its own, as wide
     as the band and cut to its trapezoid — laid across the whole box, the body's bright edge
     fell inside the narrower band as a pale strip down its right side. */
  const pct = n => (n * 100).toFixed(2) + '%';
  [shM, glM].forEach(d => { d.style.height = tp ? pct(g.main) : ''; d.style.bottom = tp ? 'auto' : ''; });
  [shB, glB].forEach((d, i) => {
    if (!tp || !st){ d.style.display = 'none'; return; }
    const w = Math.max(tp.t, tp.b), it = (w - tp.t) / 2 / w, ib = (w - tp.b) / 2 / w;
    Object.assign(d.style, {display: '', top: pct(g.main), height: pct(1 - g.main), bottom: 'auto',
      left: pct((1 - w) / 2), width: pct(w),
      clipPath: `polygon(${pct(it)} 0, ${pct(1 - it)} 0, ${pct(1 - ib)} 100%, ${pct(ib)} 100%)`,
      background: css(i ? st.gloss : st.shade)});
  });
}

function shadePrint(c, w, h, prof){
  if (!prof) return;
  const st = lightStops(prof);
  const shade = c.createLinearGradient(0, 0, w, 0), gloss = c.createLinearGradient(0, 0, w, 0);
  st.shade.forEach(([p, col]) => shade.addColorStop(p, col));
  st.gloss.forEach(([p, col]) => gloss.addColorStop(p, col));
  // Overlay and screen onto a transparent pixel paint the gradient itself, which showed as
  // a grey line in the gap between the Big Swig's wrap and its band — so the result is cut
  // back to what was printed.
  const mask = document.createElement('canvas'); mask.width = w; mask.height = h;
  mask.getContext('2d').drawImage(c.canvas, 0, 0);
  c.save();
  c.globalCompositeOperation = 'overlay'; c.fillStyle = shade; c.fillRect(0, 0, w, h);
  c.globalCompositeOperation = 'screen';  c.fillStyle = gloss; c.fillRect(0, 0, w, h);
  c.globalCompositeOperation = 'destination-in'; c.drawImage(mask, 0, 0);
  c.restore();
}

/* One view's design as its own canvas, bent round the body and cut to its outline. */
function bodyCanvas(flat, band, centre, w, h, photo, flip, noLight){
  const cv = document.createElement('canvas'); cv.width = w; cv.height = h;
  paintBody(cv.getContext('2d'), flat, band, centre, w, h, photo, flip, noLight);
  return cv;
}
/* The same, straight into an existing context — the stage's views. Drawing into a spare
   canvas and copying it across made the browser read each view back from the GPU on every
   redraw, which was most of what a drag step cost. */
function paintBody(c, flat, band, centre, w, h, photo, flip, noLight){
  const taper = bandTaper(photo);
  c.save(); bodyPath(c, w, h, taper); c.clip();
  drawBody(c, flat, band, 0, 0, w, h, centre, taper, noLight ? null : lightProfile(photo, flip));
  c.restore();
}

/* The same cylinder shading the stage's .cyl overlay applies, for the filed mockup. */
function shadeCylinder(c, bx, by, bw, bh){
  c.save();
  c.beginPath(); c.rect(bx, by, bw, bh); c.clip();
  const g = c.createLinearGradient(bx, 0, bx + bw, 0);
  [[0,'rgba(0,0,0,.50)'], [.07,'rgba(0,0,0,.22)'], [.18,'rgba(0,0,0,0)'],
   [.82,'rgba(0,0,0,0)'], [.93,'rgba(0,0,0,.22)'], [1,'rgba(0,0,0,.50)']]
    .forEach(([s0, col]) => g.addColorStop(s0, col));
  c.globalCompositeOperation = 'overlay';
  c.fillStyle = g; c.fillRect(bx, by, bw, bh);
  c.restore();
}

/* One wrapped tumbler on the stage: the photo (mirrored when the handle has to change
   sides), a canvas over the body box that drawViews() paints, and the shading. The canvas
   multiplies onto the photo: sublimation is ink on a white body, so the white of the file
   leaves the photo untouched and the body's own edges and shading show through the design
   instead of a flat, hard-edged rectangle sitting on top of it. */
/* On the Front view the handle is directly behind the body, but the photo is shot with it
   in profile — so it's cut off the photo there, right at the body's edge on its side, from
   the top of the print box down. Above that the photo is left whole, so the lid's rim (wider
   than the body) keeps its shape. It cuts 0.3% inside the edge: a 1.2% allowance past it
   left the Big Swig handle's mounting bosses showing, and even at the edge a sliver of the
   mug's handle (and its lower joint) did. Given as insets (fractions of the photo) plus `top`, for the
   stage's clip-path (handleClipCss) and the mockup's canvas clip (handleClipPath). */
function handleCut(vw){
  const hs = handleSide(S.product);
  if (!hs || vw.c !== 0.5) return null;
  const a = area(), m = -0.003, top = Math.max(0, a.y - a.h/2);
  return hs === 'right' ? {l: 0, r: Math.max(0, 1 - (a.x + a.w/2) - m), top}
                        : {l: Math.max(0, a.x - a.w/2 - m), r: 0, top};
}
/* The kept region: the whole photo above `top`, and only the body's side of the cut below. */
function handleCutPoints(cut){
  const L = cut.l, R = 1 - cut.r, T = cut.top;
  return cut.r ? [[0,0],[1,0],[1,T],[R,T],[R,1],[0,1]]
               : [[0,0],[1,0],[1,1],[L,1],[L,T],[0,T]];
}
const handleClipCss = cut => 'polygon(' + handleCutPoints(cut)
  .map(([x, y]) => `${(x*100).toFixed(2)}% ${(y*100).toFixed(2)}%`).join(', ') + ')';
function handleClipPath(c, cut, ox, oy, w, h){
  c.beginPath();
  handleCutPoints(cut).forEach(([x, y], i) => c[i ? 'lineTo' : 'moveTo'](ox + x * w, oy + y * h));
  c.closePath();
}

function wrapView(vw){
  const a = area(), flip = wrapViewFlip(vw);
  const cx = flip ? 1 - a.x : a.x;
  const pct = n => (n*100)+'%';
  const frame = `left:${pct(cx-a.w/2)}; top:${pct(a.y-a.h/2)}; width:${pct(a.w)}; height:${pct(a.h)};`;
  const cut = handleCut(vw);
  const img = el('img',{class:'base', src:S.variant.img, alt:pname(S.product),
    style:(flip ? 'transform:scaleX(-1);' : '')
        + (cut ? `clip-path:${handleClipCss(cut)};` : '')});
  img.addEventListener('load', () => scheduleViews());
  return el('div',{class:'view'},
    el('div',{class:'mock tv'}, img,
      // The print and its light, blended together first (isolated) and only then multiplied
      // onto the photo — so the light touches the print and never the photo's own white.
      // The canvas has a white base (.tvc): the light layers cover the whole print box, and
      // overlay/screen onto a *transparent* pixel paint the gradient itself — which Safari
      // showed as hairlines round the box, most visibly across the Big Swig's narrower base.
      // Onto white both leave white, and white multiplies onto the photo as nothing.
      el('div',{class:'tvp', style:frame},
        el('canvas',{class:'tvc', 'data-c':String(vw.c), 'data-f':flip ? '1' : ''}),
        el('div',{class:'cyl-shade'}), el('div',{class:'cyl-gloss'}),
        // The bottom band's own light, narrowed with the band (lightLayers).
        el('div',{class:'cyl-shade bandl'}), el('div',{class:'cyl-gloss bandl'})),
      el('div',{class:'cyl', style:frame})),
    el('span',{class:'vlab'}, vw.label));
}

/* Repaints every wrapped view from one flat render. Coalesced to a frame (with a timer
   behind it, since a background tab never gets one), so a drag that moves forty times a
   second redraws at most once per frame. */
let viewsQueued = false;
/* True while a piece in the design area is being dragged, sized or turned. Set in the
   capture phase, so it's already false when the gesture's own pointerup re-renders. */
let gesturing = false;
document.addEventListener('pointerdown', e => {
  if (e.target.closest && e.target.closest('#hogg-customizer .sbx')) gesturing = true;
}, true);
['pointerup', 'pointercancel'].forEach(t => document.addEventListener(t, () => {
  if (gesturing){ gesturing = false; scheduleViews(); }
}, true));

function scheduleViews(){
  if (viewsQueued) return;
  viewsQueued = true;
  const go = () => { if (!viewsQueued) return; viewsQueued = false; drawViews(); };
  requestAnimationFrame(go); setTimeout(go, 80);
}
/* Where the product actually is in its photo — [left, right, top, bottom] as fractions,
   straw, handle and all. Cached per photo. The photos are square with a slim tumbler in
   the middle, so three views side by side were mostly white space. */
const PHOTO_BOUNDS = new Map();
function photoBounds(photo){
  if (!photo) return null;
  if (PHOTO_BOUNDS.has(photo.src)) return PHOTO_BOUNDS.get(photo.src);
  let b = null;
  try {
    const W = 300, H = Math.round(W * photo.naturalHeight / photo.naturalWidth);
    const cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    const c = cv.getContext('2d', {willReadFrequently: true});
    c.drawImage(photo, 0, 0, W, H);
    const d = c.getImageData(0, 0, W, H).data;
    let lo = W, hi = -1, top = H, bot = -1;
    for (let y = 0; y < H; y++) for (let x = 0; x < W; x++){
      const i = (y * W + x) * 4;
      if (d[i] < 244 || d[i+1] < 244 || d[i+2] < 244){
        if (x < lo) lo = x; if (x > hi) hi = x; if (y < top) top = y; if (y > bot) bot = y;
      }
    }
    if (hi > lo && bot > top) b = [lo / W, (hi + 1) / W, top / H, (bot + 1) / H];
  } catch (e) { b = null; }
  PHOTO_BOUNDS.set(photo.src, b);
  return b;
}

/* Trims a view to its product (plus a little air) with clip-path, and takes the trimmed
   space back with negative margins — so the views sit together, and each label sits under
   its tumbler rather than under the photo's empty floor. */
function trimView(mock, photo, flip, centre){
  if (!mock) return;
  const b = photoBounds(photo), W = mock.offsetWidth, H = mock.offsetHeight;
  if (!b || !W) return;
  let [l, r] = flip ? [1 - b[1], 1 - b[0]] : [b[0], b[1]];
  const t = Math.max(0, b[2] - 0.02), bt = Math.min(1, b[3] + 0.02);
  const cut = handleCut({c: centre});                  // the front view's handle is cut off
  if (cut){ l = Math.max(l, flip ? cut.r : cut.l); r = Math.min(r, 1 - (flip ? cut.l : cut.r)); }
  const m = 0.03;
  l = Math.max(0, l - m); r = Math.min(1, r + m);
  const key = `${W}|${H}|${l.toFixed(3)}|${r.toFixed(3)}|${t.toFixed(3)}|${bt.toFixed(3)}`;
  if (mock.dataset.trim === key) return;
  mock.dataset.trim = key;
  const pc = v => (v * 100).toFixed(2) + '%';
  mock.style.clipPath = `inset(${pc(t)} ${pc(1 - r)} ${pc(1 - bt)} ${pc(l)})`;
  mock.style.margin = `${(-t * H).toFixed(1)}px ${(-(1 - r) * W).toFixed(1)}px ${(-(1 - bt) * H).toFixed(1)}px ${(-l * W).toFixed(1)}px`;
}

function drawViews(){
  const sb = document.querySelector('#hogg-customizer canvas.sbx-bg');
  if (sb){
    const bg = wrapBgCanvas(cachedImg), r = sb.getBoundingClientRect();
    if (bg && r.width){
      sb.width = Math.round(r.width * Math.min(2, window.devicePixelRatio || 1));
      sb.height = Math.round(sb.width * bg.height / bg.width);
      const sc = sb.getContext('2d');
      // A big downscale at the default quality samples rather than averages, so fine
      // lines like pinstripes come out at uneven weights.
      sc.imageSmoothingEnabled = true; sc.imageSmoothingQuality = 'high';
      if (S.wrapBg.kind === 'pinstripes'){
        sc.fillStyle = '#FFFFFF'; sc.fillRect(0, 0, sb.width, sb.height);
        sc.fillStyle = S.wrapBg.color;
        drawPinstripes(sc, pinstripeCount(bg.width), sb.width, sb.height);
      } else sc.drawImage(scaledCopy(BG_CACHE.key, bg, sb.width, sb.height), 0, 0);
    }
  }
  const cvs = document.querySelectorAll('#hogg-customizer canvas.tvc');
  if (!cvs.length || !isSub()) return;
  /* The flat render only as big as the views can use: tall enough for the tallest view,
     wide enough that the middle of a view (where the file is least compressed) still gets
     a pixel per column. 1,400 across was twice what a Skinny's views take. */
  const dprV = Math.max(3, (window.devicePixelRatio || 1) * 1.5);
  let maxW = 0, maxH = 0;
  cvs.forEach(cv => { const r = cv.getBoundingClientRect(); maxW = Math.max(maxW, r.width * dprV); maxH = Math.max(maxH, r.height * dprV); });
  const need = Math.max(maxH * areaW() / areaH(), Math.PI * maxW / circK()) * 1.05;
  const flat = flatWrap(Math.round(Math.min(1400, Math.max(600, need))));
  const band = S.artB ? cachedImg(S.artB.src) : null;
  const photo = cachedImg(S.variant.img);
  /* At least 3x, whatever the screen: a Skinny's body is ~40 CSS px wide, and drawn at 1:1
     on a standard-density (typically Windows) display every column and every step of the
     rim curve was a whole visible pixel — the views looked jagged there and fine on a Mac. */
  const dpr = Math.max(3, (window.devicePixelRatio || 1) * 1.5);
  cvs.forEach(cv => {
    const r = cv.getBoundingClientRect();
    if (!r.width || !r.height) return;          // photo not laid out yet — its load redraws
    cv.width = Math.round(r.width * dpr); cv.height = Math.round(r.height * dpr);
    const c = cv.getContext('2d');
    // White, not clear: the light layers blend with this canvas, and overlay and screen
    // leave white alone, so only the print picks them up; white multiplies onto the photo
    // as nothing.
    c.fillStyle = '#FFFFFF'; c.fillRect(0, 0, cv.width, cv.height);
    const centre = +cv.getAttribute('data-c');
    const flip = !!cv.getAttribute('data-f');
    trimView(cv.closest('.mock.tv'), photo, flip, centre);
    if (flat) paintBody(c, flat, band, centre, cv.width, cv.height, photo, flip, true);
    lightLayers(cv.parentElement, flat ? lightProfile(photo, flip) : null, photo);
  });
}

/* The sandbox: the whole wrap, flat, at its real proportions. Editing works exactly as it
   does on a UV tumbler — the same layer nodes, frame and handles — because it is built as
   a `.mock` whose print area is the entire element (editBox()). */
function sandbox(){
  const W = areaW(), H = areaH();
  // Typing longer text, a cleanup that changes a logo's shape, a size change — any of them
  // can push a piece past the edge, so every draw of the design area re-clamps.
  printing().forEach(clampToArea);
  const clip = el('div',{class:'clip', style:'inset:0'});
  // The background, painted by drawViews() from the same full-size canvas the views use.
  if (bgActive()) clip.appendChild(el('canvas',{class:'sbx-bg'}));
  printing().forEach(l => {
    if (!l.src || isTile(l)) return;
    clip.appendChild(layerNode(l));
    // Ghosts one wrap-width either side: a piece dragged over the seam shows up on the
    // other edge as well, which is what will happen on the tumbler. Not where the wrap
    // stops short of the handle (the mug) — past its edge a piece is simply trimmed.
    if (wrapsRound()) [-1, 1].forEach(d => {
      const g = layerNode(l); g.classList.add('ghost');
      g.style.left = (l.x + d) * 100 + '%';
      clip.appendChild(g);
    });
  });
  const hf = handleFrac();
  const zone = side => el('div',{class:'hzone '+side, style:`width:${hf/2*100}%`},
    el('span',{}, 'Handle'));
  const box = el('div',{class:'mock sbx',
      style:`width:min(100%, calc(330px * ${W} / ${H})); aspect-ratio:${W} / ${H};`},
    clip,
    hf ? zone('l') : null, hf ? zone('r') : null,
    el('span',{class:'guide v'}), el('span',{class:'guide h'}));
  const sel = selected();
  if (sel && sel.src && !isTile(sel)) box.appendChild(frameFor(sel));
  box.addEventListener('pointerdown', e => {
    const hit = e.target.closest('.art');   // a ghost is the same piece, seen across the seam
    const id = hit && +hit.getAttribute('data-id');
    const hl = id && layerById(id);
    if (hl && isEmptySpot(hl)){ e.preventDefault(); S.sel = id; return pickSpot(hl); }
    if (id){ S.sel = id; return startMove(e, hl); }
    if (!e.target.closest('.frame')){ S.sel = null; render(true); }
  });
  return el('div',{class:'sbx-wrap'},
    el('div',{class:'sbx-hd'}, el('b',{}, 'Design area'), el('span',{}, `${px(W)} × ${px(H)} px`)),
    box);
}

function subStage(){
  const views = el('div',{class:'views tviews'}, WRAP_VIEWS.map(wrapView));
  scheduleViews();
  /* Nothing to design on yet: greyed out, pointing at the panel. Without this the empty
     design area reads as the place to start, and there is nothing to do in it until a
     piece has been added on the right. */
  // The starter state: nothing chosen on the right yet (no template on Create your own,
  // no file on Upload full wrap).
  const empty = sandboxMode() ? (S.artTab === 'logo' ? !S.tpl.id : !printing().length) && !bgActive() : !S.art;
  return el('div',{class:'stage sub-stage'+(empty ? ' is-empty' : '')},
    sandboxMode() ? sandbox() : null,
    views,
    empty ? el('div',{class:'empty-ov'},
      el('div',{}, el('b',{}, 'Select a design option to start'),
        el('span',{}, S.artTab === 'pet' ? 'Pick a template and add your pet’s photo on the right.'
                    : S.artTab === 'upload' ? 'Upload your wrap on the right.'
                    : 'Pick a template, or start from scratch, on the right.'))) : null,
    S.fxBusy ? enhancing() : null);
}

/* Where the print area sits in the element being edited, as fractions of it: the box on
   the photo for UV (mirrored on a two-sided design's back), the whole sandbox otherwise. */
const SNAP = 0.05;              // how close to a centre line, as a fraction of the area, snaps to it
const editBox = () => sandboxMode() ? {x: 0.5, y: 0.5, w: 1, h: 1}
                                    : {x: areaX(), y: area().y, w: area().w, h: area().h};

function stage(){
  const st = stageBody();
  st.appendChild(histButtons());
  if (S.crop){ const cvw = cropView(); if (cvw) st.appendChild(cvw); }
  if (S.logoFx){ const lv = logoView(); if (lv) st.appendChild(lv); }
  if (S.wrapPos){ const wv = wrapPosView(); if (wv) st.appendChild(wv); }
  return st;
}
function stageBody(){
  if (isSub()) return subStage();
  /* UV: the front and the back, always, side by side and trimmed to the tumbler so they sit
     close and the tumbler fills the stage (trimUvViews). The side being edited takes the
     pieces; pressing the other switches to it. */
  // Nothing added yet: greyed out and pointing at the panel, as the sublimation stage is.
  const empty = !printing().length;
  const st = el('div',{class:'stage wrap-stage uv-stage'+(empty ? ' is-empty' : '')},
    el('div',{class:'views'}, sideViews().map(vw =>
      el('div',{class:'view'},
        mockView({...vw, edit: vw.side === S.side}, false),
        el('span',{class:'vlab'}, vw.label)))),
    empty ? el('div',{class:'empty-ov'},
      el('div',{}, el('b',{}, 'Add a design to start'))) : null,
    S.fxBusy ? enhancing() : null);
  // Once each photo is laid out: before that a view is zero wide and there's nothing to trim.
  st.querySelectorAll('img.base').forEach(i => i.addEventListener('load', trimUvViews));
  requestAnimationFrame(trimUvViews);
  return st;
}
/* Crops each UV view to the tumbler (photoBounds, via the CORS-loaded copy of the photo) and
   takes the empty space back — the photos are square with a slim tumbler in the middle. */
function trimUvViews(){
  const photo = cachedImg(S.variant.img);
  if (!photo){ const i = IMG_CACHE.get(S.variant.img); if (i) i.addEventListener('load', trimUvViews, {once:true}); return; }
  const a = area();
  document.querySelectorAll('#hogg-customizer .uv-stage .mock').forEach((m, k) => {
    const flip = sideViews()[k] && sideViews()[k].flip;
    trimView(m, photo, flip, null);
    /* Centre the label under the tumbler's body, not under the trimmed photo — a handle on
       one side would otherwise pull it off-centre. The body's centre is the print box's. */
    const b = photoBounds(photo), lab = m.parentElement && m.parentElement.querySelector('.vlab');
    if (!b || !lab) return;
    const [l, r] = flip ? [1 - b[1], 1 - b[0]] : [b[0], b[1]];
    const cx = flip ? 1 - a.x : a.x;
    lab.style.transform = `translateX(${((cx - (l + r) / 2) * m.offsetWidth).toFixed(1)}px)`;
  });
}

/* Shown over the stage while processLayer()/refitWrap() work.

   It names the step it is on rather than spinning anonymously, because the steps
   are real — background knockout, trim, and the resample up to print size all
   genuinely run here — and a customer who can see what was done to their file is
   likelier to trust the result than one watching an unlabelled spinner. */
function enhancing(){
  const steps = [];
  const l = useLayers() ? selected() : null;
  if (!useLayers()) steps.push('Fitting to the wrap');
  else if (l && l.kind === 'img'){
    if (l.fx.removeBg) steps.push('Removing the background');
    if (l.fx.trim) steps.push('Trimming empty space');
    if (l.fx.ink !== 'original') steps.push('Recoloring the ink');
  }
  steps.push('Sizing it for print');
  return el('div',{class:'enhance'},
    el('div',{class:'ring'}),
    el('div',{}, el('b',{}, 'Preparing your artwork'), ' ', steps.join(' · ')));
}

/* On-screen aspect of the print-area box. Built to equal areaW/areaH, so
   fitting inside it on screen means fitting inside it on the press. */
function clipAR(){
  const a = area(), v = S.variant;
  return (a.w * v.iw) / (a.h * v.ih);
}

/* The print area's TRUE aspect, which is what artwork has to be fitted against.

   Not the same as clipAR(): the box on the photo is deliberately foreshortened
   horizontally (printed_arc_fraction — a 3" print wraps, so it looks narrower than
   3" head-on), so its on-screen aspect is not the aspect of the flat print. Fitting
   against the on-screen box and then reporting the result in print pixels stretches
   the artwork by exactly the foreshortening ratio: ~9% on a Modern Curve, and 20%
   on a straight-sided product now that its area is the full surface. Fitting in
   print space instead makes the printed aspect exact, and drawing that fit into the
   foreshortened box is what makes the preview look right at the same time. */
function printAR(){ return layerAreaW() / areaH(); }

/* Art scaled to `contain` within the print area at full size, as a % of that box.
   Deliberately carries no scale of its own: each layer owns its `s`, and layerBox()
   applies it. Baking the scale in here is what made the old single-art model
   impossible to extend to more than one piece. */
function fitPct(artAR){
  const c = printAR();
  return artAR >= c ? {w: 100, h: 100 * (c / artAR)}
                    : {w: 100 * (artAR / c), h: 100};
}

/* What a layer actually measures on the press, in real pixels. */
function printedPx(l){
  const b = layerBox(l);
  return {w: Math.round(layerAreaW() * b.w), h: Math.round(areaH() * b.h)};
}

/* One layer on the stage. Only the artwork lives inside the clip — the selection
   chrome is drawn separately (see frameFor) because the clip has overflow:hidden
   and would slice every handle in half. */
function layerNode(l){
  const b = layerBox(l);
  const n = el('div',{class:'art', 'data-id':l.id});
  n.appendChild(el('img',{src:l.src, alt:'',
    style:'width:100%;height:100%;object-fit:contain'+(l.flip?';transform:scaleX(-1)':'')}));
  n.style.cssText += `
    width:${b.w*100}%; height:${b.h*100}%;
    left:${l.x*100}%; top:${l.y*100}%;
    transform:translate(-50%,-50%) rotate(${l.rot||0}deg);`;
  return n;
}

/* The print area's centre across the photo, for the view being edited — mirrored on the
   back of a two-sided design, whose photo is flipped (see mockView). */
const areaX = () => uvSides() && sideFlip(S.side) ? 1 - area().x : area().x;

/* Selection frame and the four corner handles, positioned over the clip rather
   than inside it.

   The corners follow the arrangement customers already know from every sticker
   editor: move bottom-left, resize bottom-right, delete top-right. Top-left is
   **flip**, not the rotate its position usually implies — rotation on a curved
   printed face was removed deliberately (see NOTES) and nothing about layers
   brings it back, whereas flipping a logo is a real thing people want. */
function frameFor(l){
  const b = layerBox(l);
  const a = editBox();
  // From fractions of the print area to fractions of the element being edited.
  const w = b.w * a.w, h = b.h * a.h;
  const cx = (a.x - a.w/2) + l.x * a.w, cy = (a.y - a.h/2) + l.y * a.h;
  const f = el('div',{class:'frame', style:
    `left:${(cx-w/2)*100}%; top:${(cy-h/2)*100}%; width:${w*100}%; height:${h*100}%;`
    + (l.rot ? ` transform:rotate(${l.rot}deg);` : '')});
  const handle = (cls, label, title, onDown) => {
    const el2 = el('button',{class:'hnd '+cls, title, 'aria-label':title}, label);
    if (onDown) el2.addEventListener('pointerdown', onDown);
    return el2;
  };
  f.appendChild(el('div',{class:'frame-ring'}));
  f.appendChild(handle('tl','','Rotate', e => startRotate(e, l)));
  f.appendChild(handle('tr','✕','Remove', e => {
    e.preventDefault(); e.stopPropagation();
    removeLayer(l.id);
  }));
  f.appendChild(handle('bl','','Move', e => startMove(e, l)));
  f.appendChild(handle('br','','Resize', e => startResize(e, l)));
  return f;
}

/* Keeps a sandbox piece wholly inside the wrap: shrunk if its (rotated) bounds are larger
   than the wrap, then moved in until no edge is past the design area's. A piece hanging
   off the edge left its corner handles off-screen too, so it could no longer be resized.
   UV keeps its own rules (its area crops). */
function clampToArea(l){
  if (!sandboxMode()) return;
  const W = areaW(), H = areaH(), th = (l.rot || 0) * Math.PI / 180;
  const ext = () => {
    const b = layerBox(l), bw = b.w * W, bh = b.h * H;
    const c = Math.abs(Math.cos(th)), s0 = Math.abs(Math.sin(th));
    return [bw * c + bh * s0, bw * s0 + bh * c];
  };
  let [ew, eh] = ext();
  if (l.wrap){ clampWrap(l, ew / W / 2, eh / H / 2); return; }
  const k = Math.min(1, W / ew, H / eh);
  if (k < 1){ l.s *= k * 0.999; [ew, eh] = ext(); }
  const hx = ew / W / 2, hy = eh / H / 2;
  l.x = Math.min(1 - hx, Math.max(hx, l.x));
  l.y = Math.min(1 - hy, Math.max(hy, l.y));
}

/* An uploaded full wrap can be zoomed past the wrap and cropped (that's what Fill does),
   so it isn't shrunk to fit like other pieces. On each axis it either stays inside (when
   it's smaller) or keeps covering (when it's larger) — moving it never opens a white gap
   at one edge that wasn't there. `hx`, `hy`: half its size, as fractions of the wrap. */
function clampWrap(l, hx, hy){
  const fit = (v, h) => h <= 0.5 ? Math.min(1 - h, Math.max(h, v)) : Math.min(h, Math.max(1 - h, v));
  l.x = fit(l.x, hx); l.y = fit(l.y, hy);
}

/* Puts a piece's nodes and selection frame where its state says, mid-gesture. */
function syncPiece(mock, l){
  const b = layerBox(l), a = editBox();
  mock.querySelectorAll(`.art[data-id="${l.id}"]`).forEach(n => {
    n.style.width = b.w*100 + '%'; n.style.height = b.h*100 + '%';
    n.style.left = l.x*100 + '%'; n.style.top = l.y*100 + '%';
    n.style.transform = `translate(-50%,-50%) rotate(${l.rot || 0}deg)`;
  });
  const frame = mock.querySelector('.frame');
  if (frame){
    const w = b.w * a.w, h = b.h * a.h;
    const cx = (a.x - a.w/2) + l.x * a.w, cy = (a.y - a.h/2) + l.y * a.h;
    frame.style.cssText = `left:${(cx-w/2)*100}%; top:${(cy-h/2)*100}%; width:${w*100}%; height:${h*100}%;`
      + (l.rot ? ` transform:rotate(${l.rot}deg);` : '');
  }
}

/* ---------- pointer interactions ----------
   Both of these mutate the DOM directly while the pointer is down and only call
   render() on release. Re-rendering mid-drag destroys the element the pointer
   captured, which is exactly the bug the sliders had. */

function clipRect(node){
  const mock = node.closest('.mock');
  return mock ? mock.querySelector('.clip').getBoundingClientRect() : null;
}

function startMove(e, l){
  e.preventDefault(); e.stopPropagation();
  const r = clipRect(e.target);
  if (!r) return;
  const mock = e.target.closest('.mock');
  const node = mock.querySelector(`.art[data-id="${l.id}"]`);
  const frame = mock.querySelector('.frame');
  const b = layerBox(l), a = editBox(), wraps = sandboxMode() && wrapsRound();
  const ghosts = [...mock.querySelectorAll(`.art.ghost[data-id="${l.id}"]`)];
  const gv = mock.querySelector('.guide.v'), gh = mock.querySelector('.guide.h');
  const grabX = e.clientX - (r.left + l.x * r.width);
  const grabY = e.clientY - (r.top  + l.y * r.height);
  e.target.setPointerCapture(e.pointerId);
  const move = ev => {
    // Round a wrap, sideways movement has no end: it's taken back into range on release.
    const nx = (ev.clientX - grabX - r.left) / r.width;
    l.x = wraps ? Math.min(2, Math.max(-1, nx)) : Math.min(1, Math.max(0, nx));
    l.y = Math.min(1, Math.max(0, (ev.clientY - grabY - r.top)  / r.height));
    /* Centring by eye is the one thing a drag is bad at, so the middle is sticky: within
       SNAP of either centre line the piece locks onto it, and that guide lights up. */
    const sx = Math.abs(l.x - 0.5) < SNAP, sy = Math.abs(l.y - 0.5) < SNAP;
    if (sx) l.x = 0.5;
    if (sy) l.y = 0.5;
    clampToArea(l);
    if (gv) gv.classList.toggle('on', l.x === 0.5);
    if (gh) gh.classList.toggle('on', l.y === 0.5);
    if (sandboxMode()){ syncPiece(mock, l); scheduleViews(); return; }
    if (node){ node.style.left = l.x*100 + '%'; node.style.top = l.y*100 + '%'; }
    ghosts.forEach((g, i) => { g.style.left = (l.x + (i ? 1 : -1))*100 + '%'; g.style.top = l.y*100 + '%'; });
    if (frame){
      const w = b.w * a.w, h = b.h * a.h;
      const cx = (a.x - a.w/2) + l.x * a.w, cy = (a.y - a.h/2) + l.y * a.h;
      frame.style.left = (cx - w/2)*100 + '%';
      frame.style.top  = (cy - h/2)*100 + '%';
    }
  };
  const up = ev => {
    if (wraps) l.x -= Math.floor(l.x);
    e.target.releasePointerCapture(ev.pointerId);
    e.target.removeEventListener('pointermove', move);
    e.target.removeEventListener('pointerup', up);
    render(true);
  };
  e.target.addEventListener('pointermove', move);
  e.target.addEventListener('pointerup', up);
}

/* Rotation, dragged from the top-left handle.

   Snapped to whole degrees, and pulled to the nearest right angle within 5° —
   almost nobody wants 89°, and an accidental half-degree tilt on a logo is the
   kind of thing that gets noticed only once it is printed. */
function startRotate(e, l){
  e.preventDefault(); e.stopPropagation();
  const r = clipRect(e.target);
  if (!r) return;
  const mock = e.target.closest('.mock');
  const node = mock.querySelector(`.art[data-id="${l.id}"]`);
  const frame = mock.querySelector('.frame');
  const cxPx = r.left + l.x * r.width, cyPx = r.top + l.y * r.height;
  const ang = ev => Math.atan2(ev.clientY - cyPx, ev.clientX - cxPx) * 180 / Math.PI;
  const start = ang(e), rot0 = l.rot || 0;
  e.target.setPointerCapture(e.pointerId);
  const move = ev => {
    let d = Math.round(rot0 + (ang(ev) - start));
    d = ((d % 360) + 360) % 360;
    for (const snap of [0, 90, 180, 270, 360])
      if (Math.abs(d - snap) <= 5) d = snap % 360;
    l.rot = d;
    if (sandboxMode()){ clampToArea(l); syncPiece(mock, l); scheduleViews(); return; }
    mock.querySelectorAll(`.art[data-id="${l.id}"]`).forEach(n =>
      n.style.transform = `translate(-50%,-50%) rotate(${d}deg)`);
    if (frame) frame.style.transform = `rotate(${d}deg)`;
  };
  const up = ev => {
    e.target.releasePointerCapture(ev.pointerId);
    e.target.removeEventListener('pointermove', move);
    e.target.removeEventListener('pointerup', up);
    render(true);
  };
  e.target.addEventListener('pointermove', move);
  e.target.addEventListener('pointerup', up);
}

function startResize(e, l){
  e.preventDefault(); e.stopPropagation();
  const r = clipRect(e.target);
  if (!r) return;
  const mock = e.target.closest('.mock');
  const node = mock.querySelector(`.art[data-id="${l.id}"]`);
  const frame = mock.querySelector('.frame');
  const a = editBox();
  // On a wrap a piece can be as large as the design area — clampToArea() stops it there.
  // A UV print can't exceed its area.
  const maxS = sandboxMode() ? 4 : 1;
  // Distance from the layer's own centre, so the drag scales about it and the
  // artwork doesn't walk across the tumbler while being resized.
  const cxPx = r.left + l.x * r.width, cyPx = r.top + l.y * r.height;
  const start = Math.hypot(e.clientX - cxPx, e.clientY - cyPx) || 1;
  const s0 = l.s;
  e.target.setPointerCapture(e.pointerId);
  const move = ev => {
    const d = Math.hypot(ev.clientX - cxPx, ev.clientY - cyPx);
    l.s = Math.min(maxS, Math.max(0.08, s0 * (d / start)));
    if (sandboxMode()){ clampToArea(l); syncPiece(mock, l); scheduleViews(); return; }
    const b = layerBox(l);
    mock.querySelectorAll(`.art[data-id="${l.id}"]`).forEach(n => {
      n.style.width = b.w*100 + '%'; n.style.height = b.h*100 + '%'; });
    if (frame){
      const w = b.w * a.w, h = b.h * a.h;
      const cx = (a.x - a.w/2) + l.x * a.w, cy = (a.y - a.h/2) + l.y * a.h;
      frame.style.cssText = `left:${(cx-w/2)*100}%; top:${(cy-h/2)*100}%; width:${w*100}%; height:${h*100}%;`
        + (l.rot ? ` transform:rotate(${l.rot}deg);` : '');
    }
  };
  const up = ev => {
    e.target.releasePointerCapture(ev.pointerId);
    e.target.removeEventListener('pointermove', move);
    e.target.removeEventListener('pointerup', up);
    render(true);
  };
  e.target.addEventListener('pointermove', move);
  e.target.addEventListener('pointerup', up);
}

function stageFoot(){
  // The UV print area is always outlined (no Show print area toggle): it's the thing
  // every piece is placed against.
  return el('div',{class:'stage-foot'},
    el('span',{}, isSub() ? 'Preview is approximate.'
                          : (printing().length ? 'Drag to move. Corners: rotate, remove, move, resize.'
                                               : 'Add a design to get started.')),
  );
}

/* ---------- artwork validation (all pixels) ---------- */
const px = n => n.toLocaleString('en-US');

/* Does this product need a separate bottom panel? The tapered Big Swig bodies do. */
const bottomSpec = () => { const z = sizeSpec(); return z.bottomW ? {w:z.bottomW, h:z.bottomH} : null; };

/* ---------- the layer stack (UV) ----------
   Four ways in, matching what a customer arrives wanting: their own file, some
   words, initials, or a jersey mark. Everything after that is the same — a layer
   on the stack, moved and sized on the tumbler itself. */
/* The pieces panel. On a sublimation Create your own tab it leads with the "Start with"
   choices (templates, then Start from scratch last) and shows the add buttons only once one
   is picked — before that, the templates are the thing to look at. UV goes straight to the
   add buttons.

   Every text-ish piece is edited right in its row of the list — a template's "The
   Johnsons" is just a Text piece whose box says The Johnsons — so there is one way to
   change wording whether it came from a template or was added by hand. */
function layerStackUI(){
  const wrap = el('div',{});
  const starter = isSub() && S.artTab === 'logo';
  if (starter){
    wrap.appendChild(templateUI());
    if (!S.tpl.id) return wrap;
  }
  const add = (label, fn) => el('button',{class:'addbtn', onclick:fn}, el('b',{}, label));
  /* Photo and Logo stay separate: a logo is cleaned up (background removed, trimmed) and a
     photo never should be — it keeps the whole picture, in a frame. Both are drawn as
     upload buttons (dashed, arrow) so they read as "choose a file", not as a style. */
  const logoIn = el('input',{type:'file', accept:'image/*', class:'hidden',
    onchange:e=>{ if (e.target.files[0]) loadImageLayer(e.target.files[0]); }});
  const photoIn = el('input',{type:'file', accept:'image/*', class:'hidden',
    onchange:e=>{ if (e.target.files[0]) addPhotoLayer(e.target.files[0]); }});
  const upload = (label, sub, inp) => el('button',{class:'upbtn', onclick:()=>inp.click()},
    el('span',{class:'up-ic'}, '↑'), el('span',{}, el('b',{}, label), el('em',{}, sub)));
  const addBox = el('div',{class:'addbox'},
    el('div',{class:'addgrid'},
      upload('Upload photo', 'People, pets, family', photoIn),
      upload('Upload logo', 'Logo or artwork', logoIn),
      photoIn, logoIn),
    el('div',{class:'addgrid three'},
      add('Text', ()=>addTextLayer('text')),
      add('Monogram', ()=>addTextLayer('monogram')),
      add('Jersey', ()=>addTextLayer('jersey'))));
  if (S.artError) addBox.appendChild(el('div',{class:'note bad', style:'margin-top:10px'},
    el('span',{class:'ni'}, '!'), el('div',{}, S.artError)));

  /* "+ Add a piece" / "+ Add another piece" is always a line item that opens and closes.
     Open, the options sit inside the same dashed outline as the row that opened them, so
     they read as one section rather than spilling into the panel. With nothing on the
     design yet it starts open (the options are the next step) unless it's been closed. */
  const none = uvSides() ? !printing().length : !S.layers.length;
  const open = none ? !S.addShut : S.addOpen;
  // UV: once there's a piece, the next one can go on either side — asked where it's added.
  // Under the options, as each card's own Side switch sits under its settings.
  if (uvSides() && !none) addBox.appendChild(el('div',{class:'add-side'},
    el('span',{}, 'Add to'), sideSwitch(S.side, sd => { S.side = sd; S.sel = null; render(true); })));
  const addHead = el('button',{class:'lrow add-row'+(open?' open':''),
    onclick:()=>{ if (none) S.addShut = open; else S.addOpen = !open; render(true); }},
    el('span',{class:'plus'}, open ? '−' : '+'), el('span',{}, none ? 'Add a design' : 'Add another design'),
    // On UV, once there's a piece anywhere, the next one costs extra — said where it's added.
    uvSides() && inked().length ? el('span',{class:'two-side-price add-price'}, '+' + fmt(EXTRA_PRICE)) : null);
  const addSect = open ? el('div',{class:'add-sect'}, addHead, addBox) : addHead;
  const opts = starter ? templateOptionsUI() : null;

  if (none){
    wrap.appendChild(el('div',{class:'layers', style:'margin-top:12px'}, addSect));
    if (opts) wrap.appendChild(opts);
    return wrap;
  }
  /* Listed in the order they sit on the design — top to bottom, then left to right — so a
     template's photo spots come before its name and date, the way they read. The last
     row is "+ Add another piece": adding is adding a line to this list, and a row that
     looks like the others says so better than a block of buttons under a heading did. */
  // In the order the pieces were added (a template adds its own in reading order).
  // Sorting by position re-ordered the rows under the customer's hand mid-drag.
  // UV lists both sides together, in the order added; each card says which side it's on.
  const reading = uvSides() ? printing().slice().sort((a, b) => a.id - b.id) : S.layers;
  /* The selected piece's card opens to hold its editor — the font and color controls are
     part of that piece's card, and the card closes back to one line when it's deselected. */
  const sel = selected();
  // Text-ish cards are always open (their font and color are the point); anything else
  // shows its extras only while selected.
  const list = el('div',{class:'layers', style:'margin-top:12px'},
    reading.map(l => {
      const row = pieceRow(l, TEXTISH.includes(l.kind) || l === sel ? layerEditor(l) : null);
      if (!uvSides()) return row;
      /* Anything done in this card acts on the side the piece is on — the editing path
         works through S.layers, the side being edited — so its side is made current first
         (capture phase, ahead of the card's own handlers). */
      row.addEventListener('pointerdown', () => { S.side = sideOf(l); }, true);
      row.classList.add('has-side');
      row.appendChild(el('div',{class:'row-side', onclick:e=>e.stopPropagation()},
        el('span',{}, 'Side'), sideSwitch(sideOf(l), sd => movePiece(l, sd))));
      return row;
    }));
  list.appendChild(addSect);
  wrap.appendChild(list);
  if (opts) wrap.appendChild(opts);
  return wrap;
}

/* Front | Back, as a small segmented switch. */
function sideSwitch(cur, set){
  return el('div',{class:'side-sw'}, [['front','Front'],['back','Back']].map(([sd, lab]) =>
    el('button',{class:cur === sd ? 'on' : '', onclick:e=>{ e.stopPropagation(); if (cur !== sd) set(sd); }}, lab)));
}
/* Moves a UV piece to the other side, keeping its place in the print area. */
function movePiece(l, sd){
  const from = sideOf(l);
  if (from === sd) return;
  S.sides[from] = S.sides[from].filter(x => x !== l);
  S.sides[sd].push(l);
  S.side = sd; S.sel = l.id;
  render(true);
}

/* A text box inside a list row. Typing re-bakes that piece and redraws the stage only —
   rebuilding the panel would take the box out from under the cursor. */
function rowInput(l, value, set, opts){
  return el('input',{type:'text', class:'row-in', value, ...(opts||{}),
    onclick:e=>e.stopPropagation(), onpointerdown:e=>e.stopPropagation(),
    oninput:e=>{ set(e.target.value); bake(l).then(liveStage); },
    // Typing doesn't re-render, so the edit is committed to the undo history on leaving
    // the box — one step per edit rather than one per keystroke.
    onchange:()=>recordHistory()});
}

/* How a text-ish piece's box looks: its own face and ink, so the wording is shown once, as
   it prints, rather than in a plain box beside a thumbnail of itself. */
function inkBoxStyle(l){
  const face = l.kind === 'jersey' ? LAYER_FONTS.block
             : LAYER_FONTS[l.font] || (l.kind === 'monogram' ? LAYER_FONTS.script : LAYER_FONTS.block);
  const [r, g, b] = hexRGB(l.color || '#111111');
  const light = (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.72;
  const big = l.font === 'script' || (l.kind === 'monogram' && !l.font) || face === LAYER_FONTS.block;
  // Always a plain white text box, so it reads as the place to type. Light ink (white text
  // on a dark tumbler) shows black here instead of on a dark box; the Color row shows the
  // real color.
  return `font-family:${face}; color:${light ? '#111111' : (l.color || '#111111')}; font-size:${big ? 19 : 15}px;`
       + (l.kind === 'jersey' ? ' text-transform:uppercase; letter-spacing:.02em;' : '');
}

const TEXTISH = ['text', 'monogram', 'jersey'];

/* Every row is one line in the same order: a thumbnail (none for text-ish pieces, whose
   box shows the wording as it prints), the one thing to do next on the left — Edit, or
   Add on an empty spot — then the middle (print quality, the text box, or a hint), then
   Swap for a photo or logo, then ✕. Same height, same places, whatever the piece. */
const PENCIL = '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M11.3 1.7a1.5 1.5 0 0 1 2.1 0l.9.9a1.5 1.5 0 0 1 0 2.1L5.6 13.4 2 14l.6-3.6 8.7-8.7z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
function pieceRow(l, ed){
  const stop = fn => e => { e.stopPropagation(); fn(); };
  const btn = (cls, icon, label, fn) => el('button',{class:cls, onclick:stop(fn)},
    icon ? el('span',{class:'ic', html:icon}) : null, label);
  const pickLogoInto = () => {
    const inp = el('input',{type:'file', accept:'image/*', class:'hidden'});
    inp.addEventListener('change', () => { if (inp.files[0]) loadImageLayer(inp.files[0], l); });
    document.body.appendChild(inp); inp.click(); setTimeout(() => inp.remove(), 60000);
  };
  const ink = inkBoxStyle.bind(null, l);
  const textish = TEXTISH.includes(l.kind), empty = isEmptySpot(l);
  const edit = fn => btn('edit-btn', PENCIL, 'Edit', fn);

  let lead = null, mid, swap = null;
  // Text-ish cards are always open, so they have no Edit: the box gets the width.
  if (l.kind === 'text'){
    mid = rowInput(l, l.text, v => { l.text = v || ' '; }, {'aria-label':'Text', style:ink()});
  } else if (l.kind === 'monogram'){
    mid = rowInput(l, l.letters, v => { l.letters = v.replace(/[^A-Za-z]/g,'').slice(0,3).toUpperCase(); },
      {maxlength:'3', style:'text-transform:uppercase; '+ink(), 'aria-label':'Initials'});
  } else if (l.kind === 'jersey'){
    mid = el('div',{class:'row-pair'},
      rowInput(l, l.name, v => { l.name = v; }, {'aria-label':'Name', placeholder:'Name', style:ink()}),
      rowInput(l, l.number, v => { l.number = v.replace(/\D/g,'').slice(0,3); },
        {'aria-label':'Number', placeholder:'#', inputmode:'numeric', maxlength:'3', class:'row-in num', style:ink()}));
  } else if (empty){
    // An empty spot's next step is filling it, so Add takes Edit's place.
    const what = l.kind === 'logospot' ? 'logo' : 'photo';
    lead = btn('edit-btn add', '+', `Add ${what}`, () => pickSpot(l));
    mid = el('div',{class:'row-hint'}, l.kind === 'logospot' && S.tpl.id === 'repeat'
      ? 'Your logo, repeated all over' : `Empty ${what} spot`);
  } else if (l.kind === 'photo' || (l.kind === 'img' && !l.wrap)){
    // No file name or pixel size: the thumbnail says which image, the quality says
    // what its size means for the print.
    lead = edit(() => l.kind === 'photo' ? openCrop(l) : openLogoFx(l));
    const q = qualityOf(l);
    mid = q ? qualityMini(q)
            : el('div',{class:'row-hint'}, isTile(l) ? 'Repeated all over' : '');
    swap = btn('row-act', null, 'Swap', l.kind === 'photo' ? () => pickPhotoFor(l) : pickLogoInto);
  } else {
    mid = el('div',{class:'row-hint'}, layerLabel(l));
  }

  return el('div',{class:'lrow'+(l.id===S.sel?' on':'')+(ed?' open':''),
      // An empty spot opens the picker; anything else is selected.
      onclick:e=>{ if (empty) return pickSpot(l);
                    /* Not from its own text box or controls, and not when it's already the
                       selected one: a drag-select in the box ends in a click on the card, and
                       re-rendering then replaced the box — the selection (and focus) with it. */
                    if (e.target.closest('input, select, textarea, label, .row-ed, .row-side')) return;
                    if (S.sel === l.id) return;
                    S.sel=l.id; S.zoom=true; render(true); }},
    textish ? null : empty ? el('span',{class:'thumb thumb-empty'}, '+')
                           : el('img',{class:'thumb', src:l.src || '', alt:''}),
    lead,
    el('div',{class:'row-mid'}, mid),
    swap,
    el('button',{class:'row-x', title:'Remove', 'aria-label':'Remove',
      onclick:e=>{ e.stopPropagation(); removeLayer(l.id); }}, '✕'),
    ed ? el('div',{class:'row-ed', onclick:e=>e.stopPropagation()}, ed) : null);
}

const LAYER_KIND_NAME = {img:'Logo', logospot:'Logo', text:'Text', monogram:'Monogram', jersey:'Jersey', photo:'Photo'};
const layerLabel = l =>
  l.kind === 'img'      ? l.name :
  l.kind === 'logospot' ? 'Empty logo spot' :
  l.kind === 'photo'    ? (l.photo ? l.photo.name : 'Empty photo spot') :
  l.kind === 'monogram' ? (l.letters || '—').toUpperCase() :
  l.kind === 'jersey'   ? [l.name, l.number].filter(Boolean).join(' · ') || '—'
                        : (l.text || '—').split('\n')[0];

/* A row of color choices: the preset swatches, then a color-wheel swatch (the browser's
   own full picker, which takes a hex too), so any color is reachable. `list` is hex strings or
   [hex, name] pairs; `set(hex)` applies it — and is responsible for redrawing.

   The wheel commits on `change` (the picker closing), not `input`: dragging across the
   spectrum would otherwise re-bake a piece or regenerate a full-size background dozens of
   times a second. */
function colorRow(list, cur, set){
  const norm = h => (h || '').toUpperCase();
  const presets = list.map(x => Array.isArray(x) ? x : [x, x]);
  const custom = cur && !presets.some(([h]) => norm(h) === norm(cur));
  const wheel = el('label',{class:'sw sw-sm sw-wheel'+(custom?' on':''), title:'Any color',
      style: custom ? `--cur:${cur}` : ''},
    el('input',{type:'color', value: /^#[0-9a-f]{6}$/i.test(cur || '') ? cur : '#14566B',
      onchange:e=>set(norm(e.target.value))}));
  return el('div',{class:'swatches color-row', style:'flex:1'},
    presets.map(([h, name]) => el('button',{class:'sw sw-sm'+(norm(cur)===norm(h)?' on':''),
      style:'background:'+h, title:name, 'aria-label':name, onclick:()=>set(h)})),
    wheel);
}

/* A text-ish piece's controls, always open in its card and kept short: Style and Curve on
   one line, Color on the next. A jersey has only Color; a monogram has no Curve. */
const TEXT_FONTS = [['block','Bold condensed'],['sans','Clean sans'],['serif','Classic serif'],['script','Script']];
const MONO_FONTS = [['script','Script'],['serif','Classic serif'],['block','Bold condensed']];
function textEditor(l){
  const box = el('div',{class:'te'});
  if (l.kind !== 'jersey'){
    const keys = l.kind === 'monogram' ? MONO_FONTS : TEXT_FONTS;
    const cur = l.font || keys[0][0];
    const line = el('div',{class:'te-line'},
      el('label',{class:'te-lab'}, 'Style',
        el('select',{onchange:e=>{ l.font = e.target.value; rebake(l); },
          ...(l.kind === 'monogram' ? {title:'The middle initial is the surname, and prints larger — the traditional arrangement.'} : {})},
          keys.map(([v, lab]) => el('option',{value:v, ...(cur === v ? {selected:''} : {})}, lab)))));
    /* Curve is a checkbox that opens a full-width slider: squeezed in beside Style the
       slider was too short to use, and most text is straight. Ticking it starts at a
       gentle arch so the effect shows; unticking straightens the text. */
    const curved = l.kind === 'text' && (l.curveOn || !!l.curve);
    if (l.kind === 'text')
      line.appendChild(el('label',{class:'te-lab te-check'},
        el('input',{type:'checkbox', ...(curved ? {checked:''} : {}),
          onchange:e=>{ l.curveOn = e.target.checked; l.curve = e.target.checked ? (l.curve || 30) : 0; rebake(l); }}),
        'Curve'));
    box.appendChild(line);
    if (curved){
      const lab = v => v === 0 ? 'Straight' : v > 0 ? `Arch ${v}` : `Dip ${-v}`;
      const out = el('em',{}, lab(l.curve || 0));
      box.appendChild(el('div',{class:'te-line te-curve-row'},
        el('span',{class:'te-end'}, 'Dip'),
        // Dragging re-bakes and redraws the stage only, so the slider survives the drag;
        // the release re-renders (and records the step for undo).
        el('input',{type:'range', min:'-100', max:'100', step:'5', value:String(l.curve || 0), 'aria-label':'Curve',
          oninput:e=>{ const v = +e.target.value; l.curve = Math.abs(v) < 5 ? 0 : v;
                       out.textContent = lab(l.curve); bake(l).then(liveStage); },
          onchange:()=>render(true)}),
        el('span',{class:'te-end'}, 'Arch'),
        out));
    }
  }
  box.appendChild(el('div',{class:'te-line te-ink'}, el('span',{class:'te-lab'}, 'Color'),
    colorRow(INK_COLORS, l.color, hex => { l.color = hex; l.autoInk = false; rebake(l); })));
  return box;
}

function layerEditor(l){
  // Flip and Straighten are UV-only; on a wrap the rotate handle is enough.
  const extras = isSub() ? null : el('div',{class:'mini-btns'},
    el('button',{class:'mini', onclick:()=>{ l.flip = !l.flip; render(true); }},
      l.flip ? 'Unflip' : 'Flip'),
    el('button',{class:'mini', onclick:()=>{ l.rot = 0; render(true); }},
      'Straighten'));

  // A photo's only setting is its frame (Edit); its quality is on its row.
  if (l.kind === 'photo') return null;
  if (l.kind === 'logospot') return null;   // nothing to adjust until a logo is in it
  // A logo's cleanup is its pop-up (Edit) and its quality is on its row; all that's left
  // here is UV's Flip / Straighten.
  if (l.kind === 'img') return extras ? el('div',{}, extras) : null;
  // Text is edited the same way on both methods: Style, Curve and Color (no Flip or
  // Straighten, which read backwards on text and duplicate the rotate handle).
  if (TEXTISH.includes(l.kind)) return textEditor(l);
  return extras ? el('div',{}, extras) : null;
}

/* A logo's cleanup, under its print quality: background removal and trim for every logo,
   plus ink and contrast on UV (on sublimation every blank is white, so there's nothing for
   those to decide). Photos never get this — it would damage them. */
function logoCleanup(L, box){
  const toggle = (label, key, hint) => el('label',{class:'fx-row'},
    el('input',{type:'checkbox', ...(L.fx[key]?{checked:''}:{}),
      onchange:e=>{ L.fx[key]=e.target.checked; processLayer(L); render(true); }}),
    el('span',{}, el('b',{}, label), hint ? el('em',{}, hint) : null));
  // Flood-fill knockout only works on a plain, even background. Say so plainly rather
  // than letting someone toggle it and see nothing happen.
  const noBgFound = L.fx.removeBg && L.fxRemoved !== null
                    && L.fxRemoved !== undefined && L.fxRemoved < 0.02;
  box.appendChild(el('div',{style:'margin-top:10px'},
    toggle('Remove background', 'removeBg', 'Takes the white box off a logo, including inside letters'),
    noBgFound ? el('div',{class:'note warn'},
      el('span',{class:'ni'}, '!'),
      el('div',{html:'<b>No plain background found.</b> This works on a logo sitting on one flat color. A photo needs its background cut out properly first — send it over and our team can do it.'})) : null,
    toggle('Trim empty space', 'trim', 'Lets your design fill the print area')));
  if (isSub()) return;
  const want = bestInk(), inkIsBest = L.fx.ink === want;
  box.appendChild(el('div',{class:'fx-ink'},
    el('span',{class:'fx-ink-lab'}, 'Ink'),
    el('div',{class:'tabs', style:'margin:0;flex:1'},
      [['original','As uploaded'],['white','All white'],['black','All black']].map(([v,lab]) =>
        el('button',{class:'tab'+(L.fx.ink===v?' on':''),
          onclick:()=>{ L.fx.ink=v; processLayer(L); render(true); }}, lab)))));
  box.appendChild(el('button',{class:'btn fx-contrast', ...(inkIsBest?{disabled:''}:{}),
    onclick:()=>{ L.fx.ink = want; processLayer(L); render(true); }},
    inkIsBest ? 'Contrast looks good' : 'Apply best contrast'));
  box.appendChild(el('div',{class:'fx-note'}, inkIsBest
    ? `All ${want} reads clearly on ${S.variant.color || 'this finish'}.`
    : `${S.variant.color || 'This finish'} is ${want === 'white' ? 'dark' : 'light'}, so all ${want} will stand out most.`));
}

/* ---------- the control panel ---------- */
function panel(){
  const p = S.product, v = S.variant;
  const sects = [];

  /* size — only when the product actually comes in more than one */
  if (hasSizes(p)){
    sects.push(el('div',{class:'sect'},
      el('div',{class:'sect-t'}, 'Size', el('em',{}, p.sizes.length+' options')),
      el('div',{class:'sizes'}, p.sizes.map(z =>
        el('button',{class:'size-btn'+(z.size===v.size?' on':''),
          onclick:()=>{ S.variant = findVariant(p, z.size, v.color);
            S.artB = null;      // bottom panel is sized per tumbler size
            refitWrap();        // ...and the main wrap's pixel size changes with it
            render(true); }},
          el('span',{class:'sz'}, z.size),
          el('span',{class:'szp'}, fmt(
            (p.variants.find(x=>x.size===z.size)||{price:0}).price + decoPrice()))))),
    ));
  }

  /* color — listed per selected size. Sublimation has no section at all: every blank
     is white, and a "Finish: White — comes one way only" note answered nothing. */
  const named = colorsFor(p, v.size);
  if (isSub()){
    // no colour choice to show
  } else if (named.length > 1){
    sects.push(el('div',{class:'sect'},
      el('div',{class:'sect-t'}, 'Tumbler color', el('em',{}, named.length+' options')),
      el('div',{class:'swatches'}, named.map(x =>
        el('button',{class:'sw'+(x===v?' on':''), style:'background:'+hexFor(x),
          title:x.color, 'aria-label':x.color,
          onclick:()=>{ S.variant=x; render(true); }}))),
      el('div',{class:'sw-name', html:'Selected: <b>'+(v.color||'—')+'</b>'}),
    ));
  } else if (!hasSizes(p)) {
    sects.push(el('div',{class:'sect'},
      el('div',{class:'sect-t'}, 'Color'),
      el('div',{class:'sw-name', html:'<b>'+(v.color||'Single finish')+'</b> — this product comes one way only.'}),
    ));
  }

  /* artwork */
  const artSect = el('div',{class:'sect'});
  artSect.appendChild(el('div',{class:'sect-t'}, isSub()?'Your artwork':'Your design'));

  if (isSub()){
    const bot = isSub() ? bottomSpec() : null;

    const panelUI = (art, setArt, need, label) => {
      const wrapEl = el('div',{});
      if (bot && label) wrapEl.appendChild(el('div',{class:'panel-label'}, label,
        el('em',{}, px(need.w)+' × '+px(need.h)+' px')));
      if (art && art.type === 'img'){
        wrapEl.appendChild(el('div',{class:'file-row'},
          el('img',{class:'thumb', src:art.src, alt:''}),
          el('div',{class:'fmeta'},
            el('div',{class:'fname'}, art.name),
            el('div',{class:'fdim'}, art.w+' × '+art.h+' px')),
          el('button',{class:'link-btn', onclick:()=>{ setArt(null); render(true); }}, 'Remove'),
        ));
      } else {
        wrapEl.appendChild(dropZone(setArt, need));
        if (S.artError) wrapEl.appendChild(el('div',{class:'note bad', style:'margin-top:10px'},
          el('span',{class:'ni'}, '!'), el('div',{}, S.artError)));
      }
      // A quality reading, not a verdict. Nothing is refused for being small any
      // more — it's enlarged and printed — so what the customer needs is how much
      // real resolution is behind it, which is the one thing we can't fix for them.
      /* A generated wrap is always full resolution for its size, so the scale would read
         Excellent every time — a meter that can only say one thing is furniture. It is
         still drawn if a generation ever comes back small, which is the only case where
         it would tell the customer something they could act on. */
      const q = art && art.type === 'img' ? qualityOf() : null;
      if (q && !(art.ai && q.lab === 'Excellent')) wrapEl.appendChild(qualityBar(q));
      return wrapEl;
    };

    /* The main wrap — and only the main wrap — can be described instead of supplied.
       The bottom band can't: it's a step-and-repeat that has to hide a seam on a tapered
       body, which is a manufacturing constraint rather than a design one, and the pattern
       generators already solve it better than a prompt would.

       The tabs stay visible after a design is chosen, because the whole point of paying
       for a package is generating more than once — hiding the generator the moment
       something lands in S.art would make the second design harder to reach than the
       first. The chosen file's row and quality reading are shown under either tab, so the
       customer can always see what is actually on the tumbler. */
    /* The full wrap is one piece in the sandbox, so it moves and scales like any other.
       Fill and Fit are shortcuts that snap it back to one of the two sensible placements. */
    const wrapPieceUI = need => {
      const l = S.sides.wrap[0];
      const box = el('div',{});
      if (!l){
        box.appendChild(dropZone(null, need, loadWrapLayer));
        if (S.artError) box.appendChild(el('div',{class:'note bad', style:'margin-top:10px'},
          el('span',{class:'ni'}, '!'), el('div',{}, S.artError)));
        return box;
      }
      /* Laid out like a photo's row: Edit (position and zoom, in a pop-up like a photo's)
         on the left, Swap and ✕ on the right. */
      const swapIn = el('input',{type:'file', accept:'image/*', class:'hidden',
        onchange:e=>{ if (e.target.files[0]) loadWrapLayer(e.target.files[0]); }});
      const btn = (cls, label, fn) => el('button',{class:cls,
        onclick:e=>{ e.stopPropagation(); fn(); }}, label);
      const wq = qualityOf(l);
      box.appendChild(el('div',{class:'layers'}, el('div',{class:'lrow'},
        el('img',{class:'thumb', src:l.src, alt:''}),
        el('button',{class:'edit-btn', onclick:e=>{ e.stopPropagation(); openWrapPos(l); }},
          el('span',{class:'ic', html:PENCIL}), 'Edit'),
        el('div',{class:'row-mid'}, wq ? qualityMini(wq) : null),
        btn('row-act', 'Swap', () => swapIn.click()),
        el('button',{class:'row-x', title:'Remove', 'aria-label':'Remove',
          onclick:()=>{ S.sides.wrap = []; S.sel = null; render(true); }}, '✕'),
        swapIn)));
      box.appendChild(el('div',{class:'fx-note'},
        'Fitted to the wrap automatically. Tap Edit to move or zoom it — anything past the edges is trimmed.'));
      return box;
    };

    const mainWrapUI = (need, label) => {
      const wrapEl = el('div',{});
      if (label) wrapEl.appendChild(el('div',{class:'panel-label'}, label));
      wrapEl.appendChild(el('div',{class:'tabs'},
        // Pet Templates ('pet') is off while its scenes are being redrawn by the designer; its code
        // (petPanel/petGenerate/petChoose) stays for the rebuild — DESIGN_STUDIO.md, Pet Templates.
        [['logo','Create your own'],['upload','Upload full wrap']].map(([t,lab]) =>
          el('button',{class:'tab'+(S.artTab===t?' on':''),
            onclick:()=>{ S.artTab=t; S.zoom=false; S.sel=null; render(true); }}, lab))));
      if (S.artTab === 'logo'){
        wrapEl.appendChild(layerStackUI());
      } else if (S.artTab === 'pet'){
        wrapEl.appendChild(petPanel());
      } else {
        wrapEl.appendChild(wrapPieceUI(need));
      }
      return wrapEl;
    };

    artSect.appendChild(mainWrapUI({w:areaW(), h:areaH()}, null));
  } else {
    /* UV has no Front/Back tabs: each piece's card carries its side, and the add box asks
       which side the next one goes on (layerStackUI). */
    artSect.appendChild(layerStackUI());
  }
  sects.push(artSect);
  if (isSub()){ const wo = wrapOptionsUI(); if (wo) sects.push(wo); }

  /* quantity + price */
  sects.push(el('div',{class:'sect'},
    el('div',{class:'sect-t'}, 'Quantity'),
    el('div',{class:'qty'},
      el('button',{onclick:()=>{ S.qty=Math.max(1,S.qty-1); render(true); }, 'aria-label':'Decrease'}, '−'),
      el('input',{type:'text', value:String(S.qty), oninput:e=>{
        const n = parseInt(e.target.value.replace(/\D/g,''),10);
        S.qty = isNaN(n)||n<1 ? 1 : Math.min(999,n); render(true);
      }}),
      el('button',{onclick:()=>{ S.qty=Math.min(999,S.qty+1); render(true); }, 'aria-label':'Increase'}, '+')),
    p.packSize > 1 ? el('div',{class:'note warn', style:'margin-top:11px'},
      el('span',{class:'ni'}, 'i'),
      el('div',{html:`<b>Sold as a ${p.packSize}-pack.</b> One quantity is ${p.packSize} tumblers, and all ${p.packSize} get this same design.`})) : null,
    el('div',{style:'margin-top:15px'},
      el('div',{class:'total-row'}, el('span',{}, pname(p)), el('span',{class:'v'}, fmt(S.variant.price))),
      el('div',{class:'total-row'},
        el('span',{}, (isSub()?'Sublimation printing':'UV printing') + (p.packSize>1 ? ` (${p.packSize} × ${fmt(p.decoRate)})` : '')),
        el('span',{class:'v'}, fmt(decoPrice()))),
      extraPieces() ? el('div',{class:'total-row'},
        el('span',{}, `Additional designs (${extraPieces()} × ${fmt(EXTRA_PRICE)})`),
        el('span',{class:'v'}, fmt(extraPrice()))) : null,
      bandOn() ? el('div',{class:'total-row'}, el('span',{}, 'Bottom band'),
        el('span',{class:'v'}, fmt(bandPrice()))) : null,
      el('div',{class:'total-row big'}, el('span',{}, S.qty>1 ? `Total (${S.qty})` : 'Total'),
        el('span',{class:'v'}, fmt(unitPrice()*S.qty)))),
  ));

  const bot = isSub() ? bottomSpec() : null;
  // Nothing about the artwork itself blocks any more: a wrap is fitted to shape
  // on upload and a small file is enlarged, so the only stopper is a missing one.
  const blocked = (useLayers()
      ? (!inked().length && !bgActive()) || printing().some(isEmptySpot)
        || (S.tpl.id === 'repeat' && S.artTab === 'logo' && !repeatSource())
      : !S.art) || (bot && !S.artB);
  return el('div',{},
    el('div',{class:'panel'},
      el('div',{class:'panel-hd'},
        el('div',{class:'t'}, pname(p)),
        el('button',{class:'link-btn pd-link', onclick:()=>openDetails(p, false)}, 'Product details')),
      sects),
    el('div',{class:'bar'},
      el('button',{class:'btn', onclick:()=>go(2)}, '← Back'),
      el('span',{class:'spacer'}),
      el('button',{class:'btn pri', ...(blocked?{disabled:''}:{}), onclick:()=>go(4)}, 'Review design →')),
  );
}

/* Redraw the stage without touching the control panel.

   render() empties the whole app and rebuilds it. For a button that is fine, but
   a range input that calls it on `input` destroys *itself* on the first movement
   of a drag: the element under the pointer is replaced, the browser has nothing
   left to track, and the slider ends up moving one step per click instead of
   sliding. The panel has to survive a drag, so the stage is redrawn on its own. */
function liveStage(){
  const col = document.getElementById('hc-stage-col');
  if (!col) return render(true);
  col.textContent = '';
  col.appendChild(stage());
  col.appendChild(stageFoot());
}

/* `readout` is a function, not a string: it has to be recomputed on every input
   event so the label tracks the thumb, and the surrounding DOM is deliberately
   not being rebuilt to do it. */
function slider(label, val, min, max, step, readout, set){
  const out = el('em',{}, readout());
  return el('div',{style:'margin-bottom:13px'},
    el('div',{class:'slider-lab'}, el('span',{}, label), out),
    el('input',{type:'range', min, max, step, value:val,
      oninput:e=>{ set(parseFloat(e.target.value)); out.textContent = readout(); liveStage(); },
      // Once the drag is over, resync everything the panel derives from these.
      onchange:()=>render(true)}));
}

function dropZone(setArt, need, onFile){
  const take = f => onFile ? onFile(f) : loadArt(f, setArt, need);
  const input = el('input',{type:'file', accept:'image/*', class:'hidden', onchange:e=>{
    if (e.target.files[0]) take(e.target.files[0]);
  }});
  const z = el('div',{class:'drop', onclick:()=>input.click(),
    ondragover:e=>{ e.preventDefault(); z.classList.add('over'); },
    ondragleave:()=>z.classList.remove('over'),
    ondrop:e=>{ e.preventDefault(); z.classList.remove('over');
      if (e.dataTransfer.files[0]) take(e.dataTransfer.files[0]); }},
    el('div',{class:'ic'}, '↑'),
    el('div',{class:'t1'}, 'Upload your file'),
    // For a wrap, the size to ask an outside AI tool for — those draw at whatever size
    // they're told. Any shape is still fitted to the wrap on upload.
    isSub()
      ? el('div',{class:'t2'}, el('b',{}, 'Using AI?'), ` Ask for a file ${px(need.w)} × ${px(need.h)} pixels.`)
      : el('div',{class:'t2'}, 'PNG or JPG — we clean it up for you'),
    input);
  return z;
}

/* Re-runs fitToWrap() against the file as uploaded — for a Fill/Fit change, and
   for a size change, since the two Big Swig sizes want different wrap pixels. */
async function refitWrap(){
  if (!isSub() || !S.art || S.art.type !== 'img' || !S.art.orig) return;
  S.fxBusy = true; render(true);
  await paint();                      // see paint() — the fit below blocks the main thread
  const img = new Image();
  img.onload = () => {
    const cv = fitToWrap(img, areaW(), areaH(), S.wrapFit);
    S.art.src = wrapURL(cv);
    S.art.w = cv.width; S.art.h = cv.height;
    S.fxBusy = false; render(true);
  };
  img.src = S.art.orig;
}

/* An uploaded image becomes a layer. Separate from loadArt(), which still serves
   sublimation: a wrap is one file at one exact size and has no stack to join. */
/* `spot` (optional) is a template's empty logo spot: the logo takes its place, and is
   sized to it once cleanup has trimmed it (`fitTo`, read by processLayer). */
function loadImageLayer(file, spot){
  const r = new FileReader();
  r.onload = ev => {
    const img = new Image();
    img.onload = () => {
      const {id} = imageDataOf(img, 320);
      const f = {kind:'img', src:ev.target.result, orig:ev.target.result,
                 w:img.naturalWidth, h:img.naturalHeight,
                 // The file as it arrived; qualityOf() has to be honest
                 // against this and not against the cleaned-up copy.
                 ow:img.naturalWidth, oh:img.naturalHeight, name:file.name,
                 fx:{removeBg: looksMatted(id), trim:true, ink:'original'}};
      let l;
      if (spot && S.layers.includes(spot)){ l = Object.assign(spot, f); S.sel = l.id; }
      else l = addLayer(f);
      processLayer(l);
      openLogoFx(l);                       // a new logo opens its cleanup, as a photo opens its frame
      render(true);
    };
    img.src = ev.target.result;
  };
  r.readAsDataURL(file);
}

/* The fields that make a logo, for moving one into another template's logo spot. */
const logoFields = l => ({kind:'img', src:l.src, orig:l.orig, w:l.w, h:l.h, ow:l.ow, oh:l.oh,
                          name:l.name, fx:{...l.fx}, fxRemoved:l.fxRemoved});

/* Fills an empty spot: a photo spot opens the photo flow, a logo spot the logo one. */
function pickSpot(l){
  if (l.kind !== 'logospot') return pickPhotoFor(l);
  const inp = el('input',{type:'file', accept:'image/*', class:'hidden'});
  inp.addEventListener('change', () => { if (inp.files[0]) loadImageLayer(inp.files[0], l); });
  document.body.appendChild(inp);
  inp.click();
  setTimeout(() => inp.remove(), 60000);
}

/* ================= AI artwork (sublimation only) =================

   The server owns everything that costs money. This file asks what the visitor is
   allowed, shows it, and posts prompts; it never decides that a generation is free, and
   it deliberately keeps no local count — a number held here is a number anyone can edit,
   and every generation is a real charge. `S.ai.status` is always the server's last word,
   replaced wholesale by every response.

   The session id is the one piece of state the browser does own, and only so the free
   look survives a page reload. Clearing it doesn't buy another one: the server meters the
   free allowance per address as well (routes/public.py:_ai_state). */

const AI_SESSION_KEY = 'hoggStudioAiSession';

function aiSession(){
  let id = null;
  try { id = localStorage.getItem(AI_SESSION_KEY); } catch (e) { /* private mode */ }
  if (!id || !/^[a-zA-Z0-9_-]{12,64}$/.test(id)){
    id = 'sx' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    try { localStorage.setItem(AI_SESSION_KEY, id); } catch (e) { /* not fatal */ }
  }
  return id;
}

async function aiPost(path, body){
  const r = await fetch(API + '/api/customizer/ai/' + path, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(Object.assign({sessionId: aiSession()}, body || {})),
  });
  const data = await r.json().catch(() => ({}));
  return {ok: r.ok, status: r.status, data};
}

/* Asked once, when the AI tab is first opened rather than on page load: most visitors are
   uploading a file and never see this, and a status call for every one of them is a
   database write per pageview for nothing. */
async function aiStatus(){
  if (S.ai.status) return;
  const {ok, data} = await aiPost('status');
  if (ok) S.ai.status = data;
  render(true);
}

/* Pet Templates: one generation from a template, with the pet's photo. The server owns the
   wording (services/pet_templates.py) — the browser only names the template. The pet's name
   is never sent: it is added afterwards as a real text piece, since image models garble or
   drop lettering. */
async function petGenerate(){
  const A = S.ai;
  if (A.busy || !A.template || !A.ref) return;
  A.busy = true; A.error = ''; render(true);
  const {ok, status, data} = await aiPost('generate',
    {sku: S.variant.sku, template: A.template, reference: A.ref.src});
  A.busy = false;
  if (ok){
    // Newest first, and earlier ones kept: someone who tries two templates wants to compare.
    A.results = (data.images || []).map(url => ({url, template: A.template})).concat(A.results).slice(0, 12);
    A.status = data;
  } else if (status === 402){
    A.status = data; A.pack = true;        // out of free designs: the package is offered
  } else {
    A.error = data.error || 'Something went wrong. Please try again.';
    if (data.remaining !== undefined) A.status = data;
  }
  render(true);
}

async function aiUnlock(){
  S.ai.unlocking = true; S.ai.error = ''; render(true);
  const {ok, data} = await aiPost('unlock');
  S.ai.unlocking = false;
  if (ok){ S.ai.status = data; S.ai.pack = false; }
  else S.ai.error = data.error || 'We could not add the package. Please try again.';
  render(true);
}

/* A chosen result becomes the design on the Pet Templates side: the scene as a full-wrap
   piece filling the wrap edge to edge (`cover` — it is composed to run past every edge), and,
   when a name was typed, the name as a real text piece near the bottom in the template's ink.
   From there it is an ordinary design: the scene moves and zooms (Edit), the name is edited
   like any text piece, and the views, print file and cart all work as for any other design.

   The image is kept as pixels (JPEG at the wrap's own resolution), not the Cloudinary URL:
   the print render and the upload of originals both need data, not a link. loadImg() so the
   canvas isn't tainted. */
async function petChoose(url, templateId){
  const A = S.ai;
  A.applying = url; S.fxBusy = true; A.error = ''; render(true);
  await paint();
  try {
    const img = await loadImg(aiFull(url));
    const cap = Math.max(areaW(), areaH());
    const kk = Math.min(1, cap / Math.max(img.naturalWidth, img.naturalHeight));
    const cv = document.createElement('canvas');
    cv.width = Math.round(img.naturalWidth * kk); cv.height = Math.round(img.naturalHeight * kk);
    cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
    const src = cv.toDataURL('image/jpeg', 0.92);
    const tpl = petTemplate(templateId) || {};
    // Keep the name piece if they've already styled or moved it; otherwise start one fresh.
    const oldName = S.sides.pet.find(l => l.kind === 'text');
    S.sides.pet = [];
    const scene = addLayer({kind:'img', wrap:true, src, orig:src, w:cv.width, h:cv.height,
                            ow:img.naturalWidth, oh:img.naturalHeight, aiUrl:url,
                            name:'Pet template — ' + (tpl.name || 'design'),
                            fx:{removeBg:false, trim:false, ink:'original'}});
    scene.x = 0.5; scene.y = 0.5; scene.s = wrapCoverZ(scene); clampToArea(scene);
    const name = (A.name || '').trim();
    if (oldName && name){
      oldName.text = name; S.sides.pet.push(oldName); await bake(oldName);
    } else if (name){
      const t = addLayer({kind:'text', text:name, font:'script', align:'center'});
      t.color = tpl.ink || '#FFFFFF';   // after addLayer, which turns white ink black on sublimation
      await bake(t);
      t.s = 0.36; t.x = 0.5; t.y = 0.86; clampToArea(t);
    }
    S.sel = null; S.zoom = false;
  } catch (e){
    console.error('[customizer]', e);
    A.error = 'That design could not be loaded. Please pick another or create again.';
  }
  A.applying = null; S.fxBusy = false; render(true);
  const stage = document.getElementById('hc-stage-col');
  if (stage && !A.error) stage.scrollIntoView({behavior:'smooth', block:'nearest'});
}

function petLoadRef(file){
  const r = new FileReader();
  r.onload = ev => { S.ai.ref = {src: ev.target.result, name: file.name}; render(true); };
  r.readAsDataURL(file);
}

let PET_TEMPLATES = {dog: [], cat: []};        // from the catalog response (server-owned list)
const petTemplate = id => [...PET_TEMPLATES.dog, ...PET_TEMPLATES.cat].find(t => t.id === id) || null;

/* Cloudinary can resize on delivery, so the results grid pulls ~600px thumbnails instead
   of a dozen 4K wraps. */
const aiThumb = url => url.replace('/upload/', '/upload/w_600,q_auto,f_auto/');

/* ...and the chosen one is not fetched at full size either. The generator returns more
   than the press can use — 5056 x 3392 for a wrap that prints at 2776 x 2421 — and those
   extra pixels cost bandwidth on every selection while never reaching the paper, since
   renderPrint() draws at the print size. Delivered at the wrap's own height plus a small
   margin for the crop: about 1.6 MB instead of 3 MB, with nothing lost that could have
   been printed. Margin, not exact, because `cover` crops width against height and a file
   that arrived a pixel short would be enlarged to fit. */
const aiFull = url => url.replace('/upload/',
  `/upload/c_scale,h_${Math.round(areaH() * 1.05)},q_auto:good,f_auto/`);

/* The Pet Templates panel: dog or cat, a template, the pet's photo and name, then Create.
   Results below; picking one puts it on the tumbler, and "Your design" then holds the scene
   (Edit to move/zoom) and the name (font, colour, curve). The AI allowance and package work
   as they always have. */
function petPanel(){
  const A = S.ai, st = A.status;
  const box = el('div',{class:'pet'});
  if (!st){ box.appendChild(el('div',{class:'fx-note'}, 'Loading…')); aiStatus(); return box; }
  if (!st.enabled){
    box.appendChild(el('div',{class:'note warn'}, el('span',{class:'ni'}, 'i'),
      el('div',{html:'<b>Pet Templates are off right now.</b> Upload a file instead, or request a quote and our team will design it with you.'})));
    return box;
  }
  if (A.pack && !st.unlimited){
    box.appendChild(el('div',{class:'ai-pack'},
      el('div',{class:'ai-pack-t'}, 'AI Design Package'),
      el('div',{class:'ai-pack-p'}, fmt(st.packPrice)),
      el('ul',{class:'ai-pack-l'},
        el('li',{}, `${st.packGenerations} more designs, each one ${st.variants > 1 ? st.variants + ' versions to choose from' : 'made for this tumbler'}`),
        el('li',{}, 'Built to your tumbler’s exact wrap size, ready to print'),
        el('li',{}, 'Try as many templates as you like with your pet')),
      el('div',{class:'ai-pack-n'},
        'Added to your cart once. It’s per order, not per tumbler.'),
      el('div',{class:'ai-pack-b'},
        el('button',{class:'btn', onclick:()=>{ A.pack=false; render(true); }}, 'Not now'),
        el('button',{class:'btn pri', ...(A.unlocking?{disabled:''}:{}), onclick:aiUnlock},
          A.unlocking ? 'Adding…' : 'Add the package'))));
    return box;
  }
  if (!st.unlimited) box.appendChild(el('div',{class:'ai-bal'},
    st.unlocked
      ? el('span',{}, el('b',{}, st.remaining + ' design' + (st.remaining === 1 ? '' : 's')), ' left in your package.')
      : st.remaining > 0
        ? el('span',{}, el('b',{}, 'Your first design is free.'))
        : el('span',{}, 'You’ve used your free design.'),
    st.unlocked ? null : el('button',{class:'link-btn', onclick:()=>{ A.pack=true; render(true); }},
      st.remaining > 0 ? 'See the package' : 'Get more')));

  // Dog / cat
  box.appendChild(el('div',{class:'tabs', style:'margin:4px 0 10px'},
    [['dog','Dog'],['cat','Cat']].map(([v, lab]) =>
      el('button',{class:'tab'+(A.species===v?' on':''),
        onclick:()=>{ if (A.species !== v){ A.species = v; A.template = null; } render(true); }}, lab))));

  // Templates
  const list = PET_TEMPLATES[A.species] || [];
  box.appendChild(el('div',{class:'pet-grid'}, list.map(t =>
    el('button',{class:'pet-opt'+(A.template===t.id?' on':''), onclick:()=>{ A.template = t.id; render(true); }},
      el('b',{}, t.name), el('span',{}, t.blurb)))));

  // Photo (required) and name
  const noun = A.species === 'cat' ? 'cat' : 'dog';
  box.appendChild(el('div',{class:'ai-ref'},
    A.ref
      ? el('div',{class:'file-row'},
          el('img',{class:'thumb', src:A.ref.src, alt:''}),
          el('div',{class:'fmeta'},
            el('div',{class:'fname'}, `Your ${noun}’s photo`),
            el('div',{class:'fdim'}, 'We keep their face and markings')),
          el('button',{class:'link-btn', onclick:()=>{ A.ref=null; render(true); }}, 'Change'))
      : (() => {
          const input = el('input',{type:'file', accept:'image/*', class:'hidden',
            onchange:e=>{ if (e.target.files[0]) petLoadRef(e.target.files[0]); }});
          return el('button',{class:'ai-ref-btn', onclick:()=>input.click()},
            el('span',{class:'ic'}, '+'),
            el('span',{}, `Add a photo of your ${noun}`),
            el('em',{}, 'clear, face visible'), input);
        })()));
  box.appendChild(el('label',{class:'pet-name'},
    el('span',{}, `Your ${noun}’s name`),
    el('input',{type:'text', maxlength:'30', value:A.name, placeholder:'Optional',
      oninput:e=>{ A.name = e.target.value; }})));

  const ready = A.template && A.ref && !A.busy;
  box.appendChild(el('button',{class:'btn pri ai-go', ...(ready ? {} : {disabled:''}), onclick:petGenerate},
    A.busy ? 'Creating your design…'
      : !A.template ? 'Pick a template' : !A.ref ? `Add your ${noun}’s photo`
      : (st.unlimited || st.remaining > 0 ? 'Create my design' : 'Get more designs')));
  if (A.busy) box.appendChild(el('div',{class:'ai-wait'}, 'This takes about 20 seconds.'));
  if (A.error) box.appendChild(el('div',{class:'note bad'}, el('span',{class:'ni'}, '!'), el('div',{}, A.error)));

  if (A.results.length){
    const chosen = (S.sides.pet.find(l => l.wrap) || {}).aiUrl;
    box.appendChild(el('div',{class:'panel-label', style:'margin-top:16px'}, 'Your designs',
      el('em',{}, 'tap one to put it on the tumbler')));
    box.appendChild(el('div',{class:'ai-grid'}, A.results.map(r =>
      el('button',{class:'ai-res' + (chosen === r.url ? ' on' : '') + (A.applying === r.url ? ' busy' : ''),
        ...(A.applying ? {disabled:''} : {}), onclick:()=>petChoose(r.url, r.template)},
        el('img',{src:aiThumb(r.url), alt:'', loading:'lazy'}),
        A.applying === r.url ? el('span',{class:'ai-res-busy'}, 'Adding…') : null))));
  }

  // The design on the tumbler: the scene and the name, as pieces
  if (S.sides.pet.length){
    box.appendChild(el('div',{class:'panel-label', style:'margin-top:16px'}, 'Your design'));
    const rows = el('div',{class:'layers'});
    const scene = S.sides.pet.find(l => l.wrap);
    if (scene){
      const q = qualityOf(scene);
      rows.appendChild(el('div',{class:'lrow'},
        el('img',{class:'thumb', src:scene.src, alt:''}),
        el('button',{class:'edit-btn', onclick:e=>{ e.stopPropagation(); openWrapPos(scene); }},
          el('span',{class:'ic', html:PENCIL}), 'Edit'),
        el('div',{class:'row-mid'}, q ? qualityMini(q) : null)));
    }
    S.sides.pet.filter(l => l.kind === 'text').forEach(l => rows.appendChild(pieceRow(l, layerEditor(l))));
    if (!S.sides.pet.some(l => l.kind === 'text'))
      rows.appendChild(el('button',{class:'lrow add-row', onclick:async ()=>{
        const tpl = petTemplate((S.ai.results.find(r => r.url === (scene || {}).aiUrl) || {}).template) || {};
        const t = addLayer({kind:'text', text: A.name.trim() || 'Name', font:'script', align:'center'});
        t.color = tpl.ink || '#FFFFFF';
        await bake(t); t.s = 0.36; t.x = 0.5; t.y = 0.86; clampToArea(t); render(true);
      }}, el('span',{class:'plus'}, '+'), el('span',{}, 'Add a name')));
    box.appendChild(rows);
  }
  return box;
}

/* A wrap upload that fails has to say so. It used to fail silently in three ways — a file
   the browser can't decode (an AI/PSD/HEIC renamed, a truncated download), an SVG with no
   intrinsic size (0 x 0, so the fit drew nothing), and a canvas the device refuses (phones
   cap canvas memory) — and each left either nothing on the tumbler or the "Preparing your
   artwork" spinner up for good, which reads exactly as "the upload didn't work". */
function artFailed(msg){
  S.fxBusy = false;
  S.artError = msg;
  render(true);
}

/* The full-wrap piece is placed to fit: centred, all of it kept, as large as the wrap
   allows (layerBox() fits `contain` at s = 1). Cropping someone's photo to fill was the
   wrong default to make for them; they can still enlarge it by hand. */
function placeWrap(l){
  l.x = 0.5; l.y = 0.5; l.rot = 0; l.s = 1;
  clampToArea(l);
}

/* Upload full wrap: the file becomes the one piece on the wrap tab's sandbox, as uploaded
   — no cleanup, since a wrap is meant to run edge to edge. The print file is drawn from it
   at order time, so nothing is resampled here. */
function loadWrapLayer(file){
  S.artError = '';
  const r = new FileReader();
  r.onerror = () => artFailed('We could not read that file. Please try again, or use a PNG or JPG.');
  r.onload = ev => {
    const img = new Image();
    img.onerror = () => artFailed(`We could not open “${file.name}”. Please upload a PNG or JPG.`);
    img.onload = () => {
      const w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
      if (!w || !h)
        return artFailed(`“${file.name}” has no size we can read. Please export it as a PNG or JPG.`);
      S.sides.wrap = [];
      const l = addLayer({kind:'img', wrap:true, src:ev.target.result, orig:ev.target.result,
                          w, h, ow:w, oh:h, name:file.name,
                          fx:{removeBg:false, trim:false, ink:'original'}});
      placeWrap(l);
      S.sel = null;
      openWrapPos(l);                 // straight into positioning, as a photo opens its frame
    };
    img.src = ev.target.result;
  };
  r.readAsDataURL(file);
}

function loadArt(file, setArt, need){
  S.artError = '';
  const r = new FileReader();
  r.onerror = () => artFailed('We could not read that file. Please try again, or use a PNG or JPG.');
  r.onload = ev => {
    const img = new Image();
    img.onerror = () => artFailed(`We could not open “${file.name}”. Please upload a PNG or JPG.`);
    img.onload = async () => {
      if (!(img.naturalWidth || img.width) || !(img.naturalHeight || img.height))
        return artFailed(`“${file.name}” has no size we can read. Please export it as a PNG or JPG.`);
      S.fxBusy = true; render(true);
      await paint();                  // same blocking fit as petChoose/refitWrap
      try {
      const art = {type:'img', src:ev.target.result, orig:ev.target.result,
                   w:img.naturalWidth, h:img.naturalHeight,
                   // The file as it arrived. Everything below may rewrite w/h;
                   // this is what qualityOf() has to be honest against.
                   ow:img.naturalWidth, oh:img.naturalHeight, name:file.name};
      {
        // Sublimation only. Cleanup is a UV idea — a wrap runs edge to edge, so
        // knocking out its background or trimming it would only break it — and
        // the wrap is always normalised to its exact pixels, whatever arrived.
        // S.wrapFit picks whether overflow is cropped or the artwork is padded.
        const cv = fitToWrap(img, need.w, need.h, S.wrapFit);
        art.src = wrapURL(cv);
        art.w = cv.width; art.h = cv.height;
        setArt(art);
      }
      } catch (err){
        console.error('[customizer] wrap fit failed', err);
        return artFailed('That file is too large for this device to prepare. Please try a smaller PNG or JPG.');
      }
      S.fxBusy = false;
      render(true);
    };
    img.src = ev.target.result;
  };
  r.readAsDataURL(file);
}


/* ================= layers =================
   Text, monograms and jersey marks are drawn to an offscreen canvas and kept as
   bitmaps, exactly like an upload. Three reasons, in order of how much trouble
   each avoids:

     1. One placement and compositing path. A text layer that stayed as text would
        need its own measuring, wrapping and scaling everywhere an image layer
        already has some — and the two would drift.
     2. The stage and the print file cannot disagree about what a font measures.
        Canvas text metrics differ from CSS text metrics; baking once and drawing
        the same pixels in both places sidesteps the whole question.
     3. Fonts load late. A canvas draw before the webfont arrives silently uses a
        fallback, and on the print file nobody would notice until it was printed.
        bake() waits for the font (see fontReady) and re-bakes if it lands late. */

const LAYER_FONTS = {
  block:  '"Bebas Neue", Impact, "Haettenschweiler", sans-serif',
  serif:  'Georgia, "Times New Roman", serif',
  script: '"Snell Roundhand", "Brush Script MT", "Segoe Script", cursive',
  sans:   '"IBM Plex Sans", -apple-system, "Segoe UI", sans-serif',
};
const INK_COLORS = [
  ['#FFFFFF','White'], ['#111111','Black'], ['#C8102E','Red'], ['#1F3A64','Navy'],
  ['#0F7B4F','Green'], ['#E8B21A','Gold'], ['#B8B8B8','Silver'],
];
const BAKE_PX = 1400;                     // baked at print-ish resolution, then scaled

/* Resolves once the named family is actually usable, so a bake can't quietly land
   on a fallback face. Never rejects: a missing font is a worse-looking design, not
   a broken one, and blocking the design step on it would be the wrong trade. */
function fontReady(family, px){
  if (!document.fonts || !document.fonts.load) return Promise.resolve();
  return document.fonts.load(`${px}px ${family}`).catch(() => {});
}

function measureText(c, txt, font, px){
  c.font = `${px}px ${font}`;
  const m = c.measureText(txt);
  const asc = m.actualBoundingBoxAscent  || px * 0.75;
  const desc = m.actualBoundingBoxDescent || px * 0.25;
  return {w: Math.max(1, m.width), asc, desc, h: Math.max(1, asc + desc)};
}

/* Draws one text-ish layer onto its own canvas and hands back {src, w, h}. */
async function bakeAt(l, B){
  const cv = document.createElement('canvas');
  const c = cv.getContext('2d');
  /* Drawn with generous room and trimmed to the ink afterwards. Font metrics describe the
     advance, not the ink: a script capital's swash runs well past it, and a canvas sized
     from the metrics cut the A and C off a script monogram. */
  const pad = Math.round(B * 0.2);         // room for swashes; trimmed to the ink after

  if (l.kind === 'jersey'){
    /* A name in a condensed block face over a big number, which is what a jersey
       print is. Two lines, because the number is the point and sizing them
       together would shrink it to fit the longer name. */
    const font = LAYER_FONTS.block;
    const namePx = Math.round(B * 0.22), numPx = Math.round(B * 0.62);
    await fontReady(font, numPx);
    const name = (l.name || '').toUpperCase(), num = (l.number || '');
    const nm = name ? measureText(c, name, font, namePx) : {w:0, h:0, asc:0, desc:0};
    const nu = num  ? measureText(c, num,  font, numPx)  : {w:0, h:0, asc:0, desc:0};
    const gap = name && num ? Math.round(namePx * 0.22) : 0;
    const W0 = Math.max(nm.w, nu.w) + pad*2;
    if (W0 > MAX_BAKE_W) return {tooWide: W0};
    cv.width  = Math.max(1, Math.round(W0));
    cv.height = Math.max(1, Math.round(nm.h + gap + nu.h + pad*2));
    c.fillStyle = l.color; c.textAlign = 'center'; c.textBaseline = 'alphabetic';
    let y = pad;
    if (name){ c.font = `${namePx}px ${font}`; c.fillText(name, cv.width/2, y + nm.asc); y += nm.h + gap; }
    if (num) { c.font = `${numPx}px ${font}`;  c.fillText(num,  cv.width/2, y + nu.asc); }
  } else if (l.kind === 'monogram'){
    /* Three initials with the middle one larger — the classic arrangement, where
       the middle letter is the surname. Letters are placed on a shared baseline
       rather than centred on each other, or the big one floats. */
    const font = LAYER_FONTS[l.font] || LAYER_FONTS.script;
    const big = Math.round(B * 0.62), small = Math.round(big * 0.62);
    await fontReady(font, big);
    const ch = (l.letters || '').toUpperCase().slice(0, 3).split('');
    // The middle letter is only enlarged when there *is* a middle one. Padding a
    // shorter set out to three left an empty slot, and the mark sat off-centre
    // inside its own bounding box for the rest of its life.
    const sizes = ch.map((_, i) => (ch.length === 3 && i === 1) ? big : small);
    const ms = ch.map((t, i) => measureText(c, t, font, sizes[i]));
    const kern = Math.round(big * 0.02);
    const totalW = ms.reduce((a, m) => a + m.w, 0) + kern * 2;
    const asc = Math.max(...ms.map(m => m.asc), 1);
    const desc = Math.max(...ms.map(m => m.desc), 1);
    if (totalW + pad*2 > MAX_BAKE_W) return {tooWide: totalW + pad*2};
    cv.width  = Math.max(1, Math.round(totalW + pad*2));
    cv.height = Math.max(1, Math.round(asc + desc + pad*2));
    c.fillStyle = l.color; c.textAlign = 'left'; c.textBaseline = 'alphabetic';
    let x = pad;
    ch.forEach((t, i) => {
      c.font = `${sizes[i]}px ${font}`;
      c.fillText(t, x, pad + asc);
      x += ms[i].w + kern;
    });
  } else if (l.kind === 'text' && l.curve){
    /* Curved text: the line set along a circular arc, letter by letter. `curve` runs
       -100..100 — positive arches up (∩, over a photo), negative dips (∪, under one) — and
       is the arc's sweep, up to 180°. The radius comes from the line's own length, so the
       wording keeps its size however far it's bent. */
    const font = LAYER_FONTS[l.font] || LAYER_FONTS.block;
    const px = Math.round(B * 0.5);
    await fontReady(font, px);
    const txt = (l.text || ' ').split('\n')[0] || ' ';
    c.font = `${px}px ${font}`;
    const chars = [...txt], ws = chars.map(ch => c.measureText(ch).width);
    const tw = ws.reduce((a, b) => a + b, 0) || 1;
    const m = measureText(c, txt, font, px);
    const sweep = Math.abs(l.curve) / 100 * Math.PI, R = tw / sweep, up = l.curve > 0;
    const sag = R * (1 - Math.cos(sweep / 2));
    const W0 = Math.min(tw, 2 * R * Math.sin(Math.min(sweep, Math.PI) / 2) + m.h * 2) + pad*2;
    if (W0 > MAX_BAKE_W) return {tooWide: W0};
    cv.width = Math.max(1, Math.round(Math.max(W0, tw * 0.3 + pad*2)));
    cv.height = Math.max(1, Math.round(sag + m.asc + m.desc + pad*2 + m.h * 0.4));
    c.font = `${px}px ${font}`;
    c.fillStyle = l.color; c.textAlign = 'center'; c.textBaseline = 'alphabetic';
    const cx = cv.width / 2;
    const cy = up ? pad + m.asc + R : pad + m.asc - R * Math.cos(sweep / 2);
    let run = -tw / 2;
    chars.forEach((ch, i) => {
      const phi = (run + ws[i] / 2) / R;
      run += ws[i];
      c.save();
      if (up){ c.translate(cx + R * Math.sin(phi), cy - R * Math.cos(phi)); c.rotate(phi); }
      else   { c.translate(cx + R * Math.sin(phi), cy + R * Math.cos(phi)); c.rotate(-phi); }
      c.fillText(ch, 0, 0);
      c.restore();
    });
  } else {
    const font = LAYER_FONTS[l.font] || LAYER_FONTS.block;
    const px = Math.round(B * 0.5);
    await fontReady(font, px);
    const lines = (l.text || ' ').split('\n').slice(0, 3);
    const ms = lines.map(t => measureText(c, t || ' ', font, px));
    const lead = Math.round(px * 1.15);
    const W0 = Math.max(...ms.map(m => m.w)) + pad*2;
    if (W0 > MAX_BAKE_W) return {tooWide: W0};
    cv.width  = Math.max(1, Math.round(W0));
    cv.height = Math.max(1, Math.round(lead * (lines.length - 1) + ms[0].asc + ms[ms.length-1].desc + pad*2));
    c.fillStyle = l.color; c.textBaseline = 'alphabetic';
    c.textAlign = l.align === 'left' ? 'left' : l.align === 'right' ? 'right' : 'center';
    const ax = l.align === 'left' ? pad : l.align === 'right' ? cv.width - pad : cv.width/2;
    lines.forEach((t, i) => {
      c.font = `${px}px ${font}`;
      c.fillText(t, ax, pad + ms[0].asc + lead * i);
    });
  }
  return {cv};
}

/* A long line at the full bake size is enormous — "In loving memory · 1948 – 2025" came
   to ~11,000 px wide, 18 M pixels: over the ~16.7 M an iPhone allows a canvas, and slow to
   trim anywhere. Nothing prints wider than the widest wrap (3,744 px), so a bake plans its
   size first and, if it would pass MAX_BAKE_W, is redrawn at a proportionally smaller font
   before any canvas that size is allocated. */
const MAX_BAKE_W = 3800;

async function bake(l){
  if (l.kind === 'photo') return bakePhoto(l);
  if (l.kind === 'logospot') return bakeLogoSpot(l);
  let r = await bakeAt(l, BAKE_PX);
  if (r.tooWide) r = await bakeAt(l, BAKE_PX * MAX_BAKE_W / r.tooWide * 0.98);
  const cv = r.cv;
  const inked = trimCanvas(cv);
  const m = Math.round(BAKE_PX * 0.02);
  const out = document.createElement('canvas');
  out.width = inked.width + m*2; out.height = inked.height + m*2;
  out.getContext('2d').drawImage(inked, m, m);
  l.src = out.toDataURL('image/png');
  l.w = out.width; l.h = out.height;
  return l;
}

let bakeSeq = 0;
/* Re-bakes a layer and redraws. Serialised per call so a fast typist can't have an
   earlier bake land after a later one. */
async function rebake(l){
  const mine = ++bakeSeq;
  await bake(l);
  if (mine === bakeSeq) render(true);
}

function addLayer(l){
  S.addOpen = false;
  l.id = ++layerSeq;
  // On the sandbox `s` is measured against the whole wrap, so a new piece starts at a
  // size that reads as a logo on the front rather than one covering half the tumbler.
  /* UV: a new design starts filling the print area's full width (or its full height, for a
     tall logo — `s` 1 is the largest that fits), kept inside the area vertically. On the
     sublimation sandbox `s` is against the whole wrap, so it starts at a logo's size. */
  l.x = 0.5; l.y = ART_DEFAULT_Y(); l.s = l.s || (sandboxMode() ? 0.32 : 1);
  if (!sandboxMode()) l.y = 0.5;          // centred on the crosshairs
  l.flip = false; l.rot = 0;
  // Text defaults to white ink for coloured tumblers; every sublimation blank is white.
  if (isSub() && l.color === '#FFFFFF') l.color = '#111111';
  clampToArea(l);
  S.layers.push(l);
  S.sel = l.id;
  S.zoom = false;
  return l;
}

const NEW_LAYER = {
  text:     () => ({kind:'text', text:'Your Text', font:'block', color:'#FFFFFF', align:'center'}),
  monogram: () => ({kind:'monogram', letters:'ABC', font:'script', color:'#FFFFFF'}),
  jersey:   () => ({kind:'jersey', name:'Your Name', number:'00', color:'#FFFFFF'}),
};

function addTextLayer(kind){
  const l = addLayer(NEW_LAYER[kind]());
  rebake(l);
}

function removeLayer(id){
  S.layers = S.layers.filter(l => l.id !== id);
  if (S.sel === id) S.sel = S.layers.length ? S.layers[S.layers.length-1].id : null;
  if (!S.layers.length) S.zoom = false;
  render(true);
}

/* The layer's on-screen box, as fractions of the print area. `s` is measured
   against the limiting side, so 1 means "as large as this area can print it" for
   any shape — the same meaning the size slider used to carry. */
function layerBox(l){
  const f = fitPct((l.w || 1) / (l.h || 1));
  return {w: f.w / 100 * l.s, h: f.h / 100 * l.s};
}

/* ================= image cleanup (UV only) =================
   Customer logos usually arrive as JPEGs sitting on a white box, which looks
   broken on a coloured tumbler. Everything here runs in the browser — no
   upload round-trip, no server cost. */
const FX_MAX = 1600;                       // cap working resolution for speed

/* ---------- upscaling ----------
   A single drawImage() into a much larger box is one bilinear step, and it goes
   soft fast. Doubling repeatedly and stopping at the target keeps noticeably more
   edge for the same one-liner at the call site.

   Be clear about what this is: resampling **cannot invent detail**. A 300px logo
   blown up to 900px is a 300px logo, sharper at the edges than a naive stretch
   and no more. Its value is that nobody gets told to go and re-export a file — we
   send the press a correctly sized file either way, and qualityOf() tells the
   customer honestly how much real resolution is behind it. */
/* ---------- enlarging ----------
   Measured, because the intuition here is wrong. Stepped doubling — resample to
   2x, again, again — is a real trick for *downscaling*, and it was shipped here
   for upscaling on the assumption it carried over. It does not: against a known
   900px original, a 150px source came back at 19.25 dB through one plain
   bilinear step and 18.72 dB through stepped doubling. Blurrier, visibly so on a
   wordmark, for more code.

   What does help is a mild unsharp afterwards: +1.0 dB over the plain step, and
   the sharpest option measured (a hand-rolled Lanczos plus unsharp, 21.23 dB)
   costs a custom resampler for another 1 dB.

   Keep all of it in proportion: 150px -> 450px of *source* is +5.2 dB. The file
   the customer uploads dominates everything we can do to it afterwards, which is
   why qualityOf() reports honestly rather than implying we fixed it. */
const SHARPEN_MIN = 1.6;                  // below this much enlargement, don't bother

/* Unsharp mask over a canvas, in place. Three box passes approximate a Gaussian
   closely enough for this and stay O(n) per pass. */
function unsharp(cv, radius, amount){
  const w = cv.width, h = cv.height;
  const ctx = cv.getContext('2d', {willReadFrequently:true});
  const id = ctx.getImageData(0, 0, w, h), src = id.data;
  const orig = new Uint8ClampedArray(src);
  const r = Math.max(1, Math.round(radius));

  const buf = new Float32Array(w * h * 3);
  for (let i = 0, p = 0; i < src.length; i += 4, p += 3){
    buf[p] = src[i]; buf[p+1] = src[i+1]; buf[p+2] = src[i+2];
  }
  const tmp = new Float32Array(buf.length);
  const pass = (from, to, horiz) => {
    const outer = horiz ? h : w, inner = horiz ? w : h;
    const step  = horiz ? 3 : w * 3;
    for (let o = 0; o < outer; o++){
      const base = horiz ? o * w * 3 : o * 3;
      for (let c = 0; c < 3; c++){
        let sum = 0, n = 0;
        for (let i = -r; i <= r; i++){
          if (i >= 0 && i < inner){ sum += from[base + i*step + c]; n++; }
        }
        for (let i = 0; i < inner; i++){
          to[base + i*step + c] = sum / n;
          const add = i + r + 1, sub = i - r;
          if (add < inner){ sum += from[base + add*step + c]; n++; }
          if (sub >= 0){ sum -= from[base + sub*step + c]; n--; }
        }
      }
    }
  };
  for (let k = 0; k < 3; k++){ pass(buf, tmp, true); pass(tmp, buf, false); }

  for (let i = 0, p = 0; i < src.length; i += 4, p += 3){
    if (orig[i+3] === 0) continue;                 // leave knocked-out pixels alone
    for (let c = 0; c < 3; c++){
      const d = orig[i+c] - buf[p+c];
      if (Math.abs(d) > 2) src[i+c] = orig[i+c] + amount * d;   // threshold: skip noise
    }
  }
  ctx.putImageData(id, 0, 0);
  return cv;
}

/* How much real resolution is behind what we are about to print, as a fraction
   of what the press wants. Replaces the old pass/warn notes: nothing is refused
   for being small any more, so the customer needs a reading rather than a
   verdict. */
/* The scale the bar draws, and the thresholds qualityOf() reads — one list, so a
   band can't say one thing while the reading says another. `upto` is the fraction
   of the needed resolution the band ends at; the widths on screen are those same
   numbers, so where the pin lands is literally where the file lands. */
const QUALITY_BANDS = [
  {upto: 0.40, lab: 'Soft',      col: 'var(--crit)',
   d: 'This is a small file for the size. We have enlarged it, but fine detail will look soft — making it smaller on the tumbler, or sending a bigger file, will print sharper.'},
  {upto: 0.60, lab: 'Fair',      col: 'var(--warn)',
   d: 'We have enlarged this to fit. It will print fine, but a larger file would be crisper.'},
  {upto: 0.90, lab: 'Good',      col: 'var(--good)',
   d: 'Enlarged a little, which will not show.'},
  // The accent, not a second green: Good and Excellent sit next to each other on
  // the scale, and two bands of one colour read as a single wide band whenever
  // neither is the active one.
  {upto: 1.00, lab: 'Excellent', col: 'var(--accent)',
   d: 'Full resolution for this size.'},
];

function qualityOf(a){
  a = a || S.art;
  if (!a || !((a.kind || a.type) === 'img' || (a.kind === 'photo' && a.ow))) return null;
  // A layer prints at whatever fraction of the area it currently occupies; a wrap
  // always prints at the full wrap size.
  const need = a.kind ? {w: Math.round(layerAreaW() * layerBox(a).w)}
                      : {w: areaW(), h: areaH()};
  // Measured against the file as uploaded, never the working copy: fitting a
  // wrap or upscaling for the press must not be able to flatter its own output.
  const r = Math.min(1, (a.ow || a.w) / Math.max(1, need.w));
  const i = QUALITY_BANDS.findIndex(b => r < b.upto);
  const band = QUALITY_BANDS[i === -1 ? QUALITY_BANDS.length - 1 : i];
  return {r, band, lab: band.lab, col: band.col, d: band.d};
}

/* The whole scale, with the file's own place marked on it. A lone fill bar said
   how full it was without saying full of what — the bands are what turn a length
   into a judgement the customer can act on. */
/* The compact reading every photo and logo row carries: label, the banded scale with its
   pin, and the verdict, on one line; the explanation is the tooltip. */
function qualityMini(q){
  let lo = 0;
  const segs = QUALITY_BANDS.map(b => {
    const w = (b.upto - lo) * 100; lo = b.upto;
    return el('span',{class:'seg'+(b === q.band ? ' on' : ''), style:`flex:${w} 0 auto; background:${b.col}`});
  });
  // Two short lines to fit the middle of a row: "Quality" and the verdict, then the bar
  // across the full width. The explanation is the tooltip.
  return el('div',{class:'qmini', title:`Print quality: ${q.lab}. ${q.d}`},
    el('div',{class:'qline'}, el('span',{class:'t'}, 'Quality'),
      el('span',{class:'lab', style:'color:'+q.col}, q.lab)),
    el('div',{class:'scale'}, ...segs,
      el('span',{class:'pin', style:`left:${Math.min(99, Math.max(1, q.r*100))}%`})));
}

function qualityBar(q){
  let lo = 0;
  const segs = QUALITY_BANDS.map(b => {
    const w = (b.upto - lo) * 100; lo = b.upto;
    return el('span',{class:'seg'+(b === q.band ? ' on' : ''),
                      style:`flex:${w} 0 auto; background:${b.col}`});
  });
  lo = 0;
  const ticks = QUALITY_BANDS.map(b => {
    const w = (b.upto - lo) * 100; lo = b.upto;
    return el('span',{style:`flex:${w} 0 auto`}, b.lab);
  });
  return el('div',{class:'qbar'},
    el('div',{class:'head'},
      el('span',{class:'t'}, 'Print quality'),
      el('span',{class:'lab', style:'color:'+q.col}, q.lab)),
    el('div',{class:'scale'}, ...segs,
      el('span',{class:'pin', style:`left:${Math.min(99.5, Math.max(0.5, q.r*100))}%`})),
    el('div',{class:'ticks'}, ...ticks),
    el('div',{class:'fx-note'}, q.d));
}

/* Redraws artwork onto exactly the wrap's pixel size.

   A sublimation wrap has one legal shape, and the old behaviour was to refuse
   anything else and say "Resize and upload again" — the single place this app
   sent someone away to do work itself could do. `cover` fills the wrap and loses
   the overflow; `contain` keeps all of it and pads. Neither distorts, which is
   the one thing that must not happen to a wrap. */
/* How a fitted wrap is held in memory. JPEG, not PNG, for the same reason the wrap's
   print file is (see renderPrint): a full wrap is opaque edge to edge, so PNG's alpha
   channel protects nothing — and it is expensive. Measured on a 2,776 x 2,421 wrap:
   PNG is a **14.2 MB** data URL taking 627 ms to encode, JPEG q0.95 is 1.8 MB in 131 ms.
   That string is held in S.art.src for the whole session and re-decoded on every render,
   which is survivable on a desktop and a real hazard on a phone. UV layers keep PNG —
   they are artwork on transparency and the alpha is the point. */
const WRAP_MIME = 'image/jpeg', WRAP_Q = 0.95;
const wrapURL = cv => {
  const u = cv.toDataURL(WRAP_MIME, WRAP_Q);
  // A canvas the browser refused to allocate encodes as the bare "data:," — throw so the
  // caller reports it instead of putting an empty wrap on the tumbler.
  if (u.length < 32) throw new Error('canvas could not be encoded');
  return u;
};

/* Let the browser actually draw before starting work that blocks it.

   render() mutates the DOM but nothing is painted until the task yields, and fitting a
   wrap — drawImage into a multi-megapixel canvas, then toDataURL — is entirely
   synchronous. So `S.fxBusy = true; render(true)` followed straight away by the fit put
   the spinner in the DOM and then froze the main thread before a single frame went out:
   the customer saw no busy state at all, just an unresponsive page, and then everything
   appearing at once. Awaiting an image is not enough of a yield either — a cached image
   resolves in a microtask, which still runs before paint.

   Two frames, not one: the first is when the new DOM gets its style and layout, the
   second is when it has actually been presented. */
/* Raced against a timer: a background tab pauses requestAnimationFrame entirely, and an
   upload started just before switching tabs must not sit on its spinner until they return. */
const paint = () => Promise.race([
  new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r))),
  new Promise(r => setTimeout(r, 120))]);

function fitToWrap(img, w, h, mode){
  const cv = document.createElement('canvas');
  cv.width = w; cv.height = h;
  const c = cv.getContext('2d');
  c.imageSmoothingEnabled = true; c.imageSmoothingQuality = 'high';
  const iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
  const k = mode === 'contain' ? Math.min(w/iw, h/ih) : Math.max(w/iw, h/ih);
  const dw = iw * k, dh = ih * k;
  c.drawImage(img, (w-dw)/2, (h-dh)/2, dw, dh);
  if (k >= SHARPEN_MIN) unsharp(cv, k * 0.6, 0.8);
  return cv;
}
const hexRGB = h => [parseInt(h.slice(1,3),16), parseInt(h.slice(3,5),16), parseInt(h.slice(5,7),16)];

function imageDataOf(img, maxSide){
  const s = Math.min(1, maxSide / Math.max(img.naturalWidth, img.naturalHeight));
  const cv = document.createElement('canvas');
  cv.width  = Math.max(1, Math.round(img.naturalWidth  * s));
  cv.height = Math.max(1, Math.round(img.naturalHeight * s));
  const ctx = cv.getContext('2d', {willReadFrequently:true});
  ctx.drawImage(img, 0, 0, cv.width, cv.height);
  return {cv, ctx, id: ctx.getImageData(0, 0, cv.width, cv.height), scale: s};
}

/* Is there a flat, opaque background worth knocking out? */
function looksMatted(id){
  const d = id.data, w = id.width, h = id.height;
  const c = [[0,0],[w-1,0],[0,h-1],[w-1,h-1]].map(([x,y]) => (y*w+x)*4);
  if (!c.every(i => d[i+3] > 250)) return false;      // already has transparency
  let spread = 0;
  for (const i of c) for (const j of c)
    spread = Math.max(spread, Math.abs(d[i]-d[j]) + Math.abs(d[i+1]-d[j+1]) + Math.abs(d[i+2]-d[j+2]));
  return spread < 30;
}

/* Flood in from the edges rather than keying a colour globally, so white
   *inside* a logo (a knockout letter, an eye) survives. */
function knockoutBG(id, tol){
  const d = id.data, w = id.width, h = id.height;
  let cleared = 0;
  const corners = [[0,0],[w-1,0],[0,h-1],[w-1,h-1]].map(([x,y]) => (y*w+x)*4);
  const bg = [0,1,2].map(k => Math.round(corners.reduce((a,i) => a + d[i+k], 0) / 4));
  const dist = i => Math.abs(d[i]-bg[0]) + Math.abs(d[i+1]-bg[1]) + Math.abs(d[i+2]-bg[2]);

  const seen = new Uint8Array(w*h);
  const stack = [];
  const push = (x,y) => { if (x>=0 && y>=0 && x<w && y<h && !seen[y*w+x]) stack.push(x,y); };
  const flood = () => {
    let n = 0;
    while (stack.length){
      const y = stack.pop(), x = stack.pop(), p = y*w+x;
      if (seen[p]) continue;
      const i = p*4;
      if (dist(i) > tol) continue;
      seen[p] = 1; d[i+3] = 0; n++;
      push(x+1,y); push(x-1,y); push(x,y+1); push(x,y-1);
    }
    return n;
  };

  for (let x=0;x<w;x++){ push(x,0); push(x,h-1); }
  for (let y=0;y<h;y++){ push(0,y); push(w-1,y); }
  cleared = flood();

  /* The counters of letters, and the hole in the middle of a ring, are background
     the border flood can never reach — it is walled in by the ink around it. So
     the same test is run again from every background-coloured pixel left over.

     This is deliberately not the global colour key the flood was chosen over: a
     key clears any matching pixel anywhere, including the pale side of a gradient
     and the anti-aliased fringe inside dark ink, which is what shredded artwork.
     Seeding whole enclosed *regions* is the option in between, and it's the one a
     logo actually wants. Not optional: an enclosed region that matches the outer
     background is background in every logo anyone has sent, and asking the
     customer to adjudicate that is asking them to do our job. */
  for (let p = 0; p < w*h; p++){
    if (seen[p] || dist(p*4) > tol) continue;
    push(p % w, (p / w) | 0);
    flood();
  }

  // Soften the cut edge so the logo doesn't look stencilled.
  const a = new Uint8ClampedArray(d.length); a.set(d);
  for (let y=0;y<h;y++) for (let x=0;x<w;x++){
    const p = y*w+x, i = p*4;
    if (d[i+3] === 0) continue;
    const touching = (x>0 && d[(p-1)*4+3]===0) || (x<w-1 && d[(p+1)*4+3]===0)
                  || (y>0 && d[(p-w)*4+3]===0) || (y<h-1 && d[(p+w)*4+3]===0);
    if (touching) a[i+3] = Math.round(255 * Math.min(1, dist(i) / (tol * 1.6)));
  }
  d.set(a);
  return cleared / (w * h);          // caller warns if this found nothing
}

/* Recolour the artwork to a single ink, keeping its shape and soft edges.
   With no transparency to work from, darkness becomes the shape. */
function inkify(id, hex){
  const [r,g,b] = hexRGB(hex), d = id.data;
  let hasAlpha = false;
  for (let i=3;i<d.length;i+=4) if (d[i] < 250){ hasAlpha = true; break; }
  for (let i=0;i<d.length;i+=4){
    if (!hasAlpha){
      const lum = d[i]*0.299 + d[i+1]*0.587 + d[i+2]*0.114;
      d[i+3] = Math.round(255 * Math.min(1, Math.max(0, (245 - lum) / 200)));
    }
    if (d[i+3] > 0){ d[i] = r; d[i+1] = g; d[i+2] = b; }
  }
}

/* Drop empty margins so the art fills the print area instead of floating. Scans inward
   from each edge and stops at the first ink, so a mostly-empty margin costs little. */
function trimCanvas(cv){
  const W = cv.width, H = cv.height;
  const d = cv.getContext('2d', {willReadFrequently:true}).getImageData(0, 0, W, H).data;
  const ink = (x, y) => d[(y*W + x)*4 + 3] > 8;
  let y0 = 0, y1 = H - 1, x0 = 0, x1 = W - 1, hit;
  for (hit = false; y0 < H && !hit; y0++) for (let x = 0; x < W; x++) if (ink(x, y0)){ hit = true; break; }
  if (!hit) return cv;
  y0--;
  for (hit = false; y1 > y0 && !hit; y1--) for (let x = 0; x < W; x++) if (ink(x, y1)){ hit = true; break; }
  y1++;
  for (hit = false; x0 < W && !hit; x0++) for (let y = y0; y <= y1; y++) if (ink(x0, y)){ hit = true; break; }
  x0--;
  for (hit = false; x1 > x0 && !hit; x1--) for (let y = y0; y <= y1; y++) if (ink(x1, y)){ hit = true; break; }
  x1++;
  const out = document.createElement('canvas');
  out.width = x1 - x0 + 1; out.height = y1 - y0 + 1;
  out.getContext('2d').drawImage(cv, x0, y0, out.width, out.height, 0, 0, out.width, out.height);
  return out;
}

/* Relative luminance, for deciding what will actually read on this tumbler. */
function lumOf(hex){
  const [r,g,b] = hexRGB(hex).map(v => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });
  return 0.2126*r + 0.7152*g + 0.0722*b;
}
/* Which single ink contrasts best with the selected colourway. */
const bestInk = () => lumOf(S.variant.swatch || '#888888') < 0.32 ? 'white' : 'black';

let fxToken = 0;
function processLayer(l){
  if (!l || l.kind !== 'img' || !l.orig) return;
  const mine = ++fxToken;
  S.fxBusy = true;
  const img = new Image();
  img.onload = () => {
    if (mine !== fxToken) return;                    // a newer run superseded this
    let {cv, ctx, id, scale} = imageDataOf(img, FX_MAX);
    l.fxRemoved = l.fx.removeBg ? knockoutBG(id, 34) : null;
    if (l.fx.ink !== 'original') inkify(id, l.fx.ink === 'white' ? '#FFFFFF' : '#111111');
    ctx.putImageData(id, 0, 0);
    if (l.fx.trim) cv = trimCanvas(cv);
    l.src = cv.toDataURL('image/png');
    // Report resolution in the original file's terms, not the working copy's.
    l.w = Math.round(cv.width  / scale);
    l.h = Math.round(cv.height / scale);
    if (l.fitTo){ sizePiece(l, l.fitTo.hf, l.fitTo.wf); clampToArea(l); delete l.fitTo; }
    S.fxBusy = false;
    render(true);
  };
  img.src = l.orig;
}


/* Centre of motif `x` in row `y` of a staggered (brick) layout with `px` between columns.
   Rows sit a quarter and three quarters of a column in, not at 0 and a half: at 0 the
   first motif of every other row lands on the seam, split between the two ends of the
   sheet, and a sublimation sheet's ends never meet exactly. A motif narrower than half a
   column never touches either edge, and the spacing across the seam matches the rest. */
const brickX = (x, y, px) => (x + (y % 2 ? 0.75 : 0.25)) * px;

function drawPattern(c, kind, color, w, h){
  c.fillStyle = '#FFFFFF'; c.fillRect(0, 0, w, h);
  c.fillStyle = color; c.strokeStyle = color;

  // n is a whole number of repeats across the wrap, so the seam lines up.
  if (kind === 'stripes'){
    const n = Math.max(10, Math.round(w / 150)), p = w / n;
    for (let i = 0; i < n; i++) c.fillRect(i * p, 0, p * 0.5, h);

  } else if (kind === 'dots'){
    const cols = Math.max(8, Math.round(w / 190)), rows = Math.max(2, Math.round(h / 190));
    const px = w / cols, py = h / rows, r = Math.min(px, py) * 0.17;
    for (let y = 0; y < rows; y++)
      for (let x = 0; x < cols; x++){
        c.beginPath(); c.arc(brickX(x, y, px), y * py + py / 2, r, 0, 7); c.fill();
      }

  } else if (kind === 'chevron'){
    const n = Math.max(8, Math.round(w / 210)), p = w / n;
    c.lineWidth = p * 0.20; c.lineJoin = 'round'; c.lineCap = 'round';
    const band = h / 2;
    for (let row = -1; row <= 2; row++)
      for (let i = 0; i < n; i++){
        const y = row * band;
        c.beginPath();
        c.moveTo(i * p, y + band * 0.62);
        c.lineTo(i * p + p / 2, y + band * 0.12);
        c.lineTo(i * p + p, y + band * 0.62);
        c.stroke();
      }

  } else {                                            // grid
    const n = Math.max(10, Math.round(w / 160)), p = w / n;
    c.lineWidth = Math.max(2, p * 0.08);
    for (let i = 0; i < n; i++){ const x = i * p + p / 2; c.beginPath(); c.moveTo(x, 0); c.lineTo(x, h); c.stroke(); }
    for (let y = 0; y <= h; y += p){ c.beginPath(); c.moveTo(0, y); c.lineTo(w, y); c.stroke(); }
  }
}



/* ================= "Start with" templates (sublimation, Create your own) =================
   Most people designing a wrap arrive with a photo of their people or their dog and an
   occasion, not a blank canvas — so the tab leads with starters, and Start from scratch
   comes last. A template is only a head start: it lays out the same pieces the add buttons
   make (photo spots, Text with sample wording like "The Johnsons", a Jersey) and switches on
   a background. Nothing is locked; the wording is changed in each piece's own box.

   Positions are fractions of the wrap; x = 0.5 is the front. Photos are sized by share of
   the wrap's height (`hf`) capped by share of its width (`wf`), text by width (`s`), so one
   layout reads on a tall Skinny wrap and a wide mug alike — clampToArea() keeps anything
   from spilling on the extremes. */
const TPL_FONT_INK = '#111111';
/* Template wording starts black, which vanishes on a dark Solid color background (purple,
   navy, black…). Text still on its automatic ink follows the background instead — white on
   a dark solid, black otherwise — until the customer picks a colour for it themselves
   (`autoInk` off). Patterns keep black: they're mostly white ground. */
function bgIsDark(){
  if (!bgActive() || S.wrapBg.kind !== 'solid') return false;
  const [r, g, b] = hexRGB(S.wrapBg.color || '#FFFFFF');
  return 0.2126 * r + 0.7152 * g + 0.0722 * b < 140;
}
const autoInk = () => bgIsDark() ? '#FFFFFF' : TPL_FONT_INK;
function syncAutoInk(){
  const ink = autoInk();
  const due = S.sides.front.filter(l => l.autoInk && l.color !== ink);
  if (!due.length) return;
  due.forEach(l => { l.color = ink; });
  // All of them re-baked, then one render. rebake() per piece renders only for the last one
  // started, so a piece finishing after it kept its old bitmap in the design area (the views
  // redraw themselves on image load, which is why they looked right).
  Promise.all(due.map(l => bake(l))).then(() => render(true));
}
/* Photo collage layouts. Side by side: spaced, rounded photos across the front. Fill the
   wrap and Mosaic: photos edge to edge over the whole wrap (between the handle strips), no
   white left — what people ask for when the photos are the point. Mosaic mixes one large
   photo with smaller ones. Rects are [x, y, w, h] as shares of the usable width / height. */
const MOSAIC = {
  2: [[0, 0, 0.62, 1], [0.62, 0, 0.38, 1]],
  3: [[0, 0, 0.5, 1], [0.5, 0, 0.5, 0.5], [0.5, 0.5, 0.5, 0.5]],
  4: [[0, 0, 0.5, 0.5], [0.5, 0, 0.5, 0.5], [0, 0.5, 0.5, 0.5], [0.5, 0.5, 0.5, 0.5]],
};
const COLLAGE_LAYOUTS = [['row','Side by side'], ['fill','Fill the wrap'], ['mosaic','Mosaic']];
function collagePieces(n, layout){
  if (layout !== 'fill' && layout !== 'mosaic' && swigSides()){
    // Split between the two sides, the main (left) side first: 1+1, 1+2, 2+2.
    const left = n === 4 ? 2 : 1, right = n - left;
    const side = (k, c) => Array.from({length:k}, (_, i) => ({photo:'rounded', ar:0.8,
      x: c - 0.2 + 0.4 * (i + 0.5) / k, y:0.5, hf:0.72, wf:0.38 / k - 0.02}));
    return side(left, 0.25).concat(side(right, 0.75));
  }
  if (layout !== 'fill' && layout !== 'mosaic')
    return Array.from({length:n}, (_, i) => ({photo:'rounded', ar:0.8,
      x:(i + 0.5) / n, y:0.5, hf:0.82, wf:0.9 / n - 0.03}));
  /* A white gutter between photos, the same width round the outside (half at each end,
     which the seam puts back together), and softly rounded corners — a thin hairline
     between square photos read as a mistake rather than a border. */
  const W = areaW(), H = areaH(), hz = handleFrac() / 2;
  const gx = 0.014, gy = gx * W / H;
  const x0 = hz + gx / 2, span = 1 - x0 * 2, y0 = gy, vspan = 1 - gy * 2;
  const rects = layout === 'fill'
    ? Array.from({length:n}, (_, i) => [i / n, 0, 1 / n, 1]) : MOSAIC[n];
  return rects.map(([rx, ry, rw, rh]) => {
    const wf = rw * span - gx, hf = rh * vspan - gy;
    return {photo:'soft', ar:(wf * W) / (hf * H),
            x: x0 + (rx + rw / 2) * span, y: y0 + (ry + rh / 2) * vspan, hf, wf};
  });
}

/* On a handled body — the Big Swig and the coffee mug — the handle sits on the seam, so the
   middle of the wrap (the Front view) faces away from whoever holds it. Held right-handed,
   the LEFT view (x 0.25) faces out — that's the main side — and the RIGHT view (x 0.75) is
   the other. So there a template uses its `swig` layout: the photo and the headline centred
   on the main side, the secondary wording (a name, a date, a year) centred on the other.
   Half the wrap each, so pieces are capped near 0.3–0.38 of the width to stay clear of the
   handle. */
const swigSides = () => !!S.product && ['bigswig', 'coffeemug'].includes(S.product.group);

const TEMPLATES = [
  {id:'pet',      name:'Pet', hint:'Photo and their name', bg:{kind:'paws', color:'#F4B6C2'},
   pieces:()=>[{photo:'circle', x:0.5, y:0.4, hf:0.6, wf:0.34},
               {t:'Biscuit', font:'block', x:0.5, y:0.85, s:0.3, curve:-35, color:'#C2567A'}],
   // Main: the photo with the name curved under it. Other side: the name again, large.
   swig:()=>[{photo:'circle', x:0.25, y:0.37, hf:0.58, wf:0.3},
             {t:'Biscuit', font:'block', x:0.25, y:0.87, s:0.2, curve:-35, color:'#C2567A'},
             {t:'Biscuit', font:'block', x:0.75, y:0.5, s:0.28, color:'#C2567A'}]},
  {id:'collage',  name:'Photo collage', hint:'2–4 photos, spaced or filling the wrap', count:true, bg:null,
   pieces:(n, layout) => collagePieces(n, layout)},
  {id:'wedding',  name:'Wedding', hint:'Two photos, names, date', bg:{kind:'hearts', color:'#E8A0A8'},
   pieces:()=>[{photo:'rounded', ar:0.8, x:0.39, y:0.38, hf:0.5, wf:0.2},
               {photo:'rounded', ar:0.8, x:0.61, y:0.38, hf:0.5, wf:0.2},
               {t:'Alex & Jordan', font:'script', x:0.5, y:0.77, s:0.42},
               {t:'June 14, 2026', font:'serif', x:0.5, y:0.9, s:0.2}],
   // Main: both photos and the names. Other side: the date.
   swig:()=>[{photo:'rounded', ar:0.8, x:0.155, y:0.38, hf:0.52, wf:0.17},
             {photo:'rounded', ar:0.8, x:0.345, y:0.38, hf:0.52, wf:0.17},
             {t:'Alex & Jordan', font:'script', x:0.25, y:0.82, s:0.32},
             {t:'June 14, 2026', font:'serif', x:0.75, y:0.5, s:0.28}]},
  {id:'family',   name:'Family', hint:'Three photos and your name', bg:null,
   pieces:()=>[0.3, 0.5, 0.7].map(x => ({photo:'rounded', ar:0.8, x, y:0.4, hf:0.5, wf:0.17}))
     .concat([{t:'The Johnsons', font:'serif', x:0.5, y:0.8, s:0.4},
              {t:'Est. 2012', font:'sans', x:0.5, y:0.91, s:0.16}]),
   // Three photos don't fit one side, so: main — one wide photo over the name and year;
   // other side — the other two photos.
   swig:()=>[{photo:'rounded', ar:1.25, x:0.25, y:0.36, hf:0.5, wf:0.34},
             {t:'The Johnsons', font:'serif', x:0.25, y:0.76, s:0.3},
             {t:'Est. 2012', font:'sans', x:0.25, y:0.89, s:0.12},
             {photo:'rounded', ar:0.8, x:0.655, y:0.48, hf:0.62, wf:0.17},
             {photo:'rounded', ar:0.8, x:0.845, y:0.48, hf:0.62, wf:0.17}]},
  {id:'birthday', name:'Birthday', hint:'Photo, name, confetti', bg:{kind:'confetti', color:'#61458B'},
   pieces:()=>[{photo:'circle', x:0.5, y:0.37, hf:0.5, wf:0.3},
               {t:'Happy Birthday', font:'script', x:0.5, y:0.73, s:0.4},
               {t:'Emma', font:'block', x:0.5, y:0.88, s:0.24}],
   // Main: the photo and the greeting. Other side: the name, large.
   swig:()=>[{photo:'circle', x:0.25, y:0.38, hf:0.58, wf:0.3},
             {t:'Happy Birthday', font:'script', x:0.25, y:0.83, s:0.32},
             {t:'Emma', font:'block', x:0.75, y:0.5, s:0.26}]},
  {id:'memorial', name:'Memorial', hint:'Photo, name and dates', bg:null,
   pieces:()=>[{photo:'rounded', ar:0.8, x:0.5, y:0.38, hf:0.56, wf:0.28},
               {t:'Margaret Ellis', font:'serif', x:0.5, y:0.78, s:0.36},
               {t:'In loving memory · 1948 – 2025', font:'sans', x:0.5, y:0.9, s:0.34}],
   // Main: the photo and the name. Other side: "In loving memory" and the dates.
   swig:()=>[{photo:'rounded', ar:0.8, x:0.25, y:0.4, hf:0.62, wf:0.28},
             {t:'Margaret Ellis', font:'serif', x:0.25, y:0.85, s:0.3},
             {t:'In loving memory', font:'script', x:0.75, y:0.44, s:0.3},
             {t:'1948 – 2025', font:'serif', x:0.75, y:0.6, s:0.18}]},
  {id:'graduation', name:'Graduation', hint:'Photo, name, class year', bg:{kind:'stars', color:'#C9A227'},
   pieces:()=>[{photo:'circle', x:0.5, y:0.37, hf:0.5, wf:0.3},
               {t:'Jordan Lee', font:'block', x:0.5, y:0.75, s:0.32},
               {t:'Class of 2026', font:'serif', x:0.5, y:0.89, s:0.26}],
   // Main: the photo and the name. Other side: the class year, large.
   swig:()=>[{photo:'circle', x:0.25, y:0.38, hf:0.58, wf:0.3},
             {t:'Jordan Lee', font:'block', x:0.25, y:0.84, s:0.26},
             {t:'Class of 2026', font:'serif', x:0.75, y:0.5, s:0.3}]},
  // A logo on one side, the jersey on the other: x 0.25 and 0.75 are the middles of the
  // two halves either side of the seam (and of the handle, on a handled body).
  {id:'sports',   name:'Sports', hint:'Team logo on one side, jersey on the other', bg:{kind:'pinstripes', color:'#B02A2A'},
   pieces:()=>[{logo:true, x:0.25, y:0.45, hf:0.55, wf:0.3},
               {jersey:{name:'Mason', number:'12'}, x:0.75, y:0.45, s:0.22}]},
  {id:'christmas', name:'Christmas', hint:'Family photo, greeting', bg:{kind:'snow', color:'#14566B'},
   pieces:()=>[{photo:'rounded', ar:1.25, x:0.5, y:0.38, hf:0.5, wf:0.32},
               {t:'Merry Christmas', font:'script', x:0.5, y:0.76, s:0.42},
               {t:'The Johnsons', font:'serif', x:0.5, y:0.9, s:0.28}],
   // Main: the family photo and the greeting. Other side: the family name.
   swig:()=>[{photo:'rounded', ar:1.25, x:0.25, y:0.38, hf:0.54, wf:0.34},
             {t:'Merry Christmas', font:'script', x:0.25, y:0.83, s:0.32},
             {t:'The Johnsons', font:'serif', x:0.75, y:0.5, s:0.3}]},
  /* A logo (or any first piece) tiled across the whole wrap. It's a whole-design choice,
     not a background under other pieces, so it's a starter: the tiled piece itself isn't
     drawn on its own (`isTile`) — the pattern is the design. */
  {id:'repeat',   name:'Step and repeat', hint:'Your logo tiled all over', bg:{kind:'repeat'}, repeat:true,
   pieces:()=>[{logo:true, x:0.5, y:0.5, hf:0.4, wf:0.3}]},
  // Last: for anyone whose idea isn't one of the above. Clears the wrap to a blank one.
  {id:'scratch',  name:'Start from scratch', hint:'A blank wrap', bg:null, pieces:()=>[]},
];

const tplById = id => TEMPLATES.find(t => t.id === id);

/* Lays a template out, replacing the design. Photos already added move into the new
   layout's spots in order, so trying a different template never loses an upload. */
async function applyTemplate(id){
  const t = tplById(id);
  const keep = S.sides.front.filter(l => l.kind === 'photo' && l.photo).map(l => l.photo)
    .concat(S.tpl.spare || []);
  const keepLogos = S.sides.front.filter(l => l.kind === 'img')
    .concat(S.tpl.spareLogos || []);
  S.tpl.id = id;
  S.sides.front = []; S.sel = null;
  S.wrapBgOn = !!t.bg;
  if (t.bg) Object.assign(S.wrapBg, t.bg);
  const layout = swigSides() && t.swig ? t.swig : t.pieces;
  /* Side layouts are drawn for the 30oz Big Swig's shape (about 2:1). Text is sized by width,
     so on a wider, shorter area (the mug, ~2.4:1) it would come out taller relative to the
     photos and run into them — scaled back by the difference. */
  const ts = layout === t.swig ? Math.min(1, 2.05 / (areaW() / areaH())) : 1;
  for (const sp of layout(S.tpl.count, S.tpl.layout)){
    let l;
    if (sp.photo){
      l = addLayer({kind:'photo', slot:true, frame:sp.photo, ar:sp.ar || 1, slotAr:sp.ar || 1,
                    photo: keep.shift() || null});
      await bakePhoto(l);
      sizePiece(l, sp.hf, sp.wf);
    } else if (sp.logo){
      const had = keepLogos.shift();
      l = addLayer(had ? logoFields(had) : {kind:'logospot'});
      if (had) sizePiece(l, sp.hf, sp.wf);
      else { l.fitTo = {hf: sp.hf, wf: sp.wf}; await bake(l); sizePiece(l, sp.hf, sp.wf); }
    } else if (sp.jersey){
      l = addLayer({kind:'jersey', name:sp.jersey.name, number:sp.jersey.number, color:autoInk()});
      l.autoInk = true;
      await bake(l); l.s = sp.s * ts;
    } else {
      l = addLayer({kind:'text', text:sp.t, font:sp.font, color:sp.color || autoInk(), align:'center', curve:sp.curve || 0});
      l.autoInk = !sp.color;
      await bake(l); l.s = sp.s * ts;
    }
    l.x = sp.x; l.y = sp.y;
  }
  S.tpl.spare = keep;                       // photos with no spot here, for the next template
  S.tpl.spareLogos = keepLogos;             // and logos
  S.sel = null;
  S.sides.front.forEach(clampToArea);
  render(true);
}

/* "Start with": the templates, then Start from scratch last, as a row of chips. */
function templateUI(){
  const box = el('div',{class:'tpl-box'});
  box.appendChild(el('div',{class:'panel-label'}, 'Start with'));
  box.appendChild(el('div',{class:'chips'}, TEMPLATES.map(t =>
    el('button',{class:'chip'+(S.tpl.id===t.id?' on':'')+(t.id==='scratch'?' chip-scratch':''),
      title:t.hint, onclick:()=>{ applyTemplate(t.id); }}, t.name))));
  return box;
}

/* A template's own settings — the collage's count and layout, step and repeat's tile size
   and tilt — under the pieces list, after the line items rather than between the
   template chips and the pieces they lay out. */
function templateOptionsUI(){
  const t = tplById(S.tpl.id);
  if (!t || !(t.count || t.repeat)) return null;
  const box = el('div',{class:'tpl-opts'});
  if (t.count){
    box.appendChild(el('div',{class:'panel-label'}, 'Collage layout'));
    box.appendChild(el('div',{class:'tabs', style:'margin:0'}, [2, 3, 4].map(n =>
      el('button',{class:'tab'+(S.tpl.count===n?' on':''),
        onclick:()=>{ S.tpl.count = n; applyTemplate('collage'); }}, `${n} photos`))));
    box.appendChild(el('div',{class:'tabs', style:'margin:6px 0 0'}, COLLAGE_LAYOUTS.map(([v, lab]) =>
      el('button',{class:'tab'+(S.tpl.layout===v?' on':''),
        onclick:()=>{ S.tpl.layout = v; applyTemplate('collage'); }}, lab))));
  }
  if (t.repeat){
    box.appendChild(el('div',{class:'panel-label'}, 'Pattern'));
    box.appendChild(el('div',{class:'tabs', style:'margin:0'},
      [['s','Small'],['m','Medium'],['l','Large']].map(([v,lab]) =>
        el('button',{class:'tab'+(S.wrapBg.size===v?' on':''), onclick:()=>{ S.wrapBg.size = v; render(true); }}, lab))));
    const tl = v => v ? `${Math.abs(v)}° ${v > 0 ? 'right' : 'left'}` : 'Straight';
    const tOut = el('em',{}, tl(S.wrapBg.tilt || 0));
    box.appendChild(el('div',{style:'margin:10px 0 0'},
      el('div',{class:'slider-lab'}, el('span',{}, 'Tilt'), tOut),
      // The pattern redraws live while dragging (it's one cached canvas); release records it.
      el('input',{type:'range', min:'-45', max:'45', step:'5', value:String(S.wrapBg.tilt || 0),
        oninput:e=>{ S.wrapBg.tilt = +e.target.value; tOut.textContent = tl(S.wrapBg.tilt); scheduleViews(); },
        onchange:()=>render(true)})));
    if (repeatSource()) box.appendChild(el('div',{class:'fx-note'},
      'Your logo is tiled across the whole tumbler. Add text or more designs on top if you like.'));
  }
  return box;
}

/* ================= photo pieces =================
   People and pets, not logos. A logo upload is cleaned up — its background knocked out,
   its margins trimmed — which is exactly wrong for a photo of someone's dog. A photo piece
   keeps the whole picture, cropped to fill a frame (square, rounded, circle, heart).

   It can also be an *empty spot*: a template lays out where photos go before anyone has
   uploaded one. An empty spot shows "Add photo" in the design area and nowhere else — the
   views, the mockup and the print file draw only `inked()` pieces — and blocks checkout
   until it's filled or removed. Pressing it opens the file picker. */
const PHOTO_FRAMES = [['asis','As is'], ['rounded','Rounded'], ['circle','Circle'], ['heart','Heart']];
const PHOTO_PX = 1800;                 // baked long side: a 4" photo on a wrap is ~1,200 px

const isEmptySpot = l => (l.kind === 'photo' && !l.photo) || l.kind === 'logospot';
/* Step and repeat: the piece being tiled is the pattern's source, not a piece of its own. */
const isTile = l => S.tpl.id === 'repeat' && sandboxMode() && S.artTab === 'logo' && l === repeatSource();
/* Pieces drawn as themselves — everything except an empty photo spot or a tile's source. */
const inked = () => printing().filter(l => !isEmptySpot(l) && !isTile(l));

function framePath(c, frame, w, h){
  c.beginPath();
  if (frame === 'circle'){ c.ellipse(w/2, h/2, w/2, h/2, 0, 0, Math.PI * 2); }
  else if (frame === 'heart'){
    c.moveTo(w/2, h*0.97);
    c.bezierCurveTo(-w*0.12, h*0.52, w*0.08, -h*0.06, w/2, h*0.24);
    c.bezierCurveTo(w*0.92, -h*0.06, w*1.12, h*0.52, w/2, h*0.97);
  }
  // A generous radius: at 9% the corners barely read as rounded at all.
  else if (frame === 'rounded'){ const r = Math.min(w, h) * 0.18; c.roundRect(0, 0, w, h, r); }
  // Collage cells: corners just softened, since a cell's short side can be narrow.
  else if (frame === 'soft'){ const r = Math.min(w, h) * 0.06; c.roundRect(0, 0, w, h, r); }
  else c.rect(0, 0, w, h);
}

/* Bakes a photo piece to a bitmap like every other piece: the photo cropped to fill the
   frame's aspect (`l.ar`, width / height) and cut to its shape — or, with no photo yet,
   the "Add photo" spot. */
/* Where a photo sits inside a W x H frame. It covers the frame, times `zoom` (>= 1); `pan`
   is -1..1 on each axis across whatever overflows — 0 centred, -1 showing the photo's
   left/top edge, 1 its right/bottom. Kept as fractions, not pixels, so the same placement
   holds at the adjust view's size, the bake's, and after the frame changes shape. */
function photoPlace(im, W, H, zoom, pan){
  const k = Math.max(W / im.naturalWidth, H / im.naturalHeight) * Math.max(1, zoom || 1);
  const dw = im.naturalWidth * k, dh = im.naturalHeight * k;
  const px = pan ? pan.x : 0, py = pan ? pan.y : 0;
  return {k, dw, dh, x: (W - dw) / 2 - px * (dw - W) / 2, y: (H - dh) / 2 - py * (dh - H) / 2};
}

/* The frame's shape (width / height) for a frame choice: round frames are square, As is is
   the photo's own shape, and Rounded / square keeps a template spot's shape (or, for a
   photo added on its own, the photo's). */
function frameAr(l, frame){
  if (frame === 'circle' || frame === 'heart') return 1;
  if (frame === 'asis' || !l.slotAr) return l.photo ? l.photo.w / l.photo.h : (l.slotAr || 1);
  return l.slotAr;
}

/* An empty spot's face: grey, with a camera (photos) or an upload arrow (logos). */
function drawSpot(c, W, H, label, camera){
  c.fillStyle = '#E7ECF0'; c.fillRect(0, 0, W, H);
  c.fillStyle = '#8A97A3';
  const u = Math.min(W, H);
  if (camera){
    c.beginPath(); c.roundRect(W/2 - u*0.14, H/2 - u*0.16, u*0.28, u*0.2, u*0.03); c.fill();
    c.fillStyle = '#E7ECF0'; c.beginPath(); c.arc(W/2, H/2 - u*0.06, u*0.06, 0, 7); c.fill();
  } else {
    c.beginPath(); c.moveTo(W/2, H/2 - u*0.2); c.lineTo(W/2 + u*0.12, H/2 - u*0.06);
    c.lineTo(W/2 - u*0.12, H/2 - u*0.06); c.closePath(); c.fill();
    c.fillRect(W/2 - u*0.04, H/2 - u*0.07, u*0.08, u*0.13);
  }
  c.fillStyle = '#5C6A78'; c.font = `600 ${Math.round(u*0.075)}px "IBM Plex Sans", sans-serif`;
  c.textAlign = 'center'; c.fillText(label, W/2, H/2 + u*0.16);
}

/* A template's empty logo spot. Never printed, so drawn small. */
function bakeLogoSpot(l){
  const cv = document.createElement('canvas'); cv.width = 600; cv.height = 600;
  drawSpot(cv.getContext('2d'), 600, 600, 'Add logo', false);
  l.src = cv.toDataURL('image/png');
  l.w = 600; l.h = 600;
  return l;
}

async function bakePhoto(l){
  if (l.frame === 'circle' || l.frame === 'heart') l.ar = 1;
  const ar = l.ar || 1;
  // An empty spot never prints, so it needn't be drawn at print size.
  const side = l.photo ? PHOTO_PX : 600;
  const W = Math.round(ar >= 1 ? side : side * ar), H = Math.round(ar >= 1 ? side / ar : side);
  const cv = document.createElement('canvas'); cv.width = W; cv.height = H;
  const c = cv.getContext('2d');
  c.save(); framePath(c, l.frame, W, H); c.clip();
  if (l.photo){
    const im = await loadImg(l.photo.src);
    const {x, y, dw, dh, k} = photoPlace(im, W, H, l.zoom, l.pan);
    c.drawImage(im, x, y, dw, dh);
    // What the press gets across the frame's width, measured in the photo's own pixels.
    l.ow = Math.round(W / k);
  } else {
    drawSpot(c, W, H, 'Add photo', true);
    l.ow = null;
  }
  c.restore();
  l.src = cv.toDataURL('image/png');
  l.w = W; l.h = H;
  return l;
}

/* Sizes a piece by the share of the wrap's height it should fill, capped by a share of
   its width — so one layout reads the same on a tall Skinny wrap and a wide mug one. */
function sizePiece(l, hf, wf){
  const f = fitPct((l.w || 1) / (l.h || 1));
  let s = hf / (f.h / 100);
  if (wf) s = Math.min(s, wf / (f.w / 100));
  l.s = s;
}

function readPhoto(file){
  return new Promise((res, rej) => {
    const r = new FileReader();
    r.onerror = () => rej(new Error('read'));
    r.onload = ev => {
      const im = new Image();
      im.onerror = () => rej(new Error('decode'));
      im.onload = () => res({src: ev.target.result, name: file.name,
                             w: im.naturalWidth, h: im.naturalHeight});
      im.src = ev.target.result;
    };
    r.readAsDataURL(file);
  });
}

/* Opens the file picker for a photo piece (an empty spot, or Replace). */
function pickPhotoFor(l){
  const inp = el('input',{type:'file', accept:'image/*', class:'hidden'});
  inp.addEventListener('change', async () => {
    const f = inp.files[0];
    if (!f) return;
    try { l.photo = await readPhoto(f); }
    catch (e){ S.artError = `We could not open “${f.name}”. Please upload a PNG or JPG.`; return render(true); }
    if (!l.slot) l.ar = l.photo.w / l.photo.h;   // a free photo keeps its own shape
    l.zoom = 1; l.pan = {x: 0, y: 0};              // a new photo starts centred
    S.artError = '';
    await bakePhoto(l);
    S.sel = l.id;
    openCrop(l);
  });
  document.body.appendChild(inp);
  inp.click();
  setTimeout(() => inp.remove(), 60000);
}

/* A new photo piece at the photo's own shape, on the front. */
async function addPhotoLayer(file){
  let photo;
  try { photo = await readPhoto(file); }
  catch (e){ S.artError = `We could not open “${file.name}”. Please upload a PNG or JPG.`; return render(true); }
  S.artError = '';
  const l = addLayer({kind:'photo', photo, frame:'asis', ar: photo.w / photo.h});
  await bakePhoto(l);
  sizePiece(l, 0.55, 0.4);
  clampToArea(l);
  openCrop(l);
}

/* Edit / Swap live on the photo's card; the editor below it is just its print quality. */
/* ================= adjusting a photo in its frame =================
   Upload, pick a frame and put the photo where it belongs — one step, in one place. The
   adjust view opens over the design area straight after a photo is added (or a spot is
   filled), and again from Edit on its card: a large preview of the frame with the rest of
   the photo ghosted around it, dragged to position, a zoom slider, and the frame choices.
   Centred cropping cut heads off: people and pets are rarely in the middle of a photo.

   It works on a copy (S.crop) and redraws only its own canvas while dragging; Done bakes
   the piece once and keeps its height on the wrap. */
/* Scroll (or a trackpad pinch, which arrives as a ctrl-wheel) over a pop-up's preview
   zooms it, as in any photo editor — and doesn't scroll the page behind. */
function wheelZoom(target, get, set){
  target.addEventListener('wheel', e => {
    e.preventDefault();
    set(get() * Math.exp(-e.deltaY * (e.ctrlKey ? 0.01 : 0.0015)));
  }, {passive: false});
}

function openCrop(l){
  if (!l || !l.photo) return;
  S.crop = {id: l.id, frame: l.frame, zoom: l.zoom || 1, pan: {...(l.pan || {x: 0, y: 0})}};
  render(true);
}

async function applyCrop(){
  const c = S.crop, l = c && layerById(c.id);
  S.crop = null;
  if (!l){ render(true); return; }
  const h0 = layerBox(l).h;
  Object.assign(l, {frame: c.frame, zoom: c.zoom, pan: c.pan, ar: frameAr(l, c.frame)});
  await bakePhoto(l);
  sizePiece(l, h0);
  clampToArea(l);
  S.sel = l.id;
  render(true);
}

function cropView(){
  const c = S.crop, l = layerById(c.id);
  if (!l || !l.photo) return null;
  const BOX = 260, M = 50;                          // frame size, and ghosted margin round it
  const ar = frameAr(l, c.frame);
  const fw = Math.round(ar >= 1 ? BOX : BOX * ar), fh = Math.round(ar >= 1 ? BOX / ar : BOX);
  const cv = el('canvas',{class:'crop-cv'});
  const dpr = Math.max(2, window.devicePixelRatio || 1);
  cv.width = (fw + M*2) * dpr; cv.height = (fh + M*2) * dpr;
  cv.style.width = (fw + M*2) + 'px';              // height follows (CSS height:auto)
  let im = null;
  const draw = () => {
    if (!im) return;
    const g = cv.getContext('2d');
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    g.clearRect(0, 0, fw + M*2, fh + M*2);
    const p = photoPlace(im, fw, fh, c.zoom, c.pan);
    g.globalAlpha = 0.22; g.drawImage(im, M + p.x, M + p.y, p.dw, p.dh); g.globalAlpha = 1;
    g.save(); g.translate(M, M); framePath(g, c.frame, fw, fh); g.clip();
    g.drawImage(im, p.x, p.y, p.dw, p.dh); g.restore();
    g.save(); g.translate(M, M); framePath(g, c.frame, fw, fh);
    g.lineWidth = 2; g.strokeStyle = '#14566B'; g.stroke(); g.restore();
  };
  loadImg(l.photo.src).then(i => { im = i; draw(); });

  // Drag moves the photo under the frame: pointer pixels → a share of the overflow.
  cv.addEventListener('pointerdown', e => {
    if (!im) return;
    e.preventDefault(); cv.setPointerCapture(e.pointerId);
    let lx = e.clientX, ly = e.clientY;
    const move = ev => {
      const p = photoPlace(im, fw, fh, c.zoom, c.pan);
      const ox = p.dw - fw, oy = p.dh - fh;
      if (ox > 0) c.pan.x = Math.max(-1, Math.min(1, c.pan.x - (ev.clientX - lx) * 2 / ox));
      if (oy > 0) c.pan.y = Math.max(-1, Math.min(1, c.pan.y - (ev.clientY - ly) * 2 / oy));
      lx = ev.clientX; ly = ev.clientY;
      draw();
    };
    const up = ev => { cv.releasePointerCapture(ev.pointerId);
      cv.removeEventListener('pointermove', move); cv.removeEventListener('pointerup', up); };
    cv.addEventListener('pointermove', move); cv.addEventListener('pointerup', up);
  });

  const zoomIn = el('input',{type:'range', min:'1', max:'4', step:'0.01', value:String(c.zoom),
    oninput:e=>{ c.zoom = +e.target.value; draw(); }});
  wheelZoom(cv, () => c.zoom, z => { c.zoom = Math.min(4, Math.max(1, z)); zoomIn.value = String(c.zoom); draw(); });
  return el('div',{class:'crop-ov'},
    el('div',{class:'crop-card'},
      el('div',{class:'crop-hd'}, el('b',{}, 'Position your photo'),
        el('span',{}, 'Drag to move it in the frame · zoom to fill more of it')),
      el('div',{class:'tabs', style:'margin:0'}, PHOTO_FRAMES.map(([v, lab]) =>
        el('button',{class:'tab'+(c.frame===v?' on':''), onclick:()=>{ c.frame = v; render(true); }}, lab))),
      el('div',{class:'crop-stage'}, cv),
      el('div',{class:'crop-zoom'}, el('span',{}, 'Zoom'), zoomIn),
      el('div',{class:'crop-btns'},
        el('button',{class:'btn', onclick:()=>{ S.crop = null; render(true); }}, 'Cancel'),
        el('button',{class:'btn pri', onclick:applyCrop}, 'Done'))));
}

/* ================= positioning a full wrap =================
   The Upload full wrap tab's answer to a photo's frame view: the wrap's own shape as the
   frame, the upload drawn in it with the rest ghosted round it, drag to move, a zoom
   slider, and Fit / Fill to snap back to the whole image or edge to edge. It edits a copy
   (S.wrapPos) and Done writes it to the piece — `z` is the piece's `s` (1 = the whole
   image fitted), `x`/`y` its centre as fractions of the wrap — so the design area, views
   and print file all place it exactly as they already do. */
function wrapCoverZ(l){
  const W = areaW(), H = areaH(), iar = (l.w || 1) / (l.h || 1), war = W / H;
  return iar > war ? iar / war : war / iar;          // cover ÷ contain
}
function openWrapPos(l){
  if (!l || !l.wrap) return;
  S.wrapPos = {id: l.id, z: l.s || 1, x: l.x, y: l.y};
  render(true);
}
function wrapPosView(){
  const c = S.wrapPos, l = layerById(c.id);
  if (!l || !l.wrap){ S.wrapPos = null; return null; }
  const W = areaW(), H = areaH(), BOX = 300, M = 40;
  const fw = W >= H ? BOX : Math.round(BOX * W / H), fh = W >= H ? Math.round(BOX * H / W) : BOX;
  const cv = el('canvas',{class:'crop-cv'});
  const dpr = Math.max(2, window.devicePixelRatio || 1);
  cv.width = (fw + M*2) * dpr; cv.height = (fh + M*2) * dpr;
  cv.style.width = (fw + M*2) + 'px';
  const zMax = Math.max(4, wrapCoverZ(l) * 2);
  // The piece's box at zoom z, as fractions of the frame (layerBox at s = z).
  const boxAt = z => { const f = fitPct((l.w || 1) / (l.h || 1)); return {w: f.w / 100 * z, h: f.h / 100 * z}; };
  const clampC = () => { const b = boxAt(c.z); const t = {wrap: true, x: c.x, y: c.y};
                         clampWrap(t, b.w / 2, b.h / 2); c.x = t.x; c.y = t.y; };
  let im = null;
  const draw = () => {
    if (!im) return;
    const g = cv.getContext('2d');
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    g.clearRect(0, 0, fw + M*2, fh + M*2);
    const b = boxAt(c.z), dw = b.w * fw, dh = b.h * fh;
    const dx = M + c.x * fw - dw / 2, dy = M + c.y * fh - dh / 2;
    g.globalAlpha = 0.22; g.drawImage(im, dx, dy, dw, dh); g.globalAlpha = 1;
    g.save(); g.beginPath(); g.rect(M, M, fw, fh); g.clip();
    g.fillStyle = '#FFFFFF'; g.fillRect(M, M, fw, fh);
    g.drawImage(im, dx, dy, dw, dh); g.restore();
    g.lineWidth = 2; g.strokeStyle = '#14566B'; g.strokeRect(M, M, fw, fh);
  };
  loadImg(l.src).then(i => { im = i; draw(); });

  cv.addEventListener('pointerdown', e => {
    if (!im) return;
    e.preventDefault(); cv.setPointerCapture(e.pointerId);
    let lx = e.clientX, ly = e.clientY;
    const scale = cv.getBoundingClientRect().width / (fw + M*2);   // CSS may shrink it
    const move = ev => {
      c.x += (ev.clientX - lx) / scale / fw; c.y += (ev.clientY - ly) / scale / fh;
      lx = ev.clientX; ly = ev.clientY;
      clampC(); draw();
    };
    const up = ev => { cv.releasePointerCapture(ev.pointerId);
      cv.removeEventListener('pointermove', move); cv.removeEventListener('pointerup', up); };
    cv.addEventListener('pointermove', move); cv.addEventListener('pointerup', up);
  });

  const zoomIn = el('input',{type:'range', min:'1', max:String(zMax), step:'0.01', value:String(c.z),
    oninput:e=>{ c.z = +e.target.value; clampC(); draw(); }});
  const snap = z => { c.z = z; c.x = 0.5; c.y = 0.5; zoomIn.value = String(z); draw(); };
  wheelZoom(cv, () => c.z, z => { c.z = Math.min(zMax, Math.max(1, z)); zoomIn.value = String(c.z); clampC(); draw(); });
  return el('div',{class:'crop-ov'},
    el('div',{class:'crop-card'},
      el('div',{class:'crop-hd'}, el('b',{}, 'Position your wrap'),
        el('span',{}, 'Drag to move it · zoom to fill more of the tumbler')),
      el('div',{class:'tabs', style:'margin:0'},
        el('button',{class:'tab', onclick:()=>snap(1)}, 'Fit whole image'),
        el('button',{class:'tab', onclick:()=>snap(wrapCoverZ(l))}, 'Fill the wrap')),
      el('div',{class:'crop-stage'}, cv),
      el('div',{class:'crop-zoom'}, el('span',{}, 'Zoom'), zoomIn),
      el('div',{class:'crop-btns'},
        el('button',{class:'btn', onclick:()=>{ S.wrapPos = null; render(true); }}, 'Cancel'),
        el('button',{class:'btn pri', onclick:()=>{
          Object.assign(l, {s: c.z, x: c.x, y: c.y}); clampToArea(l);
          S.wrapPos = null; render(true); }}, 'Done'))));
}

/* ================= cleaning up a logo =================
   A logo's cleanup (Remove background, Trim, and on UV its ink) pops up over the design
   area the way a photo's frame does: straight after the upload, and again from Edit.
   Changes apply as they're ticked, on a large preview over a checkerboard so what was
   knocked out shows; Cancel puts the settings back as they were when it opened. */
function openLogoFx(l){
  if (!l || l.kind !== 'img') return;
  S.logoFx = {id: l.id, fx: {...l.fx}};
  S.sel = l.id;
  render(true);
}

function logoView(){
  const c = S.logoFx, l = layerById(c.id);
  if (!l || l.kind !== 'img'){ S.logoFx = null; return null; }
  const card = el('div',{class:'crop-card logo-card'},
    el('div',{class:'crop-hd'}, el('b',{}, 'Clean up your logo'),
      el('span',{}, 'The checkered parts print nothing — the tumbler shows through')),
    el('div',{class:'crop-stage logo-prev'},
      S.fxBusy ? el('div',{class:'logo-busy'}, 'Working on it…')
               : el('img',{src:l.src, alt:''})));
  const q = qualityOf(l);
  if (q) card.appendChild(qualityBar(q));
  logoCleanup(l, card);
  card.appendChild(el('div',{class:'crop-btns'},
    el('button',{class:'btn', onclick:()=>{
      const changed = JSON.stringify(l.fx) !== JSON.stringify(c.fx);
      l.fx = {...c.fx}; S.logoFx = null;
      if (changed) processLayer(l);
      render(true); }}, 'Cancel'),
    el('button',{class:'btn pri', onclick:()=>{ S.logoFx = null; render(true); }}, 'Done')));
  return el('div',{class:'crop-ov'}, card);
}

/* ============ full-wrap backgrounds (sublimation, Create your own tab) ============
   Easy ways to fill the whole wrap without supplying a finished wrap file: a pattern for
   the occasion, the customer's own logo repeated, or their photos side by side. Drawn
   under the pieces. Each is generated at full print size and cached, and the design area,
   the three views, the mockup and the print file all draw from that one canvas — so a
   preview can't show a different number of repeats from what prints. Every repeating
   kind lays a whole number of repeats across the width, so the join at the seam lines up. */
// No wide Stripes (Pinstripes is the stripe option; half-width bands swamp whatever sits on
// them) and no Chevron — nine options, three by three. Both stay in the bottom-band presets.
const WRAP_BGS = [
  {id:'hearts',  name:'Hearts'},
  {id:'paws',    name:'Paw prints'},
  {id:'confetti',name:'Confetti'},
  {id:'stars',   name:'Stars'},
  {id:'snow',    name:'Snowflakes'},
  {id:'solid',   name:'Solid color'},
  {id:'pinstripes', name:'Pinstripes'},
  {id:'dots',    name:'Dots'},
  {id:'grid',    name:'Grid'},
];
// The band palette plus softer tones people ask for on wedding and baby pieces.
const WRAP_COLORS = ['#E8A0A8', '#F4B6C2', '#F3D1C8', '#9CAF88', '#B7C9E2', '#C9A227',
                     '#1F2E48', '#14566B', '#2C4B36', '#B02A2A', '#61458B', '#4A4E52', '#111111'];
// Tile size as a share of the wrap's height — for a square tile; others keep the same area
// (see wrapBgCanvas). Medium was Small until customers wanted it denser.
const REPEAT_SIZES = {s: 0.065, m: 0.10, l: 0.16};

// Deterministic, so confetti is the same scatter in the preview and on the press.
function seeded(n){ return () => ((n = (n * 1664525 + 1013904223) >>> 0) / 4294967296); }

function heartPath(c, x, y, r){
  c.beginPath();
  c.moveTo(x, y + r * 0.9);
  c.bezierCurveTo(x - r * 1.6, y - r * 0.2, x - r * 0.7, y - r * 1.3, x, y - r * 0.45);
  c.bezierCurveTo(x + r * 0.7, y - r * 1.3, x + r * 1.6, y - r * 0.2, x, y + r * 0.9);
  c.fill();
}
function starPath(c, x, y, r){
  c.beginPath();
  for (let i = 0; i < 10; i++){
    const a = -Math.PI / 2 + i * Math.PI / 5, rr = i % 2 ? r * 0.45 : r;
    c.lineTo(x + Math.cos(a) * rr, y + Math.sin(a) * rr);
  }
  c.closePath(); c.fill();
}
function snowflake(c, x, y, r, color){
  c.save(); c.translate(x, y); c.strokeStyle = color; c.lineWidth = r * 0.12; c.lineCap = 'round';
  for (let i = 0; i < 6; i++){
    c.rotate(Math.PI / 3);
    c.beginPath(); c.moveTo(0, 0); c.lineTo(0, -r);
    c.moveTo(0, -r * 0.55); c.lineTo(-r * 0.22, -r * 0.78);
    c.moveTo(0, -r * 0.55); c.lineTo(r * 0.22, -r * 0.78);
    c.stroke();
  }
  c.restore();
}
function pawPrint(c, x, y, r, rot){
  c.save(); c.translate(x, y); c.rotate(rot);
  c.beginPath(); c.ellipse(0, r * 0.35, r * 0.62, r * 0.5, 0, 0, 7); c.fill();
  [[-0.62, -0.28], [-0.22, -0.62], [0.22, -0.62], [0.62, -0.28]].forEach(([dx, dy]) => {
    c.beginPath(); c.ellipse(dx * r, dy * r, r * 0.2, r * 0.26, dx * 0.5, 0, 7); c.fill();
  });
  c.restore();
}

const bgActive = () => S.wrapBgOn && sandboxMode() && S.artTab === 'logo';
/* Decoded background sources for the order-time renders, keyed by src. */
async function bgImageMap(){
  const out = {};
  if (bgActive()) for (const src of bgSources()) out[src] = await loadImg(src);
  return out;
}

/* The piece step-and-repeat tiles: the first one on the design. */
const repeatSource = () => S.sides.front.find(l => l.src && !isEmptySpot(l)) || null;

/* Everything a background needs decoded, by src. */
function bgSources(){
  const bg = S.wrapBg;
  if (bg.kind === 'repeat'){ const l = repeatSource(); return l ? [l.src] : []; }
  return [];
}

/* Pinstripes: every line the same whole number of pixels wide, starting on a whole pixel —
   at fractional positions each anti-aliased differently and read as lines of different
   weights. Lines sit half a gap in from each end, so none falls on the seam. The design
   area draws them again at its own size with the print file's count (drawViews), since
   shrinking hairlines ~14x can't keep them even. */
const pinstripeCount = w => Math.max(12, Math.round(w / 110));
function drawPinstripes(c, n, w, h){
  const p = w / n, lw = Math.max(w > 1000 ? 2 : 1, Math.round(p * 0.1));
  for (let i = 0; i < n; i++) c.fillRect(Math.round(i * p + (p - lw) / 2), 0, lw, h);
}

const BG_CACHE = {key: '', cv: null};
/* The background at full print size, or null while an image it needs is loading.
   `getImg(src)` returns a decoded image or null. */
/* `w`/`h`/`cache` default to the main wrap; the bottom band asks for the same background at
   its own size (bandBgCanvas). */
function wrapBgCanvas(getImg, w = areaW(), h = areaH(), cache = BG_CACHE){
  if (!S.wrapBgOn || !sandboxMode() || S.artTab !== 'logo') return null;
  const bg = S.wrapBg, srcs = bgSources();
  const key = [bg.kind, bg.color, bg.size, bg.tilt || 0, w, h, handleFrac(), ...srcs].join('|');
  if (cache.key === key) return cache.cv;
  const imgs = srcs.map(getImg);
  if (imgs.some(i => !i)) return null;
  const cv = document.createElement('canvas'); cv.width = w; cv.height = h;
  const c = cv.getContext('2d');
  c.fillStyle = '#FFFFFF'; c.fillRect(0, 0, w, h);
  c.fillStyle = bg.color;
  if (bg.kind === 'solid'){
    c.fillRect(0, 0, w, h);
  } else if (bg.kind === 'pinstripes'){
    drawPinstripes(c, pinstripeCount(w), w, h);
  } else if (['stripes', 'dots', 'chevron', 'grid'].includes(bg.kind)){
    drawPattern(c, bg.kind, bg.color, w, h);
  } else if (bg.kind === 'stars' || bg.kind === 'snow'){
    const cols = Math.max(6, Math.round(w / 280)), px = w / cols;
    const rows = Math.max(2, Math.round(h / px)), py = h / rows, r = px * 0.2;
    for (let y = 0; y < rows; y++) for (let x = 0; x < cols; x++){
      const cx = brickX(x, y, px), cy = y * py + py / 2;
      if (bg.kind === 'stars') starPath(c, cx, cy, r * (y % 2 ? 0.8 : 1));
      else snowflake(c, cx, cy, r, bg.color);
    }
  } else if (bg.kind === 'hearts' || bg.kind === 'paws'){
    const cols = Math.max(6, Math.round(w / 300)), px = w / cols;
    const rows = Math.max(2, Math.round(h / px)), py = h / rows, r = px * 0.2;
    for (let y = 0; y < rows; y++) for (let x = 0; x < cols; x++){
      const cx = brickX(x, y, px), cy = y * py + py / 2;
      if (bg.kind === 'hearts') heartPath(c, cx, cy, r);
      else pawPrint(c, cx, cy, r * 1.15, (y % 2 ? 0.35 : -0.35));
    }
  } else if (bg.kind === 'confetti'){
    const rnd = seeded(7), n = Math.round(w * h / 9000);
    const cols = [bg.color, bg.color, '#C9A227', '#FFFFFF'];
    // Every piece is kept a piece's reach in from the ends, so none is cut by the seam.
    const reach = w * 0.014 * 1.1;
    for (let i = 0; i < n; i++){
      c.save();
      c.translate(reach + rnd() * (w - reach * 2), rnd() * h); c.rotate(rnd() * Math.PI);
      c.fillStyle = cols[Math.floor(rnd() * cols.length)];
      c.globalAlpha = 0.55 + rnd() * 0.45;
      const s0 = w * (0.006 + rnd() * 0.008);
      if (rnd() < 0.5) c.fillRect(-s0, -s0 / 3, s0 * 2, s0 * 0.66);
      else { c.beginPath(); c.arc(0, 0, s0 * 0.6, 0, 7); c.fill(); }
      c.restore();
    }
  } else if (bg.kind === 'repeat'){
    const im = imgs[0];
    if (im){
      /* A size is an area, not a height: sized by height, a wide logo came out several
         times the area of a square one and only a handful fitted round the tumbler. */
      const ar = im.naturalWidth / im.naturalHeight;
      // Sized against the main wrap's height even on the band, so the band's logos match
      // the wrap's; the fit below shrinks them only if they can't fit the band at all.
      let th = areaH() * (REPEAT_SIZES[bg.size] || REPEAT_SIZES.m) / Math.sqrt(ar);
      let tw = th * ar;
      const tilt = (bg.tilt || 0) * Math.PI / 180;
      const cs = Math.abs(Math.cos(tilt)), sn = Math.abs(Math.sin(tilt));
      // Half the turned tile's width and height. brickX() keeps a tile off the seam while
      // the half-width is within a quarter column; a row keeps it off the top and bottom
      // while the half-height is within half a row — so those set the counts.
      let hw = (cs * tw + sn * th) / 2, hh = (sn * tw + cs * th) / 2;
      const fit = Math.min(1, w / (hw * 2.9), h / (hh * 2.2 + h * 0.03));   // too big for even one
      th *= fit; tw *= fit; hw *= fit; hh *= fit;
      /* Columns about 1.45 tiles apart, rows at least 1.1 tiles apart (so turned tiles never
         overlap row to row). Rows are staggered by as much as keeps every tile off the
         seam: a tile needs its half-width clear of each end, so alternate rows sit at
         `r` and `1 - r` of a column (r = half-width / column). A half-column drop needs
         columns four half-widths apart — twice the tile — which left a wide logo at
         Large with a single tile per row. */
      const cols = Math.max(1, Math.floor(w / (hw * 2.9))), px = w / cols;
      const r = Math.min(0.5, hw / px + 0.01), drop = (1 - 2 * r) * px;
      /* Row spacing: the smallest step at which no two tiles in nearby rows touch, tested
         on the turned tiles themselves (two equal rectangles are apart if their offset
         clears one of the tile's own axes, with some air) rather than on their bounding
         boxes — at 45° a bounding box is mostly empty corners and spaced rows far apart. */
      const sa = Math.sin(tilt), ca = Math.cos(tilt);
      const apart = (dx, dy) => Math.abs(-dx * sa + dy * ca) >= th * 1.4
                             || Math.abs(dx * ca + dy * sa) >= tw * 1.15;
      const clear = st => [1, 2].every(k => [-2, -1, 0, 1, 2].every(m =>
        [1, -1].every(sg => apart((k % 2 ? sg * drop : 0) + m * px, k * st))));
      let step = th * 0.5;
      while (!clear(step) && step < h) step += th * 0.05;
      // The first and last rows sit their turned half-height, plus a little air, in from
      // the top and bottom.
      const inset = hh + h * 0.015, span = h - 2 * inset;
      const rows = Math.max(1, Math.floor(span / step) + 1);
      const py = rows > 1 ? span / (rows - 1) : 0, y0 = rows > 1 ? inset : h / 2;
      for (let y = 0; y < rows; y++) for (let x = 0; x < cols; x++){
        const cx = (x + (y % 2 ? 1 - r : r)) * px, cy = y0 + y * py;
        // Each tile turned about its own centre, and wholly inside the wrap: none crosses
        // the seam, and none is cut by the top or bottom edge however far it's tilted.
        c.save(); c.translate(cx, cy); if (tilt) c.rotate(tilt);
        c.drawImage(im, -tw / 2, -th / 2, tw, th);
        c.restore();
      }
    }
  }
  cache.key = key; cache.cv = cv;
  return cv;
}
const BAND_CACHE = {key: '', cv: null};

/* Wrap options: the background and, on a tapered Big Swig, the bottom band — both
   optional extras on top of the design, so both are checkboxes that open their pickers. */
function wrapOptionsUI(){
  syncAutoInk();
  const sect = el('div',{class:'sect'}, el('div',{class:'sect-t'}, 'Wrap options'));
  const check = (on, label, hint, set) => el('label',{class:'fx-row'},
    el('input',{type:'checkbox', ...(on?{checked:''}:{}), onchange:e=>{ set(e.target.checked); render(true); }}),
    el('span',{}, el('b',{}, label), hint ? el('em',{}, hint) : null));
  const swatches = (list, cur, set) => colorRow(list, cur, v => { set(v); render(true); });

  // On Step and repeat the pattern *is* the design, so there's no separate background.
  if (S.artTab === 'logo' && S.tpl.id !== 'repeat'){
    sect.appendChild(check(S.wrapBgOn, 'Full wrap background', null,
      v => { S.wrapBgOn = v; if (v && S.wrapBg.kind === 'repeat') S.wrapBg.kind = 'hearts'; }));
    if (S.wrapBgOn){
      const bg = S.wrapBg;
      sect.appendChild(el('div',{class:'bg-grid'}, WRAP_BGS.map(k =>
        el('button',{class:'bg-opt'+(bg.kind===k.id?' on':''), onclick:()=>{ bg.kind = k.id; render(true); }},
          k.name))));
      sect.appendChild(el('div',{class:'fx-ink', style:'margin-top:12px'},
        el('span',{class:'fx-ink-lab'}, 'Color'),
        swatches(WRAP_COLORS, bg.color, v => { bg.color = v; })));
      // A solid colour printed onto a white blank never looks as rich as a tumbler that is
      // that colour — point people who want one at UV (coloured, powder-coated tumblers).
      // Step 1 only shows the choice; nothing is reset unless they pick UV there.
      if (bg.kind === 'solid') sect.appendChild(el('div',{class:'note', style:'margin-top:12px'},
        el('span',{class:'ni'}, 'i'),
        el('div',{},
          el('b',{}, 'Want a bold background color?'),
          ' Our UV-printed tumblers look richer than a printed-on color.',
          ' ', el('button',{class:'link-btn', onclick:()=>go(1)}, 'See UV print options'))));
    }
  }

  const bot = bottomSpec();
  if (bot){
    ensureBottomPattern(bot);
    // Only as an extension of the background: nothing to extend without one.
    if (bgActive()) sect.appendChild(el('label',{class:'fx-row band-row'},
      el('input',{type:'checkbox', ...(S.bottomOn?{checked:''}:{}),
        onchange:e=>{ S.bottomOn = e.target.checked; render(true); }}),
      el('b',{}, S.tpl.id === 'repeat' ? 'Extend pattern to bottom band' : 'Extend background to bottom band'),
      el('span',{class:'two-side-price'}, '+' + fmt(BAND_PRICE))));
  }
  return sect.children.length > 1 ? sect : null;
}

/* Regenerate only when the choice or the required size actually changed. */
function ensureBottomPattern(need){
  /* White unless the customer extends the background onto the band — the same pattern
     drawn again at the band's size. While an image the background needs is still loading
     the band stays white; the next render fills it in. */
  const bg = bandOn() ? wrapBgCanvas(cachedImg, need.w, need.h, BAND_CACHE) : null;
  if (bg){
    if (S.artB && S.artB.cv === bg) return;
    S.artB = {type:'img', cv:bg, genKey:BAND_CACHE.key, name:'Background, extended',
              src:bg.toDataURL('image/png'), w:need.w, h:need.h};
    return;
  }
  const wkey = `white|${need.w}x${need.h}`;
  if (S.artB && S.artB.genKey === wkey) return;
  const cv = document.createElement('canvas');
  cv.width = need.w; cv.height = need.h;
  const c = cv.getContext('2d'); c.fillStyle = '#FFFFFF'; c.fillRect(0, 0, need.w, need.h);
  S.artB = {type:'img', genKey:wkey, name:'Plain white', src:cv.toDataURL('image/png'),
            w:need.w, h:need.h};
}

/* ============================== step 4 ============================== */
/* Typing into these must not re-render — the view is rebuilt wholesale on every
   render() and an input would lose focus mid-word. They only write to state. */
/* The filed mockup is each view's whole square photo side by side — mostly white. For the
   review card it's cropped to the tumblers: each view to its own content, all to the
   same top and bottom, set a short gap apart. */
function tightMockup(src, n){
  return loadImg(src).then(im => {
    const W = im.naturalWidth, H = im.naturalHeight, vw = W / n;
    const cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    const c = cv.getContext('2d', {willReadFrequently: true});
    c.drawImage(im, 0, 0);
    const d = c.getImageData(0, 0, W, H).data;
    const ink = (x, y) => { const i = (y * W + x) * 4; return d[i] < 244 || d[i+1] < 244 || d[i+2] < 244; };
    let top = H, bot = -1;
    const cols = [];
    for (let v = 0; v < n; v++){
      let lo = Infinity, hi = -1;
      for (let y = 0; y < H; y += 2) for (let x = Math.floor(v * vw); x < Math.floor((v + 1) * vw); x += 2)
        if (ink(x, y)){ if (x < lo) lo = x; if (x > hi) hi = x; if (y < top) top = y; if (y > bot) bot = y; }
      cols.push(hi > lo ? [lo, hi + 2] : [Math.floor(v * vw), Math.floor((v + 1) * vw)]);
    }
    if (bot < top) return src;
    const pad = Math.round(H * 0.03), gap = Math.round(H * 0.06);
    top = Math.max(0, top - pad); bot = Math.min(H, bot + pad);
    const outW = cols.reduce((a, [l, r]) => a + (r - l), 0) + gap * (n - 1) + pad * 2;
    const out = document.createElement('canvas'); out.width = outW; out.height = bot - top;
    const o = out.getContext('2d');
    o.fillStyle = '#FFFFFF'; o.fillRect(0, 0, outW, bot - top);
    let x = pad;
    cols.forEach(([l, r]) => { o.drawImage(cv, l, top, r - l, bot - top, x, 0, r - l, bot - top); x += (r - l) + gap; });
    return out.toDataURL('image/jpeg', 0.92);
  });
}

/* The mockup full screen, over everything; click anywhere or press Escape to close. */
function openLightbox(src){
  if (!src) return;
  const close = () => { ov.remove(); document.removeEventListener('keydown', esc); };
  const esc = e => { if (e.key === 'Escape') close(); };
  const ov = el('div',{class:'crop-ov lightbox', onclick:close},
    el('img',{src, alt:'Your design, larger'}),
    el('button',{class:'lb-close', 'aria-label':'Close'}, '✕'));
  document.addEventListener('keydown', esc);
  document.getElementById(MOUNT_ID).appendChild(ov);
}

function viewReview(){
  const p = S.product, v = S.variant;
  // The real composed mockup, not the bare product photo — this page says "this is
  // exactly what we will print", and it's the same render that gets filed against the
  // order, so the two can't disagree. Shown cropped tight to the tumblers (tightMockup)
  // so they fill the card — the filed mockup is left as rendered — with Expand to see it
  // full screen. Starts on the plain photo; a failure just leaves the photo.
  const shotImg = el('img',{src:v.img, alt:pname(S.product)});
  const nViews = isSub() ? WRAP_VIEWS.length : twoOn() ? 2 : 1;
  renderMockup().then(src => tightMockup(src, nViews)).then(src => { shotImg.src = src; })
    .catch(err => console.error('[customizer]', err));
  const shot = el('div',{class:'rev-shot'}, shotImg,
    el('button',{class:'rev-expand', title:'View larger', 'aria-label':'View larger',
      onclick:()=>openLightbox(shotImg.src)},
      el('span',{html:'<svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true"><path d="M9.5 2.5h4v4M6.5 13.5h-4v-4M13.5 2.5 9 7M2.5 13.5 7 9" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'})));
  return el('div',{},
    el('div',{class:'head'},
      el('div',{class:'eyebrow'}, 'Step 4 of 4'),
      el('h1',{class:'h-lg'}, 'Review'),
    ),
    el('div',{class:'review'},
      el('div',{class:'rev-card'},
        shot,
        el('div',{class:'note ok', style:'margin-top:20px'},
          el('span',{class:'ni'}, '✓'),
          el('div',{html:'<b>Printed exactly as shown.</b> We print the logos and images you uploaded as they are, so anything marked <b>Soft</b> or <b>Fair</b> quality may look a little grainy on the finished piece.'}),
        )),
      el('div',{},
        el('div',{class:'panel'},
          el('div',{class:'panel-hd'}, el('div',{class:'t'}, 'Order summary')),
          el('div',{class:'sect'},
            el('div',{class:'total-row'}, el('span',{}, pname(p) + ' × ' + S.qty), el('span',{class:'v'}, fmt(v.price*S.qty))),
            // Named as the cart names it: a separate Customization line beside the tumbler.
            el('div',{class:'total-row'}, el('span',{}, 'Customization × '+S.qty), el('span',{class:'v'}, fmt(decoPrice()*S.qty))),
            extraPieces() ? el('div',{class:'total-row'}, el('span',{}, `Additional designs (${extraPieces()}) × ${S.qty}`), el('span',{class:'v'}, fmt(extraPrice()*S.qty))) : null,
            bandOn() ? el('div',{class:'total-row'}, el('span',{}, 'Bottom band × '+S.qty), el('span',{class:'v'}, fmt(bandPrice()*S.qty))) : null,
            el('div',{class:'total-row'}, el('span',{}, 'Shipping'), el('span',{class:'v'}, 'Calculated at checkout')),
            el('div',{class:'total-row big'}, el('span',{}, 'Subtotal'), el('span',{class:'v'}, fmt(unitPrice()*S.qty))),
          ),
          el('div',{class:'sect'},
            el('button',{class:'btn pri', style:'width:100%',
              onclick:(e)=>addToCart(e.currentTarget)}, 'Complete design & add to cart'),
            el('div',{id:'hc-order-note', style:'margin-top:10px'}),
            el('button',{class:'btn', style:'width:100%;margin-top:4px', onclick:()=>go(3)}, '← Back'),
          )),
      )),
  );
}

/* ============================== render ============================== */
let scrollLock = false;
function render(keepScroll){
  const y = window.scrollY;
  renderSteps();
  const app = document.getElementById('hc-app');
  app.textContent = '';
  app.appendChild(
    S.step===1 ? viewMethod() :
    S.step===2 ? viewProducts() :
    S.step===3 ? viewDesign() : viewReview());
  if (keepScroll) window.scrollTo(0, y);
  if (S.step === 3) recordHistory();
}


/* ---------- "Continue your design" ----------
   A reload or a dropped phone tab used to lose the whole design. It's kept in this
   browser's IndexedDB — not localStorage, whose ~5 MB a couple of photos would fill — and
   offered back on the first step. Saved (debounced) whenever the undo history takes a
   step, and cleared once the order goes in. Everything here fails quietly: private
   windows and blocked storage simply mean no draft. */
const DRAFT_DAYS = 30;
function idb(){
  return new Promise((res, rej) => {
    try {
      const r = indexedDB.open('hogg-studio', 1);
      r.onupgradeneeded = () => r.result.createObjectStore('drafts');
      r.onsuccess = () => res(r.result);
      r.onerror = () => rej(r.error);
    } catch (e){ rej(e); }
  });
}
async function idbDo(mode, fn){
  try {
    const db = await idb();
    return await new Promise((res, rej) => {
      const tx = db.transaction('drafts', mode), st = tx.objectStore('drafts');
      const r = fn(st);
      tx.oncomplete = () => res(r && r.result);
      tx.onerror = () => rej(tx.error);
    });
  } catch (e){ return null; }
}
let draftTimer = null;
function saveDraft(){
  if (!S.product || !S.variant || S.step < 3) return;
  clearTimeout(draftTimer);
  draftTimer = setTimeout(() => {
    const d = {t: Date.now(), method: S.method, sku: S.variant.sku, artTab: S.artTab,
      sides: S.sides, wrapBgOn: S.wrapBgOn, wrapBg: S.wrapBg, bottomOn: S.bottomOn,
      bottomPattern: S.bottomPattern, bottomColor: S.bottomColor, bottomMode: S.bottomMode,
      twoSided: S.twoSided, tpl: S.tpl, qty: S.qty, art: S.art, wrapFit: S.wrapFit,
      title: pname(S.product)};
    idbDo('readwrite', st => st.put(d, 'current'));
  }, 800);
}
const clearDraft = () => { clearTimeout(draftTimer); return idbDo('readwrite', st => st.delete('current')); };
async function loadDraft(){
  const d = await idbDo('readonly', st => st.get('current'));
  if (!d || Date.now() - d.t > DRAFT_DAYS * 864e5) return null;
  const p = CATALOG.find(p => p.variants.some(v => v.sku === d.sku));
  const has = d.art || SIDE_KEYS.some(k => (d.sides[k] || []).length);
  return p && has ? d : null;
}
function restoreDraft(d){
  const p = CATALOG.find(p => p.variants.some(v => v.sku === d.sku));
  if (!p) return;
  Object.assign(S, {method: d.method, product: p, variant: p.variants.find(v => v.sku === d.sku),
    // 'ai' (the old free-form tab) and 'pet' (Pet Templates, switched off) both fall back.
    artTab: (d.artTab === 'ai' || d.artTab === 'pet') ? 'logo' : d.artTab, sides: {front: [], back: [], wrap: [], pet: [], ...d.sides}, wrapBgOn: d.wrapBgOn,
    wrapBg: d.wrapBg, bottomOn: d.bottomOn, bottomPattern: d.bottomPattern,
    bottomColor: d.bottomColor, bottomMode: d.bottomMode, twoSided: d.twoSided,
    tpl: d.tpl || {id: null, count: 3, layout: 'row'}, qty: d.qty || 1, art: d.art || null,
    wrapFit: d.wrapFit || 'contain', sel: null, side: 'front', artB: null, draft: null});
  layerSeq = Math.max(0, ...SIDE_KEYS.flatMap(k => (S.sides[k] || []).map(l => l.id || 0)));
  resetHistory();
  go(3);
}
function draftBanner(){
  const d = S.draft;
  if (!d) return null;
  const n = SIDE_KEYS.reduce((a, k) => a + (d.sides[k] || []).length, 0);
  return el('div',{class:'draft-banner'},
    el('div',{},
      el('b',{}, 'Continue your design?'),
      el('span',{}, ` ${d.title}` + (n ? ` · ${n} design${n > 1 ? 's' : ''}` : '')
        + ` · saved ${new Date(d.t).toLocaleDateString('en-US', {month:'short', day:'numeric'})}`)),
    el('div',{class:'draft-btns'},
      el('button',{class:'btn', onclick:()=>{ S.draft = null; clearDraft(); render(true); }}, 'Start over'),
      el('button',{class:'btn pri', onclick:()=>restoreDraft(d)}, 'Continue')));
}

/* ---------- undo / redo ----------
   Every render on the design step compares a cheap signature of the design with the last
   one and, if it changed, keeps a snapshot. A snapshot copies the pieces shallowly — their
   bitmaps are strings, shared rather than duplicated — so fifty steps cost little.

   The signature leaves out a logo's cleanup flags and counts its bitmap instead: ticking
   Remove background renders once with the flag set and again when the work lands, and
   only the second is a state worth going back to. Typing in a row box doesn't render;
   it's committed on leaving the box (rowInput's `change`). */
const HIST = {stack: [], i: -1, key: ''};
const HIST_MAX = 50;

function designSig(){
  const piece = l => [l.id, l.kind, +l.x.toFixed(4), +l.y.toFixed(4), +l.s.toFixed(4), l.rot || 0, !!l.flip,
    l.text, l.letters, l.name, l.number, l.font, l.color, l.curve, l.frame, l.ar, l.photo && l.photo.name,
    l.pan && l.pan.x, l.pan && l.pan.y, l.zoom,
    (l.src || '').length];
  return JSON.stringify([S.method, S.artTab, SIDE_KEYS.map(k => (S.sides[k] || []).map(piece)),
    S.wrapBgOn, S.wrapBg, S.bottomOn, S.bottomPattern, S.bottomColor, S.bottomMode, S.twoSided,
    S.tpl.id, S.tpl.count]);
}
function snapshot(){
  const copy = l => ({...l, fx: l.fx ? {...l.fx} : l.fx});
  return {sides: Object.fromEntries(SIDE_KEYS.map(k => [k, (S.sides[k] || []).map(copy)])),
          wrapBgOn: S.wrapBgOn, wrapBg: {...S.wrapBg}, bottomOn: S.bottomOn,
          bottomPattern: S.bottomPattern, bottomColor: S.bottomColor, bottomMode: S.bottomMode,
          twoSided: S.twoSided, tpl: {...S.tpl}};
}
function recordHistory(){
  // Mid-cleanup the piece is half-done (processLayer renders again when it lands); an
  // upload or a ticked cleanup box should be one step, not two.
  if (S.fxBusy) return;
  const key = designSig();
  if (key === HIST.key) return;
  HIST.stack = HIST.stack.slice(0, HIST.i + 1);
  HIST.stack.push(snapshot());
  if (HIST.stack.length > HIST_MAX) HIST.stack.shift();
  HIST.i = HIST.stack.length - 1;
  HIST.key = key;
  syncHistButtons();
  saveDraft();
}
function resetHistory(){ HIST.stack = []; HIST.i = -1; HIST.key = ''; }
function restoreHistory(i){
  const h = HIST.stack[i];
  if (!h) return;
  HIST.i = i;
  const copy = l => ({...l, fx: l.fx ? {...l.fx} : l.fx});
  S.sides = Object.fromEntries(SIDE_KEYS.map(k => [k, (h.sides[k] || []).map(copy)]));
  Object.assign(S, {wrapBgOn: h.wrapBgOn, wrapBg: {...h.wrapBg}, bottomOn: h.bottomOn,
    bottomPattern: h.bottomPattern, bottomColor: h.bottomColor, bottomMode: h.bottomMode,
    twoSided: h.twoSided, tpl: {...h.tpl}});
  S.artB = null;                         // regenerated from the restored band settings
  if (!S.layers.some(l => l.id === S.sel)) S.sel = null;
  HIST.key = designSig();                // restoring is not a new step
  render(true);
  saveDraft();
}
const undo = () => { if (HIST.i > 0) restoreHistory(HIST.i - 1); };
const redo = () => { if (HIST.i < HIST.stack.length - 1) restoreHistory(HIST.i + 1); };

function syncHistButtons(){
  const u = document.getElementById('hc-undo'), r = document.getElementById('hc-redo');
  if (u) u.disabled = !(HIST.i > 0);
  if (r) r.disabled = !(HIST.i < HIST.stack.length - 1);
}
function histButtons(){
  const b = el('div',{class:'hist'},
    el('button',{id:'hc-undo', class:'hist-btn', title:'Undo (Ctrl/⌘ Z)', onclick:undo}, '↶ Undo'),
    el('button',{id:'hc-redo', class:'hist-btn', title:'Redo (Ctrl/⌘ Shift Z)', onclick:redo}, 'Redo ↷'));
  setTimeout(syncHistButtons, 0);
  return b;
}
// Ctrl/⌘ Z and Shift-Z (and Ctrl Y), except while typing in a box, where they belong to it.
document.addEventListener('keydown', e => {
  if (S.step !== 3 || !(e.metaKey || e.ctrlKey)) return;
  if (S.crop || S.logoFx || S.wrapPos) return;   // a pop-up is open: Cancel or Done first
  if (e.target.closest && e.target.closest('input, textarea, select')) return;
  const k = e.key.toLowerCase();
  if (k === 'z'){ e.preventDefault(); e.shiftKey ? redo() : undo(); }
  else if (k === 'y'){ e.preventDefault(); redo(); }
});



function designPayload(){
  var z = sizeSpec();
  return {
    sku: S.variant.sku,
    method: S.method,
    // Sublimation only: a logo placed on a white wrap, or a full wrap. Staff read it off
    // the order notes; the print file is already the whole wrap either way.
    subMode: isSub() ? (subLogo() ? 'logo' : S.artTab === 'pet' ? 'pet' : 'wrap') : null,
    // UV: a second print file for the back. The server bills it from its own price.
    twoSided: twoOn(),
    template: isSub() && S.artTab === 'logo' && S.tpl.id && S.tpl.id !== 'scratch'
      ? (tplById(S.tpl.id) || {}).name : null,
    // Sublimation logo tab: the background under the pieces, for the staff notes.
    wrapBackground: bgActive() ? {
      kind: S.wrapBg.kind,
      name: (WRAP_BGS.find(k => k.id === S.wrapBg.kind) || {}).name,
      color: S.wrapBg.kind === 'repeat' ? null : S.wrapBg.color,
    } : null,
    size: S.variant.size,
    color: S.variant.color,
    quantity: S.qty,
    printArea: {w: areaW(), h: areaH()},
    /* One entry per layer, in the order they stack. Enough for staff to answer a
       question about the order, or rebuild it, without reopening the design. */
    layers: useLayers() ? inked().map(l => ({
      kind: l.kind,
      side: sideOf(l),
      label: layerLabel(l),
      x: +l.x.toFixed(4), y: +l.y.toFixed(4), size: +l.s.toFixed(4),
      rot: l.rot || 0, flip: !!l.flip,
      printedPx: printedPx(l),
      ...(l.kind === 'img'
          ? {name: l.name, uploadedPx: {w: l.ow, h: l.oh}, cleanup: l.fx}
          : {}),
      ...(l.kind === 'text' ? {text: l.text, font: l.font, color: l.color,
                               curve: l.curve || 0} : {}),
      ...(l.kind === 'monogram' ? {letters: l.letters, font: l.font, color: l.color} : {}),
      ...(l.kind === 'jersey' ? {name: l.name, number: l.number, color: l.color} : {}),
      ...(l.kind === 'photo' ? {name: l.photo ? l.photo.name : null, frame: l.frame,
                                uploadedPx: l.photo ? {w: l.photo.w, h: l.photo.h} : null} : {}),
    })) : null,
    // The customers' own files, before the in-browser cleanup — the print file already
    // carries the cleaned versions, and these are what staff rebuild from. Added (shrunk to
    // a sensible size) by addToCart() as `artworkAll`; listed here as sources only.
    artworkSources: !useLayers()
      ? (S.art ? [S.art.orig || S.art.src] : [])
      : printing().filter(l => !isEmptySpot(l) && (l.kind === 'img' || l.kind === 'photo'))
          .map(l => l.kind === 'photo' ? l.photo.src : (l.orig || l.src)),
    artworkName: !useLayers()
      ? (S.art ? S.art.name : null)
      : (printing().filter(l => l.kind === 'img').map(l => l.name)[0] || null),
    // No `src` here: the bottom panel is posted as its own rendered print file, so
    // repeating the image in this JSON would only double the request size.
    bottomBand: bandOn(),
    bottomWrap: S.artB ? {name: S.artB.name, generated: !!S.artB.genKey,
                          w: z.bottomW, h: z.bottomH} : null,
    /* Only the session id. Whether it generated anything, whether it took the package and
       what that was priced at are all read server-side off that row — sending the fee from
       here would let the invoice be set by the browser. */
    ai: {sessionId: aiSession()},
  };
}


/* ---------- rendering the finished design ----------
   The mockup and the print file are both drawn here, in the browser, from the
   exact same numbers the stage on step 3 draws from — so what the customer
   approved is literally what gets filed against the order. The portal only
   validates the two PNGs and stores them; it never re-derives this geometry,
   which would be a second copy of the same math free to drift from this one.

   The stage renders the product photo at a fixed 412px tall (.mock > img.base),
   so that number converts a font size chosen on screen into the right size on a
   canvas of any resolution — see the `k` factor below. */
const STAGE_IMG_H = 412;
const REM = () => parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;

function loadImg(src){
  return new Promise((res, rej) => {
    const i = new Image();
    // The product photos come from Cloudinary; without this the canvas is
    // tainted and toDataURL() throws instead of returning the render.
    i.crossOrigin = 'anonymous';
    i.onload = () => res(i);
    i.onerror = () => rej(new Error('image load failed'));
    i.src = src;
  });
}

/* The whole UV stack into a boxW x boxH box at the current canvas origin.

   One function for both renders — the print file's box *is* the print area, and
   the mockup's box is where that area sits on the photo — so the two cannot show
   different arrangements. `imgs` is the layer bitmaps already decoded, keyed by
   layer id, because this has to be synchronous to be shared. */
function drawLayers(c, boxW, boxH, imgs, list, wrapX){
  // On a wrap each piece is also drawn one wrap-width either side, so one crossing the
  // seam continues on the opposite edge instead of being cut off there.
  const offs = wrapX ? [-1, 0, 1] : [0];
  list.forEach(l => offs.forEach(d => {
    const img = imgs[l.id];
    if (!img) return;
    const b = layerBox(l);
    const aw = boxW * b.w, ah = boxH * b.h;
    c.save();
    c.translate((l.x + d) * boxW, l.y * boxH);
    // Rotate before mirroring: the other order turns the layer the wrong way on a
    // flipped piece, and the mockup and print file would still agree with each
    // other while both disagreeing with the stage.
    if (l.rot) c.rotate(l.rot * Math.PI / 180);
    if (l.flip) c.scale(-1, 1);
    c.drawImage(img, -aw/2, -ah/2, aw, ah);
    c.restore();
  }));
}

/* Decodes every layer's bitmap once, so both renders draw from the same images. */
async function layerImages(){
  const out = {};
  for (const l of inked()) if (l.src) out[l.id] = await loadImg(l.src);
  return out;
}

/* Artwork alone, on transparency, at the exact size it prints. */
async function renderPrint(side){
  const list = sideLayers(side || 'front');
  const w = areaW(), h = areaH();
  const cv = document.createElement('canvas');
  cv.width = w; cv.height = h;
  const c = cv.getContext('2d');
  if (isSub()){
    /* The whole wrap at 1:1 — exactly what the sandbox shows flat, with nothing bent:
       bending round the body is the mockup's job only. A sandbox design is white with the
       pieces on it (wrapping across the seam); Pet Templates is its generated scene,
       already fitted to exactly areaW x areaH.

       JPEG, not PNG: a wrap is opaque edge to edge, so there is no alpha to keep, and a
       photographic 3,744 x 1,594 wrap is ~12 MB as PNG — over Cloudinary's 10 MB cap, so
       it used to be generated, validated and then silently dropped. */
    let k = 0;
    if (sandboxMode()){
      c.fillStyle = '#FFFFFF'; c.fillRect(0, 0, w, h);
      if (bgActive()){
        const bgm = await bgImageMap();
        const bg = wrapBgCanvas(src => bgm[src]);
        if (bg) c.drawImage(bg, 0, 0, w, h);
      }
      const sl = inked();
      drawLayers(c, w, h, await layerImages(), sl, wrapsRound());
      k = sl.reduce((m, l) => l.kind === 'img'
        ? Math.max(m, (w * layerBox(l).w) / (l.ow || 1)) : m, 0);
    } else {
      c.drawImage(await loadImg(S.art.src), 0, 0, w, h);
      k = w / (S.art.ow || w);
    }
    if (k >= SHARPEN_MIN) unsharp(cv, k * 0.6, 0.8);
    return cv.toDataURL('image/jpeg', 0.95);
  }
  drawLayers(c, w, h, await layerImages(), list);
  /* Sharpened on the most-enlarged image layer's terms. Baked text is drawn at
     BAKE_PX and is never the thing being enlarged, so it doesn't get a vote —
     sharpening the composite for its sake would only crisp the logo's edges past
     what the file supports. */
  const k = list.reduce((m, l) => l.kind === 'img'
    ? Math.max(m, (areaW() * layerBox(l).w) / (l.ow || 1)) : m, 0);
  if (k >= SHARPEN_MIN) unsharp(cv, k * 0.6, 0.8);
  return cv.toDataURL('image/png');
}

/* UV: every design on its own, for the printer — one file per logo, line of text or
   monogram, at exactly the size it prints (the print area's own pixels), on transparency,
   cropped to itself. The side print files still go too (they're what the mockup and the
   staff notes describe); these are what staff download and print from. */
async function renderPieces(){
  if (!uvSides()) return [];
  const w = areaW(), h = areaH(), imgs = await layerImages(), out = [];
  for (const l of inked()){
    const cv = document.createElement('canvas'); cv.width = w; cv.height = h;
    drawLayers(cv.getContext('2d'), w, h, imgs, [l]);
    const k = l.kind === 'img' ? (w * layerBox(l).w) / (l.ow || 1) : 0;
    if (k >= SHARPEN_MIN) unsharp(cv, k * 0.6, 0.8);
    const t = trimCanvas(cv);
    out.push({side: sideOf(l), kind: l.kind, label: layerLabel(l), png: t.toDataURL('image/png')});
  }
  return out;
}

/* The tapered bodies' second panel — already generated (or uploaded) at its
   exact required size, so this only re-encodes it as its own print file. */
async function renderBottomPrint(){
  const z = sizeSpec();
  if (!S.artB || !z.bottomW) return null;
  const cv = document.createElement('canvas');
  cv.width = z.bottomW; cv.height = z.bottomH;
  cv.getContext('2d').drawImage(await loadImg(S.artB.src), 0, 0, z.bottomW, z.bottomH);
  return cv.toDataURL('image/jpeg', 0.95);   // opaque band, same reasoning as the main wrap
}

/* The product shot with the design on it — what the customer just approved, and
   what staff and the packing slip show. JPEG, not PNG: there's no transparency
   to keep and it goes in the request body. */
/* One tumbler onto an existing context at (ox, oy), scaled to w x h. */
async function paintMock(c, base, art, view, ox, oy, w, h){
  const a = area();
  const cut = isSub() ? handleCut(view) : null;
  if (cut){
    c.save();
    handleClipPath(c, cut, ox, oy, w, h); c.clip();
    c.drawImage(base, ox, oy, w, h);
    c.restore();
  } else if (view.flip){
    // Mirror only the photo, drawn about its own centre — the artwork below is
    // laid in unmirrored, same reasoning as mockView().
    c.save();
    c.translate(ox + w, oy); c.scale(-1, 1);
    c.drawImage(base, 0, 0, w, h);
    c.restore();
  } else {
    c.drawImage(base, ox, oy, w, h);
  }
  const cx = view.flip ? 1 - a.x : a.x;
  const bx = ox + (cx - a.w/2) * w, by = oy + (a.y - a.h/2) * h,
        bw = a.w * w, bh = a.h * h;
  c.save();
  c.beginPath(); c.rect(bx, by, bw, bh); c.clip();      // matches .clip's overflow:hidden
  if (isSub()){
    // `art` is the flat wrap here: bent round the body exactly as the stage's view is, and
    // multiplied onto the photo like the stage's canvas (mix-blend-mode) — ink on a white
    // body, so the photo's own edges and shading carry through and white stays the photo.
    c.globalCompositeOperation = 'multiply';
    c.drawImage(bodyCanvas(art.flat, art.band, view.c, Math.round(bw), Math.round(bh), base, view.flip),
                bx, by, bw, bh);
    c.restore();
    shadeCylinder(c, bx, by, bw, bh);
    return;
  }
  c.translate(bx, by);
  drawLayers(c, bw, bh, art, sideLayers(view.side || 'front'));
  c.restore();
}

/* The product shot with the design on it — what the customer just approved, and
   what staff and the packing slip show. A wrap is filed as the same three views the
   customer checked it on, side by side, so whoever prints it sees the whole
   circumference without opening the print file. JPEG, not PNG: there's no
   transparency to keep and it goes in the request body. */
async function renderMockup(){
  const base = await loadImg(S.variant.img);
  const W = base.naturalWidth, H = base.naturalHeight;
  let art;
  if (isSub()){
    // One flat render, bent into every view — the same path the stage draws through.
    const imgs = sandboxMode() ? Object.assign(await layerImages(), {bg: await bgImageMap()})
                               : {art: await loadImg(S.art.src)};
    art = {flat: flatWrap(Math.min(areaW(), 2400), imgs),
           band: S.artB ? await loadImg(S.artB.src) : null};
  } else {
    art = await layerImages();
  }
  const views = isSub() ? WRAP_VIEWS.map(vw => ({...vw, flip: wrapViewFlip(vw)}))
              : twoOn() ? sideViews() : [sideViews()[0]];
  const cv = document.createElement('canvas');
  cv.width = W * views.length; cv.height = H;
  const c = cv.getContext('2d');
  c.fillStyle = '#FFFFFF'; c.fillRect(0, 0, cv.width, cv.height);
  for (let i = 0; i < views.length; i++)
    await paintMock(c, base, art, views[i], i * W, 0, W, H);
  return cv.toDataURL('image/jpeg', 0.92);
}


/* ---------- add to cart ----------
   The design goes into the storefront's own cart, as two lines: the tumbler at the same price
   as our main site, and a separate Customization line (DESIGN_STUDIO.md, "Checkout: the Custom
   Shop cart"). So the customer can keep shopping, add more designs, and check out through the
   normal checkout with everything else. The server files the design and decides the variant
   IDs; this only renders the files and hands the lines to /cart/add.js (same origin — the
   Studio page is on the store). A cart guard in the theme keeps the two quantities together. */
async function addToCart(btn){
  const note = document.getElementById('hc-order-note');
  const say = (cls, msg) => { if (note){ note.className = 'note ' + cls; note.textContent = msg; } };
  const label = btn.textContent;
  const fail = msg => { say('bad', msg); btn.disabled = false; btn.textContent = label; };

  btn.disabled = true; btn.textContent = 'Preparing your files…';
  say('ok', 'Rendering your mockup and print file…');
  let body;
  try {
    if (document.fonts && document.fonts.ready) await document.fonts.ready;
    const [mockup, print, printBottom, printBack, pieces] = await Promise.all([
      renderMockup(), renderPrint('front'), renderBottomPrint(),
      twoOn() ? renderPrint('back') : null, renderPieces()]);
    const payload = designPayload();
    const artworkAll = await Promise.all((payload.artworkSources || []).map(originalForUpload));
    delete payload.artworkSources;
    body = Object.assign(payload, {
      artworkAll: artworkAll.filter(Boolean),
      renders: {mockup, print, printBottom, printBack, pieces},
      // A logged-in customer's id, when the theme provides it (window.HOGG_CUSTOMER_ID), so a
      // design left in a cart can be tied to someone. Guests stay anonymous.
      customerId: window.HOGG_CUSTOMER_ID || null,
    });
  } catch (err){
    console.error('[customizer]', err);
    fail('We could not prepare your design files. Please refresh and try again.');
    return;
  }

  btn.textContent = 'Saving your design…';
  let saved;
  try {
    const r = await fetch(API + '/api/customizer/designs', {
      method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)});
    saved = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(saved.error || ('design ' + r.status));
  } catch (err){
    console.error('[customizer]', err);
    fail(String(err.message || err));
    return;
  }

  btn.textContent = 'Adding to your cart…';
  try {
    await numberDesigns(saved.items[0]);
    const r = await fetch('/cart/add.js', {
      method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({items: saved.items})});
    if (!r.ok){
      const e = await r.json().catch(() => ({}));
      throw new Error(e.description || e.message || ('cart ' + r.status));
    }
  } catch (err){
    console.error('[customizer]', err);
    fail('Your design is saved (' + saved.ref + ') but we couldn’t add it to your cart: ' +
         (err.message || err) + '. Please try again.');
    return;
  }
  await clearDraft();                        // it lives in the cart now
  // Straight on to the cart: adding it is the last thing they came here to do, so a second
  // "View cart" click would only be in the way.
  btn.textContent = 'Added — opening your cart…';
  say('ok', 'Your design is in your cart.');
  window.location.href = '/cart';
}

/* A customer's original file, as it's sent with the design: as uploaded when it's already a
   sensible size, otherwise shrunk to 3,000px on the long side — still more than any wrap
   prints at (the largest is 3,744 × 1,594) — as JPEG, or PNG where it has transparency.
   A phone photo goes from ~8 MB of base64 to ~1 MB; sending them full size was most of what
   made Add to cart slow. */
const ORIGINAL_MAX_PX = 3000, ORIGINAL_MAX_CHARS = 2.5e6;
async function originalForUpload(src){
  if (!src) return null;
  try {
    const im = await loadImg(src);
    const w = im.naturalWidth, h = im.naturalHeight, k = Math.min(1, ORIGINAL_MAX_PX / Math.max(w, h));
    if (k === 1 && src.length <= ORIGINAL_MAX_CHARS) return src;
    const cv = document.createElement('canvas');
    cv.width = Math.round(w * k); cv.height = Math.round(h * k);
    const c = cv.getContext('2d');
    c.imageSmoothingEnabled = true; c.imageSmoothingQuality = 'high';
    c.drawImage(im, 0, 0, cv.width, cv.height);
    return /^data:image\/png/i.test(src) ? cv.toDataURL('image/png') : cv.toDataURL('image/jpeg', 0.9);
  } catch (e) { return src.length <= ORIGINAL_MAX_CHARS ? src : null; }
}

/* Two designs on the same product are two cart lines with the same name, which reads as a
   mistake. When this design joins another of the same product, each gets a design number —
   the existing one is numbered 1 if it isn't yet, and this one takes the next. It's the hidden
   `_design_no`: the theme's cart and drawer show it as "<product> — Design N", and so does
   checkout (the cart transform). A lone design stays unnumbered. Best-effort: a failure here
   never stops the add. */
async function numberDesigns(item){
  try {
    const cart = await fetch('/cart.js', {headers: {'Accept': 'application/json'}}).then(r => r.json());
    const same = (cart.items || []).filter(it => it.variant_id === item.id &&
      it.properties && it.properties._design_ref && !it.properties._ai_package);
    if (!same.length) return;
    const numberOf = p => parseInt(p._design_no || p.Design, 10);   // `Design`: older carts
    let top = 0;
    for (let i = 0; i < same.length; i++){
      const it = same[i], n = numberOf(it.properties);
      if (n){ top = Math.max(top, n); continue; }
      top = Math.max(top, i + 1);
      await fetch('/cart/change.js', {method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({id: it.key, quantity: it.quantity,
                              properties: Object.assign({}, it.properties, {_design_no: String(i + 1)})})});
    }
    item.properties = Object.assign({}, item.properties, {_design_no: String(top + 1)});
  } catch (e) { console.warn('[customizer] design numbering', e); }
}

  // ---- boot ---------------------------------------------------------------
  fetch(API + '/api/customizer/catalog', { headers: { 'Accept': 'application/json' } })
    .then(function (r) {
      if (!r.ok) throw new Error('catalog ' + r.status);
      return r.json();
    })
    .then(function (data) {
      CATALOG = data.products || [];
      if (typeof data.bottomBandPrice === 'number') BAND_PRICE = data.bottomBandPrice;
      if (typeof data.extraPiecePrice === 'number') EXTRA_PRICE = data.extraPiecePrice;
      if (data.methodImages) METHOD_IMAGES = data.methodImages;
      if (data.petTemplates) PET_TEMPLATES = data.petTemplates;
      if (!CATALOG.length) throw new Error('catalog is empty');
      try { history.replaceState({hcStep: S.step}, ''); } catch (e) {}
      const linked = linkedProduct();
      if (!linked){
        render();
        loadDraft().then(d => { if (d && S.step === 1){ S.draft = d; render(true); } });
        return;
      }
      /* Opening the design step saves its (empty) design over any draft in progress, so a
         returning customer with one gets the usual start and its "Continue your design?"
         offer instead. The page keeps its "Loading" line until this is decided. */
      loadDraft().then(d => {
        if (d){ S.draft = d; render(); return; }
        S.method = linked.method; pickProduct(linked);
      });
    })
    .catch(function (err) {
      console.error('[customizer]', err);
      document.getElementById('hc-app').innerHTML =
        '<div class="empty">We could not load the product list just now. ' +
        'Please refresh, or <a href="/pages/custom-quote">request a quote</a> instead.</div>';
    });
})();
